import React, { useRef, useEffect, useState, useMemo, Fragment as Fragment$1, useCallback, useReducer } from 'react';
import { withRouter, Link, useLocation, Route, Redirect, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { createStaticRanges, DateRangePicker } from 'react-date-range';
import { Loader as Loader$1 } from '@googlemaps/js-api-loader';
import { useTable, useGlobalFilter, useSortBy, usePagination, useRowSelect } from 'react-table';
import { useForm, Controller, FormProvider } from 'react-hook-form';

const ActionBar = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: `action-bar-wrap ${props.className}`,
    style: props.style
  }, props.children);
};

const ActionLinks = props => /*#__PURE__*/React.createElement("span", {
  className: "action-link"
}, props.children);

const AppContainer = props => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "app-container",
    style: props.style
  }, props.children));
};

const ApplyFilterBar = props => {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: props.submit ? "submit" : "button",
    style: {
      ...props.style
    },
    className: "button-clear",
    onClick: props.onClear
  }, /*#__PURE__*/React.createElement("header", null, props.labelLink)), /*#__PURE__*/React.createElement("button", {
    className: "submit-bar",
    type: props.submit ? "submit" : "button",
    style: {
      ...props.style
    },
    onClick: props.onSubmit
  }, /*#__PURE__*/React.createElement("header", null, props.buttonLink)));
};

const ArrowLeft = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "black",
  className: className,
  width: "19px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0v24H0V0h24z",
  fill: "none",
  opacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 7l-5 5 5 5V7z"
}));
const ArrowLeftWhite = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  className: className,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z",
  fill: "white"
}));
const ArrowDown = ({
  className,
  onClick,
  styles,
  disable
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    ...styles
  },
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: disable ? "#9E9E9E" : "black",
  className: className,
  onClick: onClick,
  width: "18px",
  height: "18px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 10l5 5 5-5H7z"
}));
const ArrowBack = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "black",
  className: className,
  onClick: onClick,
  width: "18px",
  height: "18px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}));
const ArrowForward = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "black",
  className: className,
  onClick: onClick,
  width: "18px",
  height: "18px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}));
const ArrowToFirst = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  width: "18px",
  height: "18px",
  viewBox: "0 0 13 12",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg",
  className: className,
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.41 10.59L7.82 6L12.41 1.41L11 0L5 6L11 12L12.41 10.59ZM0 0H2V12H0V0Z",
  fill: "#505a5f"
}));
const ArrowToLast = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  width: "18px",
  height: "18px",
  viewBox: "0 0 13 12",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg",
  className: className,
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.589844 1.41L5.17984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0L0.589844 1.41ZM10.9998 0H12.9998V12H10.9998V0Z",
  fill: "#505a5f"
}));
const DownloadPrefixIcon = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
}));
const CameraSvg = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  enableBackground: "new 0 0 24 24",
  className: className,
  viewBox: "0 0 24 24",
  fill: "black",
  width: "46px",
  height: "42px"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: "24",
  width: "24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3,4V1h2v3h3v2H5v3H3V6H0V4H3z M6,10V7h3V4h7l1.83,2H21c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V10H6z M13,19c2.76,0,5-2.24,5-5s-2.24-5-5-5s-5,2.24-5,5S10.24,19,13,19z M9.8,14c0,1.77,1.43,3.2,3.2,3.2s3.2-1.43,3.2-3.2 s-1.43-3.2-3.2-3.2S9.8,12.23,9.8,14z"
}));
const DeleteBtn = ({
  className,
  onClick,
  fill
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "white",
  className: className,
  onClick: onClick,
  width: "18px",
  height: "18px"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: fill
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
}));
const SuccessSvg = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#00703C",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
}));
const ErrorSvg = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#d4351c",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3h4v12h-4z"
}));
const StarFilled = ({
  className,
  id,
  onClick,
  styles,
  percentage: _percentage = 100
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  enableBackground: "new 0 0 24 24",
  className: className,
  style: styles,
  onClick: onClick,
  viewBox: "0 0 24 24",
  fill: "#1F4A7C",
  width: "48px",
  height: "48px"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: id,
  x1: "0",
  x2: "1",
  y1: "0",
  y2: "0"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#1F4A7C",
  stopOpacity: 1
}), /*#__PURE__*/React.createElement("stop", {
  offset: `${_percentage}%`,
  stopColor: "#1F4A7C",
  stopOpacity: 1
}), /*#__PURE__*/React.createElement("stop", {
  offset: `${_percentage}%`,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0h24v24H0V0z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z",
  fill: `url(#${id})`,
  stroke: "#1F4A7C",
  strokeWidth: 1
})));
const StarEmpty = ({
  className,
  onClick,
  styles
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#1F4A7C",
  className: className,
  style: styles,
  width: "48px",
  height: "48px",
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z",
  strokeWidth: 1
}));
const DownloadImgIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z",
  fill: "#1F4A7C"
}));
const PrevIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "8",
  height: "12",
  viewBox: "0 0 8 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.99997 0L0.589966 1.41L5.16997 6L0.589966 10.59L1.99997 12L7.99997 6L1.99997 0Z",
  fill: "#0B0C0C"
}));
const ViewsIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z",
  fill: "#1F4A7C"
}));
const DocumentIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6Z",
  fill: "#1F4A7C"
}));
const DocumentIconSolid = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
}));
const SurveyIconSolid = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z"
}));
const PMBIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "16",
  viewBox: "0 0 32 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 9C18.1733 9 20.0933 9.52 21.6533 10.2C23.0933 10.84 24 12.28 24 13.84V16H8V13.8533C8 12.28 8.90667 10.84 10.3467 10.2133C11.9067 9.52 13.8267 9 16 9ZM5.33333 9.33333C6.8 9.33333 8 8.13333 8 6.66667C8 5.2 6.8 4 5.33333 4C3.86667 4 2.66667 5.2 2.66667 6.66667C2.66667 8.13333 3.86667 9.33333 5.33333 9.33333ZM6.84 10.8C6.34667 10.72 5.85333 10.6667 5.33333 10.6667C4.01333 10.6667 2.76 10.9467 1.62667 11.44C0.64 11.8667 0 12.8267 0 13.9067V16H6V13.8533C6 12.7467 6.30667 11.7067 6.84 10.8ZM26.6667 9.33333C28.1333 9.33333 29.3333 8.13333 29.3333 6.66667C29.3333 5.2 28.1333 4 26.6667 4C25.2 4 24 5.2 24 6.66667C24 8.13333 25.2 9.33333 26.6667 9.33333ZM32 13.9067C32 12.8267 31.36 11.8667 30.3733 11.44C29.24 10.9467 27.9867 10.6667 26.6667 10.6667C26.1467 10.6667 25.6533 10.72 25.16 10.8C25.6933 11.7067 26 12.7467 26 13.8533V16H32V13.9067ZM16 0C18.2133 0 20 1.78667 20 4C20 6.21333 18.2133 8 16 8C13.7867 8 12 6.21333 12 4C12 1.78667 13.7867 0 16 0Z",
  fill: "#1F4A7C"
}));
const PMBIconSolid = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  enableBackground: "new 0 0 24 24",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: "24",
  width: "24"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18,11c0,0.67,0,1.33,0,2c1.2,0,2.76,0,4,0c0-0.67,0-1.33,0-2C20.76,11,19.2,11,18,11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,17.61c0.96,0.71,2.21,1.65,3.2,2.39c0.4-0.53,0.8-1.07,1.2-1.6c-0.99-0.74-2.24-1.68-3.2-2.4 C16.8,16.54,16.4,17.08,16,17.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4,5.6C20,5.07,19.6,4.53,19.2,4c-0.99,0.74-2.24,1.68-3.2,2.4c0.4,0.53,0.8,1.07,1.2,1.6 C18.16,7.28,19.41,6.35,20.4,5.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,9c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h1v4h2v-4h1l5,3V6L8,9H4z M9.03,10.71L11,9.53v4.94l-1.97-1.18L8.55,13H8H4v-2h4 h0.55L9.03,10.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5,12c0-1.33-0.58-2.53-1.5-3.35v6.69C14.92,14.53,15.5,13.33,15.5,12z"
}));
const EventsIconSolid = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-2 5h-5v5h5v-5z"
}));
const DustbinIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z",
  fill: "#1F4A7C"
}));
const ImageIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
}));
const DocumentSVG = () => /*#__PURE__*/React.createElement("svg", {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.6667 6.6665H20C16.3334 6.6665 13.3667 9.6665 13.3667 13.3332L13.3334 66.6665C13.3334 70.3332 16.3 73.3332 19.9667 73.3332H60C63.6667 73.3332 66.6667 70.3332 66.6667 66.6665V26.6665L46.6667 6.6665ZM53.3334 59.9998H26.6667V53.3332H53.3334V59.9998ZM53.3334 46.6665H26.6667V39.9998H53.3334V46.6665ZM43.3334 29.9998V11.6665L61.6667 29.9998H43.3334Z",
  fill: "#505A5F"
}));
const PDFSvg = ({
  className,
  width: _width = 80,
  height: _height = 80,
  style: _style = {
    background: "#f6f6f6",
    padding: "8px",
    boxShadow: "0px 2px 0px #d6d5d3",
    borderRadius: "2px"
  },
  viewBox: _viewBox = "0 0 80 80"
}) => /*#__PURE__*/React.createElement("svg", Object.assign({}, {
  className,
  width: _width,
  height: _height,
  style: _style,
  viewBox: _viewBox
}, {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.6667 6.6665H20C16.3334 6.6665 13.3667 9.6665 13.3667 13.3332L13.3334 66.6665C13.3334 70.3332 16.3 73.3332 19.9667 73.3332H60C63.6667 73.3332 66.6667 70.3332 66.6667 66.6665V26.6665L46.6667 6.6665ZM53.3334 59.9998H26.6667V53.3332H53.3334V59.9998ZM53.3334 46.6665H26.6667V39.9998H53.3334V46.6665ZM43.3334 29.9998V11.6665L61.6667 29.9998H43.3334Z",
  fill: "#505A5F"
}));
const SearchIconSvg = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#1F4A7C",
  className: className,
  width: "24px",
  height: "24px",
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}));
const CheckSvg = ({
  className,
  style: _style2 = {}
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#1F4A7C",
  className: className,
  style: _style2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
}));
const RoundedCheck = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"
}));
const Calender = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "black",
  className: className,
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
}));
const Phone = ({
  className,
  fillcolor,
  style
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: fillcolor ? fillcolor : "#1F4A7C",
  viewBox: "0 0 24 24",
  style: style ? style : {},
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}));
const FilterSvg = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#1F4A7C",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}));
const SortSvg = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 16H24V13.3333H8V16ZM0 0V2.66667H24V0H0ZM8 9.33333H24V6.66667H8V9.33333Z",
  fill: "#505A5F"
}));
const Close = ({
  className,
  style
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    ...style
  },
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  width: "24",
  height: "24",
  fill: "#9E9E9E",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}));
const GetApp = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#1F4A7C",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}));
const HamburgerIcon = ({
  className,
  styles,
  color: _color = "#fdfdfd"
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    ...styles
  },
  width: "24",
  height: "24",
  focusable: "false",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
  fill: _color
}));
const HomeIcon = ({
  className,
  styles
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  viewBox: "0 0 24 24",
  style: {
    ...styles
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}));
const LanguageIcon = ({
  className,
  styles
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  viewBox: "0 0 24 24",
  style: {
    ...styles
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
}));
const LogoutIcon = ({
  className,
  styles
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  viewBox: "0 0 24 24",
  style: {
    ...styles
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
}));
const CalendarIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({}, props, {
  fill: props.isdisabled ? "#e3e3e3" : "Black",
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
}));
const SortDown = style => /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline-block",
    height: "16px",
    ...style
  },
  xmlns: "http://www.w3.org/2000/svg",
  enableBackground: "new 0 0 24 24",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: "24",
  width: "24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,15l-1.41-1.41L13,18.17V2H11v16.17l-4.59-4.59L5,15l7,7L19,15z"
}));
const SortUp = style => /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline-block",
    height: "16px",
    ...style
  },
  xmlns: "http://www.w3.org/2000/svg",
  enableBackground: "new 0 0 24 24",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  height: "24",
  width: "24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z"
}));
const ArrowRightInbox = ({
  style
}) => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: style
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 0L11.59 1.41L16.17 6H0V8H16.17L11.58 12.59L13 14L20 7L13 0Z",
  fill: "#1F4A7C"
}));
const ShippingTruck = style => /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline-block",
    fontSize: "16px",
    ...style
  },
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}));
function CloseSvg({
  onClick
}) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }));
}
const UpwardArrow = ({
  color: _color2 = "#00703C",
  rotate: _rotate = 0,
  marginRight: _marginRight = 0
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline-block",
    verticalAlign: "baseline",
    transform: `rotate(${_rotate}deg)`,
    marginRight: `${_marginRight}px`
  },
  width: "11",
  height: "16",
  viewBox: "0 0 11 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 5.6L1.10786 6.728L4.71429 3.064V16H6.28571V3.064L9.89214 6.736L11 5.6L5.5 0L0 5.6Z",
  fill: _color2
}));
const DownwardArrow = props => /*#__PURE__*/React.createElement(UpwardArrow, Object.assign({}, props, {
  color: "#e54d42",
  rotate: 180
}));
const DownloadIcon = ({
  styles,
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    ...styles
  },
  width: "19",
  height: "24",
  viewBox: "0 0 19 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className,
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.8337 8.5H13.5003V0.5H5.50033V8.5H0.166992L9.50033 17.8333L18.8337 8.5ZM0.166992 20.5V23.1667H18.8337V20.5H0.166992Z",
  fill: "#505A5F"
}));
const GenericFileIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "80",
  height: "100",
  viewBox: "0 0 80 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 0H10C4.5 0 0.0500011 4.5 0.0500011 10L0 90C0 95.5 4.45 100 9.95 100H70C75.5 100 80 95.5 80 90V30L50 0ZM60 80H20V70H60V80ZM60 60H20V50H60V60ZM45 35V7.5L72.5 35H45Z",
  fill: "#505A5F"
}));
const ExternalLinkIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 16H2V2H9V0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z",
  fill: "#1F4A7C"
}));
const Ellipsis = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  width: "4",
  height: "16",
  viewBox: "0 0 4 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: className,
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z",
  fill: "#B1B4B6"
}));
const Poll = () => /*#__PURE__*/React.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V34C40 37.3137 37.3137 40 34 40H6C2.68629 40 0 37.3137 0 34V6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.6667 5H8.33333C6.5 5 5 6.5 5 8.33333V31.6667C5 33.5 6.5 35 8.33333 35H31.6667C33.5 35 35 33.5 35 31.6667V8.33333C35 6.5 33.5 5 31.6667 5ZM15 28.3333H11.6667V16.6667H15V28.3333ZM21.6667 28.3333H18.3333V11.6667H21.6667V28.3333ZM28.3333 28.3333H25V21.6667H28.3333V28.3333Z",
  fill: "#1F4A7C"
}));
const Details = () => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z",
  fill: "#505A5F"
}));
const FilterIcon = ({
  onClick
}) => /*#__PURE__*/React.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  onClick: onClick
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.666904 2.48016C3.36024 5.9335 8.33357 12.3335 8.33357 12.3335V20.3335C8.33357 21.0668 8.93357 21.6668 9.6669 21.6668H12.3336C13.0669 21.6668 13.6669 21.0668 13.6669 20.3335V12.3335C13.6669 12.3335 18.6269 5.9335 21.3202 2.48016C22.0002 1.60016 21.3736 0.333496 20.2669 0.333496H1.72024C0.613571 0.333496 -0.0130959 1.60016 0.666904 2.48016Z",
  fill: "#505A5F"
}));
const RefreshIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "22",
  viewBox: "0 0 16 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 5V8L12 4L8 0V3C3.58 3 0 6.58 0 11C0 12.57 0.46 14.03 1.24 15.26L2.7 13.8C2.25 12.97 2 12.01 2 11C2 7.69 4.69 5 8 5ZM14.76 6.74L13.3 8.2C13.74 9.04 14 9.99 14 11C14 14.31 11.31 17 8 17V14L4 18L8 22V19C12.42 19 16 15.42 16 11C16 9.43 15.54 7.97 14.76 6.74Z",
  fill: "#0B0C0C"
}));
const RefreshSVG = () => /*#__PURE__*/React.createElement("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 16 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 5V8L12 4L8 0V3C3.58 3 0 6.58 0 11C0 12.57 0.46 14.03 1.24 15.26L2.7 13.8C2.25 12.97 2 12.01 2 11C2 7.69 4.69 5 8 5ZM14.76 6.74L13.3 8.2C13.74 9.04 14 9.99 14 11C14 14.31 11.31 17 8 17V14L4 18L8 22V19C12.42 19 16 15.42 16 11C16 9.43 15.54 7.97 14.76 6.74Z",
  fill: "#505A5F"
}));
const PrintIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 5H3C1.34 5 0 6.34 0 8V14H4V18H16V14H20V8C20 6.34 18.66 5 17 5ZM14 16H6V11H14V16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM16 0H4V4H16V0Z",
  fill: "#505A5F"
}));
function PropertyHouse(style) {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      display: "inline-block",
      fontSize: "16px",
      ...style
    },
    width: "24",
    height: "24",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6167 9.5L1.66667 17.4667V35H10V21.6667H16.6667V35H25V17.0833L13.6167 9.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5V7.51667L20 9.73333L22.8833 11.6667H25V13.0833L28.3333 15.3167V18.3333H31.6667V21.6667H28.3333V25H31.6667V28.3333H28.3333V35H38.3333V5H16.6667ZM31.6667 15H28.3333V11.6667H31.6667V15Z",
    fill: "white"
  }));
}
const InfoBannerIcon = ({
  fill: _fill = "#3498DB"
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z",
    fill: _fill
  }));
};
const ShareIcon = ({
  styles,
  className
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    ...styles
  },
  className: className,
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 14.08C14.24 14.08 13.56 14.38 13.04 14.85L5.91 10.7C5.96 10.47 6 10.24 6 10C6 9.76 5.96 9.53 5.91 9.3L12.96 5.19C13.5 5.69 14.21 6 15 6C16.66 6 18 4.66 18 3C18 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 3.24 12.04 3.47 12.09 3.7L5.04 7.81C4.5 7.31 3.79 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C3.79 13 4.5 12.69 5.04 12.19L12.16 16.35C12.11 16.56 12.08 16.78 12.08 17C12.08 18.61 13.39 19.92 15 19.92C16.61 19.92 17.92 18.61 17.92 17C17.92 15.39 16.61 14.08 15 14.08Z",
  fill: "#505A5F"
}));
const RupeeIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "48",
  className: className,
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  width: "48",
  height: "48",
  rx: "6",
  fill: "#1F4A7C"
}));
const ComplaintIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "48",
  height: "48",
  className: className,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.6667 0.666748H5.33335C2.76669 0.666748 0.69002 2.76675 0.69002 5.33342L0.666687 47.3334L10 38.0001H42.6667C45.2334 38.0001 47.3334 35.9001 47.3334 33.3334V5.33342C47.3334 2.76675 45.2334 0.666748 42.6667 0.666748ZM26.3334 21.6667H21.6667V7.66675H26.3334V21.6667ZM26.3334 31.0001H21.6667V26.3334H26.3334V31.0001Z",
  fill: "#1F4A7C"
}));
const DropIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "28",
  height: "34",
  viewBox: "0 0 28 34",
  className: className,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.4333 10.3332L14 0.916504L4.56663 10.3332C1.96663 12.9332 0.666626 16.3998 0.666626 19.7332C0.666626 23.0665 1.96663 26.5832 4.56663 29.1832C7.16663 31.7832 10.5833 33.0998 14 33.0998C17.4166 33.0998 20.8333 31.7832 23.4333 29.1832C26.0333 26.5832 27.3333 23.0665 27.3333 19.7332C27.3333 16.3998 26.0333 12.9332 23.4333 10.3332ZM3.99996 20.3332C4.01663 16.9998 5.03329 14.8832 6.93329 12.9998L14 5.78317L21.0666 13.0832C22.9666 14.9498 23.9833 16.9998 24 20.3332H3.99996Z",
  fill: "#1F4A7C"
}));
const Person = style => /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline-block",
    fontSize: "16px",
    ...style
  },
  width: "24",
  height: "24",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6167 9.5L1.66667 17.4667V35H10V21.6667H16.6667V35H25V17.0833L13.6167 9.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
  fill: "white"
}));
const WhatsappIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.0566406 24L1.74364 17.837C0.702641 16.033 0.155641 13.988 0.156641 11.891C0.159641 5.335 5.49464 0 12.0496 0C15.2306 0.001 18.2166 1.24 20.4626 3.488C22.7076 5.736 23.9436 8.724 23.9426 11.902C23.9396 18.459 18.6046 23.794 12.0496 23.794C10.0596 23.793 8.09864 23.294 6.36164 22.346L0.0566406 24ZM6.65364 20.193C8.32964 21.188 9.92964 21.784 12.0456 21.785C17.4936 21.785 21.9316 17.351 21.9346 11.9C21.9366 6.438 17.5196 2.01 12.0536 2.008C6.60164 2.008 2.16664 6.442 2.16464 11.892C2.16364 14.117 2.81564 15.783 3.91064 17.526L2.91164 21.174L6.65364 20.193ZM18.0406 14.729C17.9666 14.605 17.7686 14.531 17.4706 14.382C17.1736 14.233 15.7126 13.514 15.4396 13.415C15.1676 13.316 14.9696 13.266 14.7706 13.564C14.5726 13.861 14.0026 14.531 13.8296 14.729C13.6566 14.927 13.4826 14.952 13.1856 14.803C12.8886 14.654 11.9306 14.341 10.7956 13.328C9.91264 12.54 9.31564 11.567 9.14264 11.269C8.96964 10.972 9.12464 10.811 9.27264 10.663C9.40664 10.53 9.56964 10.316 9.71864 10.142C9.86964 9.97 9.91864 9.846 10.0186 9.647C10.1176 9.449 10.0686 9.275 9.99364 9.126C9.91864 8.978 9.32464 7.515 9.07764 6.92C8.83564 6.341 8.59064 6.419 8.40864 6.41L7.83864 6.4C7.64064 6.4 7.31864 6.474 7.04664 6.772C6.77464 7.07 6.00664 7.788 6.00664 9.251C6.00664 10.714 7.07164 12.127 7.21964 12.325C7.36864 12.523 9.31464 15.525 12.2956 16.812C13.0046 17.118 13.5586 17.301 13.9896 17.438C14.7016 17.664 15.3496 17.632 15.8616 17.556C16.4326 17.471 17.6196 16.837 17.8676 16.143C18.1156 15.448 18.1156 14.853 18.0406 14.729Z",
  fill: "#1F4A7C"
}));
const EmailIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z",
  fill: "#1F4A7C"
}));
const CaseIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "24",
  height: "24",
  viewBox: "0 0 34 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.3333 6.99967H23.6667V3.66634C23.6667 1.81634 22.1833 0.333008 20.3333 0.333008H13.6667C11.8167 0.333008 10.3333 1.81634 10.3333 3.66634V6.99967H3.66667C1.81667 6.99967 0.350001 8.48301 0.350001 10.333L0.333334 28.6663C0.333334 30.5163 1.81667 31.9997 3.66667 31.9997H30.3333C32.1833 31.9997 33.6667 30.5163 33.6667 28.6663V10.333C33.6667 8.48301 32.1833 6.99967 30.3333 6.99967ZM20.3333 6.99967H13.6667V3.66634H20.3333V6.99967Z",
  fill: "white"
}));
const PersonIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 38 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.6667 10.3333C28.4334 10.3333 30.65 8.1 30.65 5.33333C30.65 2.56666 28.4334 0.333328 25.6667 0.333328C22.9 0.333328 20.6667 2.56666 20.6667 5.33333C20.6667 8.1 22.9 10.3333 25.6667 10.3333ZM12.3334 10.3333C15.1 10.3333 17.3167 8.1 17.3167 5.33333C17.3167 2.56666 15.1 0.333328 12.3334 0.333328C9.56669 0.333328 7.33335 2.56666 7.33335 5.33333C7.33335 8.1 9.56669 10.3333 12.3334 10.3333ZM12.3334 13.6667C8.45002 13.6667 0.666687 15.6167 0.666687 19.5V23.6667H24V19.5C24 15.6167 16.2167 13.6667 12.3334 13.6667ZM25.6667 13.6667C25.1834 13.6667 24.6334 13.7 24.05 13.75C25.9834 15.15 27.3334 17.0333 27.3334 19.5V23.6667H37.3334V19.5C37.3334 15.6167 29.55 13.6667 25.6667 13.6667Z",
  fill: "white"
}));
const ReceiptIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z",
  fill: "white"
}));
const AnnouncementIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.6665 0.666016H3.33317C1.8665 0.666016 0.679837 1.86602 0.679837 3.33268L0.666504 27.3327L5.99984 21.9993H24.6665C26.1332 21.9993 27.3332 20.7993 27.3332 19.3327V3.33268C27.3332 1.86602 26.1332 0.666016 24.6665 0.666016ZM15.3332 12.666H12.6665V4.66602H15.3332V12.666ZM15.3332 17.9993H12.6665V15.3327H15.3332V17.9993Z",
  fill: "#1F4A7C"
}));
const PTIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "34",
  height: "30",
  viewBox: "0 0 34 30",
  fill: "none",
  className: className,
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.9999 6.66667V0H0.333252V30H33.6666V6.66667H16.9999ZM6.99992 26.6667H3.66659V23.3333H6.99992V26.6667ZM6.99992 20H3.66659V16.6667H6.99992V20ZM6.99992 13.3333H3.66659V10H6.99992V13.3333ZM6.99992 6.66667H3.66659V3.33333H6.99992V6.66667ZM13.6666 26.6667H10.3333V23.3333H13.6666V26.6667ZM13.6666 20H10.3333V16.6667H13.6666V20ZM13.6666 13.3333H10.3333V10H13.6666V13.3333ZM13.6666 6.66667H10.3333V3.33333H13.6666V6.66667ZM30.3333 26.6667H16.9999V23.3333H20.3333V20H16.9999V16.6667H20.3333V13.3333H16.9999V10H30.3333V26.6667ZM26.9999 13.3333H23.6666V16.6667H26.9999V13.3333ZM26.9999 20H23.6666V23.3333H26.9999V20Z",
  fill: "#FFF"
}));
const OBPSIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "34",
  height: "30",
  viewBox: "0 0 34 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.3333 0H3.66659C1.83325 0 0.333252 1.5 0.333252 3.33333V26.6667C0.333252 28.5 1.83325 30 3.66659 30H30.3333C32.1666 30 33.6666 28.5 33.6666 26.6667V3.33333C33.6666 1.5 32.1666 0 30.3333 0ZM13.6666 23.3333H5.33325V20H13.6666V23.3333ZM13.6666 16.6667H5.33325V13.3333H13.6666V16.6667ZM13.6666 10H5.33325V6.66667H13.6666V10ZM21.6999 20L16.9999 15.2667L19.3499 12.9167L21.6999 15.2833L26.9833 10L29.3499 12.3667L21.6999 20Z",
  fill: "#1F4A7C"
}));
const OBPSIconSolidBg = () => /*#__PURE__*/React.createElement("svg", {
  width: "34",
  height: "30",
  viewBox: "0 0 34 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.333 0H3.66634C1.83301 0 0.333008 1.5 0.333008 3.33333V26.6667C0.333008 28.5 1.83301 30 3.66634 30H30.333C32.1663 30 33.6663 28.5 33.6663 26.6667V3.33333C33.6663 1.5 32.1663 0 30.333 0ZM13.6663 23.3333H5.33301V20H13.6663V23.3333ZM13.6663 16.6667H5.33301V13.3333H13.6663V16.6667ZM13.6663 10H5.33301V6.66667H13.6663V10ZM21.6997 20L16.9997 15.2667L19.3497 12.9167L21.6997 15.2833L26.983 10L29.3497 12.3667L21.6997 20Z",
  fill: "#024f9d"
}));
const CitizenTruck = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 23 19",
  className: className,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1F4A7C",
  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
}));
const EDCRIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "32",
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 15.3333V5.33333L15 0.333334L10 5.33333V8.66667H0V32H30V15.3333H20ZM6.66667 28.6667H3.33333V25.3333H6.66667V28.6667ZM6.66667 22H3.33333V18.6667H6.66667V22ZM6.66667 15.3333H3.33333V12H6.66667V15.3333ZM16.6667 28.6667H13.3333V25.3333H16.6667V28.6667ZM16.6667 22H13.3333V18.6667H16.6667V22ZM16.6667 15.3333H13.3333V12H16.6667V15.3333ZM16.6667 8.66667H13.3333V5.33333H16.6667V8.66667ZM26.6667 28.6667H23.3333V25.3333H26.6667V28.6667ZM26.6667 22H23.3333V18.6667H26.6667V22Z",
  fill: "#1F4A7C"
}));
const BPAIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 29.0333H3.33333V8.66667H15V5.33334H3.33333C1.5 5.33334 0 6.83334 0 8.66667V28.6667C0 30.5 1.5 32 3.33333 32H23.3333C25.1667 32 26.6667 30.5 26.6667 28.6667V17H23.3333V29.0333Z",
  fill: "#1F4A7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.6667 0.333336H23.3333V5.33334H18.3333C18.35 5.35 18.3333 8.66667 18.3333 8.66667H23.3333V13.65C23.35 13.6667 26.6667 13.65 26.6667 13.65V8.66667H31.6667V5.33334H26.6667V0.333336Z",
  fill: "#1F4A7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 12H6.66666V15.3333H20V12Z",
  fill: "#1F4A7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.66666 17V20.3333H20V17H15H6.66666Z",
  fill: "#1F4A7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 22H6.66666V25.3333H20V22Z",
  fill: "#1F4A7C"
}));
const BPAHomeIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "34",
  height: "30",
  viewBox: "0 0 34 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.3333 0H3.66659C1.83325 0 0.333252 1.5 0.333252 3.33333V26.6667C0.333252 28.5 1.83325 30 3.66659 30H30.3333C32.1666 30 33.6666 28.5 33.6666 26.6667V3.33333C33.6666 1.5 32.1666 0 30.3333 0ZM13.6666 23.3333H5.33325V20H13.6666V23.3333ZM13.6666 16.6667H5.33325V13.3333H13.6666V16.6667ZM13.6666 10H5.33325V6.66667H13.6666V10ZM21.6999 20L16.9999 15.2667L19.3499 12.9167L21.6999 15.2833L26.9833 10L29.3499 12.3667L21.6999 20Z",
  fill: "white"
}));
const HelpIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "18",
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H22C23.1 18 23.99 17.1 23.99 16L24 2C24 0.9 23.1 0 22 0ZM8 3C9.66 3 11 4.34 11 6C11 7.66 9.66 9 8 9C6.34 9 5 7.66 5 6C5 4.34 6.34 3 8 3ZM14 15H2V14C2 12 6 10.9 8 10.9C10 10.9 14 12 14 14V15ZM17.85 11H19.49L21 13L19.01 14.99C17.7 14.01 16.73 12.61 16.28 11C16.1 10.36 16 9.69 16 9C16 8.31 16.1 7.64 16.28 7C16.73 5.38 17.7 3.99 19.01 3.01L21 5L19.49 7H17.85C17.63 7.63 17.5 8.3 17.5 9C17.5 9.7 17.63 10.37 17.85 11Z",
  fill: "#1F4A7C"
}));
const EventCalendar = () => {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "27",
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 15.0002H12V21.6668H18.6667V15.0002ZM17.3333 0.333496V3.00016H6.66667V0.333496H4V3.00016H2.66667C1.18667 3.00016 0.0133333 4.20016 0.0133333 5.66683L0 24.3335C0 25.8002 1.18667 27.0002 2.66667 27.0002H21.3333C22.8 27.0002 24 25.8002 24 24.3335V5.66683C24 4.20016 22.8 3.00016 21.3333 3.00016H20V0.333496H17.3333ZM21.3333 24.3335H2.66667V9.66683H21.3333V24.3335Z",
    fill: "#1F4A7C"
  }));
};
const NotificationBell = () => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "20",
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.89 20 8 20ZM14 14V9C14 5.93 12.36 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.63 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14Z",
  fill: "white"
}));
const MapMarker = () => /*#__PURE__*/React.createElement("svg", {
  width: "10",
  height: "14",
  viewBox: "0 0 10 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 0.333496C2.42 0.333496 0.333328 2.42016 0.333328 5.00016C0.333328 6.16016 0.666661 7.24683 1.27333 8.22683C1.90666 9.2535 2.73999 10.1335 3.37999 11.1602C3.69333 11.6602 3.91999 12.1268 4.15999 12.6668C4.33333 13.0335 4.47333 13.6668 5 13.6668C5.52666 13.6668 5.66666 13.0335 5.83333 12.6668C6.08 12.1268 6.29999 11.6602 6.61333 11.1602C7.25333 10.1402 8.08666 9.26016 8.72 8.22683C9.33333 7.24683 9.66666 6.16016 9.66666 5.00016C9.66666 2.42016 7.58 0.333496 5 0.333496ZM5 6.8335C4.07999 6.8335 3.33333 6.08683 3.33333 5.16683C3.33333 4.24683 4.07999 3.50016 5 3.50016C5.92 3.50016 6.66666 4.24683 6.66666 5.16683C6.66666 6.08683 5.92 6.8335 5 6.8335Z",
  fill: "#505A5F"
}));
const Clock = () => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.992 0C3.576 0 0 3.584 0 8C0 12.416 3.576 16 7.992 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 7.992 0ZM7.99994 14.4C4.46393 14.4 1.59993 11.536 1.59993 7.99999C1.59993 4.46399 4.46393 1.59999 7.99994 1.59999C11.5359 1.59999 14.3999 4.46399 14.3999 7.99999C14.3999 11.536 11.5359 14.4 7.99994 14.4ZM7.20003 4H8.40003V8.2L12 10.336L11.4 11.32L7.20003 8.8V4Z",
  fill: "#505A5F"
}));
const TickMark = ({
  fillColor: _fillColor = "white"
}) => /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline-block",
    margin: "auto"
  },
  width: "14",
  height: "11",
  viewBox: "0 0 14 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.75012 8.1275L1.62262 5L0.557617 6.0575L4.75012 10.25L13.7501 1.25L12.6926 0.192505L4.75012 8.1275Z",
  fill: _fillColor
}));
const EditIcon = ({
  style
}) => /*#__PURE__*/React.createElement("svg", {
  style: style,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.126 5.125L11.063 3.188L14.81 6.935L12.873 8.873L9.126 5.125ZM17.71 2.63L15.37 0.289999C15.1826 0.103748 14.9292 -0.000793457 14.665 -0.000793457C14.4008 -0.000793457 14.1474 0.103748 13.96 0.289999L12.13 2.12L15.88 5.87L17.71 4C17.8844 3.81454 17.9815 3.56956 17.9815 3.315C17.9815 3.06044 17.8844 2.81546 17.71 2.63ZM5.63 8.63L0 14.25V18H3.75L9.38 12.38L12.873 8.873L9.126 5.125L5.63 8.63Z",
  fill: "#1F4A7C"
}));
const SearchIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z",
  fill: "#505A5F"
}));
const DeleteIcon = ({
  style,
  fill
}) => /*#__PURE__*/React.createElement("svg", {
  style: style,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z",
  fill: fill
}));
const WSICon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "28",
  height: "34",
  viewBox: "0 0 28 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.4332 10.3337L13.9998 0.916992L4.5665 10.3337C1.9665 12.9337 0.666504 16.4003 0.666504 19.7337C0.666504 23.067 1.9665 26.5837 4.5665 29.1837C7.1665 31.7837 10.5832 33.1003 13.9998 33.1003C17.4165 33.1003 20.8332 31.7837 23.4332 29.1837C26.0332 26.5837 27.3332 23.067 27.3332 19.7337C27.3332 16.4003 26.0332 12.9337 23.4332 10.3337ZM3.99984 20.3337C4.0165 17.0003 5.03317 14.8837 6.93317 13.0003L13.9998 5.78366L21.0665 13.0837C22.9665 14.9503 23.9832 17.0003 23.9998 20.3337H3.99984Z",
  fill: "#1F4A7C"
}));
const CameraIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.0002 5L11.9502 8.33333H6.66683C4.8335 8.33333 3.3335 9.83333 3.3335 11.6667V31.6667C3.3335 33.5 4.8335 35 6.66683 35H33.3335C35.1668 35 36.6668 33.5 36.6668 31.6667V11.6667C36.6668 9.83333 35.1668 8.33333 33.3335 8.33333H28.0502L25.0002 5H15.0002ZM20.0002 30C15.4002 30 11.6668 26.2667 11.6668 21.6667C11.6668 17.0667 15.4002 13.3333 20.0002 13.3333C24.6002 13.3333 28.3335 17.0667 28.3335 21.6667C28.3335 26.2667 24.6002 30 20.0002 30Z",
  fill: "#1F4A7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0002 28.3333L22.0835 23.75L26.6668 21.6667L22.0835 19.5833L20.0002 15L17.9168 19.5833L13.3335 21.6667L17.9168 23.75L20.0002 28.3333Z",
  fill: "#1F4A7C"
}));
const RemoveIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "30",
  viewBox: "0 0 24 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.00016 26.6667C2.00016 28.5 3.50016 30 5.3335 30H18.6668C20.5002 30 22.0002 28.5 22.0002 26.6667V6.66667H2.00016V26.6667ZM23.6668 1.66667H17.8335L16.1668 0H7.8335L6.16683 1.66667H0.333496V5H23.6668V1.66667Z",
  fill: "#1F4A7C"
}));
const GalleryIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "40",
  height: "34",
  viewBox: "0 0 40 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.33333 7.00016H0V15.3335H0.0166667L0 30.3335C0 32.1668 1.5 33.6668 3.33333 33.6668H33.3333V30.3335H3.33333V7.00016ZM36.6667 3.66683H23.3333L20 0.333496H10C8.16667 0.333496 6.68333 1.8335 6.68333 3.66683L6.66667 23.6668C6.66667 25.5002 8.16667 27.0002 10 27.0002H36.6667C38.5 27.0002 40 25.5002 40 23.6668V7.00016C40 5.16683 38.5 3.66683 36.6667 3.66683ZM11.6667 22.0002L19.1667 12.0002L25 19.5168L29.1667 14.5002L35 22.0002H11.6667Z",
  fill: "#1F4A7C"
}));
const EditPencilIcon = ({
  className,
  width: _width2 = 18,
  height: _height2 = 18
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: _width2,
  height: _height2,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.126 5.12482L11.063 3.18782L14.81 6.93482L12.873 8.87282L9.126 5.12482ZM17.71 2.62982L15.37 0.289816C15.1826 0.103565 14.9292 -0.000976562 14.665 -0.000976562C14.4008 -0.000976563 14.1474 0.103565 13.96 0.289816L12.13 2.11982L15.88 5.86982L17.71 3.99982C17.8844 3.81436 17.9815 3.56938 17.9815 3.31482C17.9815 3.06025 17.8844 2.81528 17.71 2.62982ZM5.63 8.62982L0 14.2498V17.9998H3.75L9.38 12.3798L12.873 8.87282L9.126 5.12482L5.63 8.62982Z",
  fill: "#505A5F"
}));
const ErrorIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "#FFFFFF",
  xmlns: "http://www.w3.org/2000/svg",
  className: className
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z",
  fill: "white"
}));
const AddIcon = ({
  styles,
  className,
  fill: _fill2 = "white"
}) => /*#__PURE__*/React.createElement("svg", {
  width: "12",
  height: "14",
  className: className,
  style: {
    ...styles
  },
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.8125 5.49609V8.4375H0.117188V5.49609H11.8125ZM7.57031 0.867188V13.2891H4.37109V0.867188H7.57031Z",
  fill: _fill2
}));
const AddNewIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 14.5833C24.3542 14.5833 25.3312 14.7729 26.25 15.0938V8.75L17.5 0H2.91667C1.29792 0 0 1.29792 0 2.91667V23.3333C0 24.9521 1.3125 26.25 2.91667 26.25H15.0938C14.7729 25.3312 14.5833 24.3542 14.5833 23.3333C14.5833 18.5062 18.5062 14.5833 23.3333 14.5833ZM16.0417 2.1875L24.0625 10.2083H16.0417V2.1875ZM29.1667 21.875V24.7917H24.7917V29.1667H21.875V24.7917H17.5V21.875H21.875V17.5H24.7917V21.875H29.1667Z",
  fill: "#1F4A7C"
}));
const ViewReportIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.6667 0H3.33333C1.5 0 0 1.5 0 3.33333V26.6667C0 28.5 1.5 30 3.33333 30H26.6667C28.5 30 30 28.5 30 26.6667V3.33333C30 1.5 28.5 0 26.6667 0ZM18.3333 23.3333H6.66667V20H18.3333V23.3333ZM23.3333 16.6667H6.66667V13.3333H23.3333V16.6667ZM23.3333 10H6.66667V6.66667H23.3333V10Z",
  fill: "#1F4A7C"
}));
const InboxIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.6667 0H3.33333C1.5 0 0 1.5 0 3.33333V15C0 16.8333 1.5 18.3333 3.33333 18.3333H26.6667C28.5 18.3333 30 16.8333 30 15V3.33333C30 1.5 28.5 0 26.6667 0ZM26.6667 10H20C20 12.7 17.7 15 15 15C12.3 15 10 12.7 10 10H3.33333V3.33333H26.6667V10ZM20 21.6667H30V26.6667C30 28.5 28.5 30 26.6667 30H3.33333C1.5 30 0 28.5 0 26.6667V21.6667H10C10 24.4333 12.2333 26.6667 15 26.6667C17.7667 26.6667 20 24.4333 20 21.6667Z",
  fill: "#1F4A7C"
}));

const BackButton = ({
  history,
  style,
  isSuccessScreen,
  isCommonPTPropertyScreen,
  getBackPageNumber,
  className: _className = "",
  variant: _variant = "black"
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: `back-btn2 ${_className}`,
    style: style ? style : {},
    onClick: () => {
      !isSuccessScreen ? !isCommonPTPropertyScreen ? history.goBack() : history.go(getBackPageNumber()) : null;
    }
  }, _variant == "black" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowLeft, null), /*#__PURE__*/React.createElement("p", null, t("CS_COMMON_BACK"))) : /*#__PURE__*/React.createElement(ArrowLeftWhite, null));
};
var BackButton$1 = withRouter(BackButton);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function (a) {
  return z(a) === k;
};
var isContextProvider = function (a) {
  return z(a) === h;
};
var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function (a) {
  return z(a) === n;
};
var isFragment = function (a) {
  return z(a) === e;
};
var isLazy = function (a) {
  return z(a) === t;
};
var isMemo = function (a) {
  return z(a) === r;
};
var isPortal = function (a) {
  return z(a) === d;
};
var isProfiler = function (a) {
  return z(a) === g;
};
var isStrictMode = function (a) {
  return z(a) === f;
};
var isSuspense = function (a) {
  return z(a) === p;
};
var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

const Successful = props => {
  var _props$props, _props$props2, _props$props3, _props$props4, _props$props5, _props$props6, _props$props7, _props$props8, _props$props9, _props$props10, _props$props11, _props$props12, _props$props13;
  const {
    t
  } = useTranslation();
  const user_type = Digit.SessionStorage.get("userType");
  return /*#__PURE__*/React.createElement("div", {
    className: user_type === "citizen" ? "success-wrap" : "emp-success-wrap",
    style: props !== null && props !== void 0 && (_props$props = props.props) !== null && _props$props !== void 0 && _props$props.style ? props === null || props === void 0 ? void 0 : (_props$props2 = props.props) === null || _props$props2 === void 0 ? void 0 : _props$props2.style : {}
  }, /*#__PURE__*/React.createElement("header", {
    style: props !== null && props !== void 0 && (_props$props3 = props.props) !== null && _props$props3 !== void 0 && _props$props3.headerStyles ? props === null || props === void 0 ? void 0 : (_props$props4 = props.props) === null || _props$props4 === void 0 ? void 0 : _props$props4.headerStyles : {}
  }, props.props.message), /*#__PURE__*/React.createElement("div", null, props.props.whichSvg === "tick" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TickMark, {
    fillColor: "green"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), " ") : (props === null || props === void 0 ? void 0 : (_props$props5 = props.props) === null || _props$props5 === void 0 ? void 0 : _props$props5.svg) || /*#__PURE__*/React.createElement(SuccessSvg, null), /*#__PURE__*/React.createElement("h2", {
    style: props !== null && props !== void 0 && (_props$props6 = props.props) !== null && _props$props6 !== void 0 && _props$props6.infoStyles ? props === null || props === void 0 ? void 0 : (_props$props7 = props.props) === null || _props$props7 === void 0 ? void 0 : _props$props7.infoStyles : {}
  }, props !== null && props !== void 0 && (_props$props8 = props.props) !== null && _props$props8 !== void 0 && _props$props8.complaintNumber ? t("CS_PGR_COMPLAINT_NUMBER") : props.props.info), /*#__PURE__*/React.createElement("p", {
    style: props !== null && props !== void 0 && (_props$props9 = props.props) !== null && _props$props9 !== void 0 && _props$props9.applicationNumberStyles ? props === null || props === void 0 ? void 0 : (_props$props10 = props.props) === null || _props$props10 === void 0 ? void 0 : _props$props10.applicationNumberStyles : {}
  }, props !== null && props !== void 0 && (_props$props11 = props.props) !== null && _props$props11 !== void 0 && _props$props11.complaintNumber ? props === null || props === void 0 ? void 0 : (_props$props12 = props.props) === null || _props$props12 === void 0 ? void 0 : _props$props12.complaintNumber : props === null || props === void 0 ? void 0 : (_props$props13 = props.props) === null || _props$props13 === void 0 ? void 0 : _props$props13.applicationNumber)));
};
const Error$1 = props => {
  var _props$props14, _props$props15, _props$props16, _props$props17, _props$props18, _props$props19, _props$props20, _props$props21, _props$props22, _props$props23, _props$props24, _props$props25;
  const {
    t
  } = useTranslation();
  const user_type = Digit.SessionStorage.get("userType");
  return /*#__PURE__*/React.createElement("div", {
    className: user_type === "citizen" ? "error-wrap" : "emp-error-wrap",
    style: props !== null && props !== void 0 && (_props$props14 = props.props) !== null && _props$props14 !== void 0 && _props$props14.style ? props === null || props === void 0 ? void 0 : (_props$props15 = props.props) === null || _props$props15 === void 0 ? void 0 : _props$props15.style : {}
  }, /*#__PURE__*/React.createElement("header", {
    style: props !== null && props !== void 0 && (_props$props16 = props.props) !== null && _props$props16 !== void 0 && _props$props16.headerStyles ? props === null || props === void 0 ? void 0 : (_props$props17 = props.props) === null || _props$props17 === void 0 ? void 0 : _props$props17.headerStyles : {}
  }, props.props.message), /*#__PURE__*/React.createElement(ErrorSvg, null), /*#__PURE__*/React.createElement("h2", {
    style: props !== null && props !== void 0 && (_props$props18 = props.props) !== null && _props$props18 !== void 0 && _props$props18.infoStyles ? props === null || props === void 0 ? void 0 : (_props$props19 = props.props) === null || _props$props19 === void 0 ? void 0 : _props$props19.infoStyles : {}
  }, props !== null && props !== void 0 && (_props$props20 = props.props) !== null && _props$props20 !== void 0 && _props$props20.complaintNumber ? t("CS_PGR_COMPLAINT_NUMBER") : props.props.info), /*#__PURE__*/React.createElement("p", {
    style: props !== null && props !== void 0 && (_props$props21 = props.props) !== null && _props$props21 !== void 0 && _props$props21.applicationNumberStyles ? props === null || props === void 0 ? void 0 : (_props$props22 = props.props) === null || _props$props22 === void 0 ? void 0 : _props$props22.applicationNumberStyles : {}
  }, props !== null && props !== void 0 && (_props$props23 = props.props) !== null && _props$props23 !== void 0 && _props$props23.complaintNumber ? props === null || props === void 0 ? void 0 : (_props$props24 = props.props) === null || _props$props24 === void 0 ? void 0 : _props$props24.complaintNumber : props === null || props === void 0 ? void 0 : (_props$props25 = props.props) === null || _props$props25 === void 0 ? void 0 : _props$props25.applicationNumber));
};
const Banner = props => {
  return props.successful ? /*#__PURE__*/React.createElement(Successful, {
    props: props
  }) : /*#__PURE__*/React.createElement(Error$1, {
    props: props
  });
};
Banner.propTypes = {
  successful: propTypes.bool.isRequired,
  message: propTypes.any.isRequired,
  complaintNumber: propTypes.any
};
Banner.defaultProps = {
  successful: true
};

const Body = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "body-container"
  }, /*#__PURE__*/React.createElement("img", {
    src: "",
    style: {
      backgroundColor: "#e3e3e3",
      position: "absolute",
      height: "100%",
      width: "100%"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      position: "relative"
    }
  }, props.children));
};

const Breadcrumb = props => {
  var _props$crumbs;
  function isLast(index) {
    return index === props.crumbs.length - 1;
  }
  return /*#__PURE__*/React.createElement("ol", {
    className: "bread-crumb"
  }, props === null || props === void 0 ? void 0 : (_props$crumbs = props.crumbs) === null || _props$crumbs === void 0 ? void 0 : _props$crumbs.map((crumb, ci) => {
    if (!(crumb !== null && crumb !== void 0 && crumb.show)) return;
    if (crumb !== null && crumb !== void 0 && crumb.isBack) return /*#__PURE__*/React.createElement("li", {
      key: ci,
      style: {
        ...props.style
      },
      className: "bread-crumb--item"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        cursor: "pointer"
      },
      onClick: () => window.history.back()
    }, crumb.content));
    return /*#__PURE__*/React.createElement("li", {
      key: ci,
      style: {
        ...props.style
      },
      className: "bread-crumb--item"
    }, isLast(ci) || !(crumb !== null && crumb !== void 0 && crumb.path) ? /*#__PURE__*/React.createElement("span", {
      style: props !== null && props !== void 0 && props.spanStyle ? {
        ...(props === null || props === void 0 ? void 0 : props.spanStyle),
        color: "#0B0C0C"
      } : {
        color: "#0B0C0C"
      }
    }, crumb.content) : /*#__PURE__*/React.createElement(Link, {
      to: crumb.path
    }, crumb.content));
  }));
};
Breadcrumb.propTypes = {
  crumbs: propTypes.array
};
Breadcrumb.defaultProps = {
  successful: true
};

const BreakLine = ({
  style: _style = {}
}) => {
  return /*#__PURE__*/React.createElement("hr", {
    color: "#d6d5d4",
    className: "break-line",
    style: _style
  });
};

const ButtonSelector = props => {
  let theme = "selector-button-primary";
  switch (props.theme) {
    case "border":
      theme = "selector-button-border";
      break;
    default:
      theme = "selector-button-primary";
      break;
  }
  return /*#__PURE__*/React.createElement("button", {
    className: props.isDisabled ? "selector-button-primary-disabled" : theme,
    type: props.type || "submit",
    form: props.formId,
    onClick: props.onSubmit,
    disabled: props.isDisabled,
    style: props.style ? props.style : null
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      ...(props === null || props === void 0 ? void 0 : props.textStyles),
      ...{
        width: "100%"
      }
    }
  }, props.label));
};
ButtonSelector.propTypes = {
  label: propTypes.string.isRequired,
  theme: propTypes.string,
  onSubmit: propTypes.func
};
ButtonSelector.defaultProps = {
  label: "",
  theme: "",
  onSubmit: undefined
};

const Card = ({
  onClick,
  style,
  children,
  className,
  ReactRef,
  ...props
}) => {
  var _Digit$UserService$ge;
  const {
    pathname
  } = useLocation();
  const classname = Digit.Hooks.fsm.useRouteSubscription(pathname);
  const info = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  const userType = info === null || info === void 0 ? void 0 : info.type;
  const isEmployee = classname === "employee" || userType === "EMPLOYEE";
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: `${isEmployee ? "employeeCard" : "card"} ${className ? className : ""}`,
    onClick: onClick,
    style: style
  }, props, {
    ref: ReactRef
  }), children);
};

const CardCaption = props => {
  return /*#__PURE__*/React.createElement("label", {
    style: props.style,
    className: "card-caption"
  }, props.children);
};

const CardHeader = props => {
  return /*#__PURE__*/React.createElement("header", {
    className: "card-header",
    style: props.styles ? props.styles : {}
  }, props.children);
};

const CardLabel = props => {
  return /*#__PURE__*/React.createElement("h2", {
    className: `card-label ${props.className}`,
    style: props.style
  }, props.children);
};

const CardLabelDesc = ({
  children,
  style,
  className
}) => {
  return /*#__PURE__*/React.createElement("h2", {
    className: `card-label-desc ${className ? className : ""}`,
    style: style
  }, children);
};

const CardLabelError = props => {
  return /*#__PURE__*/React.createElement("h2", {
    className: `card-label-error ${props !== null && props !== void 0 && props.className ? props === null || props === void 0 ? void 0 : props.className : ""}`,
    style: props.style
  }, props.children);
};

const CardSectionHeader = props => {
  return /*#__PURE__*/React.createElement("header", {
    id: props.id,
    className: "card-section-header",
    style: props.style
  }, props.children);
};

const CardSubHeader = props => {
  const user_type = Digit.SessionStorage.get("user_type") === "employee" ? true : false;
  return /*#__PURE__*/React.createElement("header", {
    className: `${user_type ? "employee-card-sub-header" : "card-sub-header"} ${props !== null && props !== void 0 && props.className ? props === null || props === void 0 ? void 0 : props.className : ""}`,
    style: props.style
  }, props.children);
};

const CardText = props => {
  return /*#__PURE__*/React.createElement("p", {
    className: `card-text ${props.disable && "disabled"} ${props !== null && props !== void 0 && props.className ? props === null || props === void 0 ? void 0 : props.className : ""}`,
    style: props.style
  }, props.children);
};

const CardText$1 = props => {
  return /*#__PURE__*/React.createElement("p", {
    className: "card-text-button"
  }, props.children);
};

const CheckBox = ({
  onChange,
  label,
  value,
  disable,
  ref,
  checked,
  inputRef,
  pageType,
  style,
  index,
  isLabelFirst,
  ...props
}) => {
  const userType = pageType || Digit.SessionStorage.get("userType");
  let wrkflwStyle = props.styles;
  if (isLabelFirst) {
    return /*#__PURE__*/React.createElement("div", {
      className: "checkbox-wrap",
      style: wrkflwStyle ? wrkflwStyle : {}
    }, /*#__PURE__*/React.createElement("p", {
      style: style ? style : null
    }, " ", index + 1, "."), /*#__PURE__*/React.createElement("p", {
      className: "label",
      style: {
        maxWidth: "80%",
        marginLeft: "10px"
      }
    }, label), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", Object.assign({
      type: "checkbox",
      className: userType === "employee" ? "input-emp" : "",
      onChange: onChange,
      style: {
        cursor: "pointer",
        left: "90%"
      },
      value: value || label
    }, props, {
      ref: inputRef,
      disabled: disable,
      checked: checked
    })), /*#__PURE__*/React.createElement("p", {
      className: userType === "employee" ? "custom-checkbox-emp" : "custom-checkbox",
      style: disable ? {
        opacity: 0.5
      } : {
        left: "90%"
      }
    }, /*#__PURE__*/React.createElement(CheckSvg, null))));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "checkbox-wrap",
      style: wrkflwStyle ? wrkflwStyle : {}
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", Object.assign({
      type: "checkbox",
      className: userType === "employee" ? "input-emp" : "",
      onChange: onChange,
      style: {
        cursor: "pointer"
      },
      value: value || label
    }, props, {
      ref: inputRef,
      disabled: disable,
      checked: checked
    })), /*#__PURE__*/React.createElement("p", {
      className: userType === "employee" ? "custom-checkbox-emp" : "custom-checkbox",
      style: disable ? {
        opacity: 0.5
      } : null
    }, /*#__PURE__*/React.createElement(CheckSvg, null))), /*#__PURE__*/React.createElement("p", {
      className: "label",
      style: style ? style : null
    }, label));
  }
};
CheckBox.propTypes = {
  label: propTypes.string.isRequired,
  onChange: propTypes.func,
  ref: propTypes.func,
  userType: propTypes.string
};
CheckBox.defaultProps = {};

const CitizenHomeCard = ({
  header,
  links,
  state,
  Icon,
  Info,
  isInfo: _isInfo = false,
  styles
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "CitizenHomeCard",
    style: styles ? styles : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "complaint-links-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, links.map((e, i) => /*#__PURE__*/React.createElement(Link, {
    key: i,
    to: {
      pathname: e.link,
      state: e.state
    }
  }, e.i18nKey))), /*#__PURE__*/React.createElement("div", null, _isInfo ? /*#__PURE__*/React.createElement(Info, null) : null)));
};

const CitizenOBPSCard = ({
  header,
  links,
  state,
  Icon,
  Info,
  isInfo: _isInfo = false,
  styles
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "CitizenOBPSCard",
    style: {
      display: "flex",
      flexDirection: 'row',
      justifyContent: "center",
      backgroundColor: '#1f4a7c',
      height: '400px',
      width: "80%",
      borderRadius: '10px',
      margin: 'auto',
      marginTop: '150px'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: "https://static.toiimg.com/photo/93246451.cms",
    alt: "cititizenobpscard",
    style: {
      width: '472px',
      height: '353px',
      marginTop: "20px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "CitizenHomeCard",
    style: styles ? styles : {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "complaint-links-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, links.map((e, i) => /*#__PURE__*/React.createElement(Link, {
    key: i,
    to: {
      pathname: e.link,
      state: e.state
    }
  }, e.i18nKey))))));
};

const CitizenOBPSHomeCard = ({
  header,
  links,
  state,
  Icon,
  Info,
  isInfo: _isInfo = false,
  styles
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "CitizenOBPSHomeCard",
    style: styles ? styles : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "complaint-links-container-obps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement("span", {
    style: {
      borderRadius: '99999px',
      padding: '7px',
      color: 'white',
      marginLeft: 'auto',
      color: 'white'
    }
  }, /*#__PURE__*/React.createElement(Icon, null))), /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, links.map((e, i) => /*#__PURE__*/React.createElement(Link, {
    key: i,
    to: {
      pathname: e.link,
      state: e.state
    }
  }, e.i18nKey))), /*#__PURE__*/React.createElement("div", null, _isInfo ? /*#__PURE__*/React.createElement(Info, null) : null)));
};

const CitizenInfoLabel = ({
  info,
  text,
  style,
  textStyle,
  showInfo: _showInfo = true,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `info-banner-wrap ${className ? className : ""}`,
    style: style
  }, _showInfo && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InfoBannerIcon, null), /*#__PURE__*/React.createElement("h2", null, info)), /*#__PURE__*/React.createElement("p", {
    style: textStyle
  }, text));
};

const CheckPoint = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: props.isCompleted ? "checkpoint-done" : "checkpoint",
    key: props.keyValue
  }, /*#__PURE__*/React.createElement("h2", null), /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", null, /*#__PURE__*/React.createElement("span", null, props.label)), /*#__PURE__*/React.createElement("p", null, props.info ? /*#__PURE__*/React.createElement("p", null, props.info) : null, props.customChild ? props.customChild : null)));
};
const ConnectingCheckPoints = props => {
  if (props.children && props.children.length >= 1) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.children.map((child, index) => {
      return props.children.length === ++index ? /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "checkpoint-wrap"
      }, child) : /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "checkpoint-connect-wrap"
      }, child, /*#__PURE__*/React.createElement("div", {
        className: "checkpoint-connect"
      }));
    }));
  } else {
    return null;
  }
};
CheckPoint.propTypes = {
  isCompleted: propTypes.bool,
  key: propTypes.oneOfType([propTypes.string, propTypes.number]),
  label: propTypes.string,
  info: propTypes.string
};
CheckPoint.defaultProps = {
  isCompleted: false,
  key: 0,
  label: "",
  info: ""
};

const CustomButton = ({
  text,
  onClick,
  selected
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    tabIndex: "0",
    type: "button",
    className: selected ? "customBtn-selected" : "customBtn",
    onClick: onClick
  }, text));
};

const DatePicker = props => {
  const dateInp = useRef();
  function defaultFormatFunc(date) {
    if (date) {
      const operationDate = typeof date === "string" ? new Date(date) : date;
      const years = operationDate === null || operationDate === void 0 ? void 0 : operationDate.getFullYear();
      const month = (operationDate === null || operationDate === void 0 ? void 0 : operationDate.getMonth()) + 1;
      const _date = operationDate === null || operationDate === void 0 ? void 0 : operationDate.getDate();
      return _date && month && years ? `${_date}/${month}/${years}` : "";
    }
    return "";
  }
  const getDatePrint = () => {
    var _props$formattingFn;
    return (props === null || props === void 0 ? void 0 : (_props$formattingFn = props.formattingFn) === null || _props$formattingFn === void 0 ? void 0 : _props$formattingFn.call(props, props === null || props === void 0 ? void 0 : props.date)) || defaultFormatFunc(props === null || props === void 0 ? void 0 : props.date);
  };
  const selectDate = e => {
    var _props$onChange;
    const date = e.target.value;
    props === null || props === void 0 ? void 0 : (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, date);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    disabled: props.disabled,
    value: getDatePrint() ? getDatePrint() : "DD/MM/YYYY",
    readOnly: true,
    className: `employee-card-input ${props.disabled ? "disabled" : ""}`,
    style: {
      width: "calc(100%-62px)"
    }
  }), /*#__PURE__*/React.createElement(CalendarIcon, {
    isdisabled: props.disabled ? true : false,
    style: {
      right: "6px",
      zIndex: "10",
      top: 6,
      position: "absolute"
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: `${props.disabled ? "disabled" : ""}`,
    style: {
      right: "6px",
      zIndex: "100",
      top: 6,
      position: "absolute",
      opacity: 0,
      width: "100%"
    },
    value: props.date ? props.date : "",
    type: "date",
    ref: dateInp,
    disabled: props.disabled,
    onChange: selectDate,
    defaultValue: props.defaultValue,
    min: props.min,
    max: props.max,
    required: props.isRequired || false
  })));
};
DatePicker.propTypes = {
  disabled: propTypes.bool,
  date: propTypes.any,
  min: propTypes.any,
  max: propTypes.any,
  defaultValue: propTypes.any,
  onChange: propTypes.func
};

const PopUp = ({
  className,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `popup-wrap ${className}`
  }, props.children);
};

const HeaderBar = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "header-wrap",
    style: props !== null && props !== void 0 && props.style ? props.style : {}
  }, props.start ? /*#__PURE__*/React.createElement("div", {
    className: "header-start"
  }, props.start) : null, props.main ? /*#__PURE__*/React.createElement("div", {
    className: "header-content"
  }, props.main) : null, props.end ? /*#__PURE__*/React.createElement("div", {
    className: "header-end"
  }, props.end) : null);
};
HeaderBar.propTypes = {
  start: propTypes.any,
  main: propTypes.any,
  end: propTypes.any
};
HeaderBar.defaultProps = {
  start: "",
  main: "",
  end: ""
};

const Toast$1 = props => {
  if (props.error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "toast-success",
      style: {
        backgroundColor: "red",
        ...props.style
      }
    }, /*#__PURE__*/React.createElement(ErrorIcon, null), /*#__PURE__*/React.createElement("h2", {
      style: {
        ...props.labelstyle
      }
    }, props.label), props.isDleteBtn ? /*#__PURE__*/React.createElement(DeleteBtn, {
      fill: "none",
      className: "toast-close-btn",
      onClick: props.onClose
    }) : null);
  }
  if (props.warning) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "toast-success",
      style: props !== null && props !== void 0 && props.isWarningButtons ? {
        backgroundColor: "#EA8A3B",
        display: "block",
        ...props.style
      } : {
        backgroundColor: "#EA8A3B",
        ...props.style
      }
    }, !(props !== null && props !== void 0 && props.isWarningButtons) ? /*#__PURE__*/React.createElement("div", {
      className: "toast-success",
      style: {
        backgroundColor: "#EA8A3B",
        ...props.style
      }
    }, /*#__PURE__*/React.createElement(ErrorIcon, null), /*#__PURE__*/React.createElement("h2", {
      style: {
        marginLeft: "10px"
      }
    }, props.label), props.isDleteBtn ? /*#__PURE__*/React.createElement(DeleteBtn, {
      fill: "none",
      className: "toast-close-btn",
      onClick: props.onClose
    }) : null) : /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement(ErrorIcon, null), /*#__PURE__*/React.createElement("h2", {
      style: {
        marginLeft: "10px"
      }
    }, props.label), props.isDleteBtn ? /*#__PURE__*/React.createElement(DeleteBtn, {
      fill: "none",
      className: "toast-close-btn",
      onClick: props.onClose
    }) : null), props !== null && props !== void 0 && props.isWarningButtons ? /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(ButtonSelector, {
      theme: "border",
      label: "NO",
      onSubmit: props.onNo,
      style: {
        marginLeft: "10px"
      }
    }), /*#__PURE__*/React.createElement(ButtonSelector, {
      label: "YES",
      onSubmit: props.onYes,
      style: {
        marginLeft: "10px"
      }
    })) : null));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "toast-success",
    style: {
      ...props.style
    }
  }, /*#__PURE__*/React.createElement(RoundedCheck, null), /*#__PURE__*/React.createElement("h2", null, props.label), /*#__PURE__*/React.createElement(DeleteBtn, {
    fill: "none",
    className: "toast-close-btn",
    onClick: props.onClose
  }));
};
Toast$1.propTypes = {
  label: propTypes.string,
  onClose: propTypes.func,
  isDleteBtn: propTypes.bool
};
Toast$1.defaultProps = {
  label: "",
  onClose: undefined,
  isDleteBtn: false
};

const Modal = ({
  headerBarMain,
  headerBarEnd,
  popupStyles,
  children,
  actionCancelLabel,
  actionCancelOnSubmit,
  actionSaveLabel,
  actionSaveOnSubmit,
  error,
  setError,
  formId,
  isDisabled,
  hideSubmit,
  style: _style = {},
  popupModuleMianStyles,
  headerBarMainStyle,
  isOBPSFlow: _isOBPSFlow = false,
  popupModuleActionBarStyles: _popupModuleActionBarStyles = {}
}) => {
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);
  return /*#__PURE__*/React.createElement(PopUp, null, /*#__PURE__*/React.createElement("div", {
    className: "popup-module",
    style: popupStyles
  }, /*#__PURE__*/React.createElement(HeaderBar, {
    main: headerBarMain,
    end: headerBarEnd,
    style: headerBarMainStyle ? headerBarMainStyle : {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "popup-module-main",
    style: popupModuleMianStyles ? popupModuleMianStyles : {}
  }, children, /*#__PURE__*/React.createElement("div", {
    className: "popup-module-action-bar",
    style: _isOBPSFlow ? !mobileView ? {
      marginRight: "18px"
    } : {
      position: "absolute",
      bottom: "5%",
      right: "10%",
      left: window.location.href.includes("employee") ? "0%" : "7%"
    } : _popupModuleActionBarStyles
  }, actionCancelLabel ? /*#__PURE__*/React.createElement(ButtonSelector, {
    theme: "border",
    label: actionCancelLabel,
    onSubmit: actionCancelOnSubmit,
    style: _style
  }) : null, !hideSubmit ? /*#__PURE__*/React.createElement(ButtonSelector, {
    label: actionSaveLabel,
    onSubmit: actionSaveOnSubmit,
    formId: formId,
    isDisabled: isDisabled,
    style: _style
  }) : null))), error && /*#__PURE__*/React.createElement(Toast$1, {
    label: error,
    onClose: () => setError(null),
    error: true
  }));
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1000);
}

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

function endOfToday() {
  return endOfDay(Date.now());
}

function endOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

var formatters = {
  y: function (date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
var formatters$1 = {
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  y: function (date, token, localize) {
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters.y(date, token);
  },
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'Q':
        return String(quarter);
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'q':
        return String(quarter);
      case 'qq':
        return addLeadingZeros(quarter, 2);
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'L':
        return String(month + 1);
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters.d(date, token);
  },
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'e':
        return String(localDayOfWeek);
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'c':
        return String(localDayOfWeek);
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case 'i':
        return String(isoDayOfWeek);
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters.h(date, token);
  },
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters.H(date, token);
  },
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters.m(date, token);
  },
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters.s(date, token);
  },
  S: function (date, token) {
    return formatters.S(date, token);
  },
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'XXXX':
      case 'XX':
        return formatTimezone(timezoneOffset);
      case 'XXXXX':
      case 'XXX':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'xxxx':
      case 'xx':
        return formatTimezone(timezoneOffset);
      case 'xxxxx':
      case 'xxx':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}
function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

function startOfToday() {
  return startOfDay(Date.now());
}

function startOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

function isEndDateFocused(focusNumber) {
  return focusNumber === 1;
}
function isStartDateFocused(focusNumber) {
  return focusNumber === 0;
}
const DateRange = ({
  values,
  onFilterChange,
  t,
  labelClass
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [focusedRange, setFocusedRange] = useState([0, 0]);
  const [selectionRange, setSelectionRange] = useState({
    ...values,
    startDate: values === null || values === void 0 ? void 0 : values.startDate,
    endDate: values === null || values === void 0 ? void 0 : values.endDate
  });
  const wrapperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  useEffect(() => {
    if (!isModalOpen && (selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.startDate) instanceof Date && (selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.endDate) instanceof Date) {
      const startDate = selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.startDate;
      const endDate = selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.endDate;
      const duration = getDuration(selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.startDate, selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.endDate);
      const title = `${format(selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.startDate, "MMM d, yy")} - ${format(selectionRange === null || selectionRange === void 0 ? void 0 : selectionRange.endDate, "MMM d, yy")}`;
      onFilterChange({
        range: {
          startDate,
          endDate,
          duration,
          title
        },
        requestDate: {
          startDate,
          endDate,
          duration,
          title
        }
      });
    }
  }, [selectionRange, isModalOpen]);
  const staticRanges = useMemo(() => {
    return createStaticRanges([{
      label: t("DSS_TODAY"),
      range: () => ({
        startDate: startOfToday(),
        endDate: endOfToday()
      })
    }, {
      label: t("DSS_YESTERDAY"),
      range: () => ({
        startDate: startOfYesterday(),
        endDate: endOfYesterday()
      })
    }, {
      label: t("DSS_THIS_WEEK"),
      range: () => ({
        startDate: startOfWeek(new Date()),
        endDate: endOfWeek(new Date())
      })
    }, {
      label: t('DSS_THIS_MONTH'),
      range: () => ({
        startDate: startOfMonth(new Date()),
        endDate: endOfMonth(new Date())
      })
    }, {
      label: t('DSS_THIS_QUARTER'),
      range: () => ({
        startDate: startOfQuarter(new Date()),
        endDate: endOfQuarter(new Date())
      })
    }, {
      label: t('DSS_PREVIOUS_YEAR'),
      range: () => ({
        startDate: subYears(addMonths(startOfYear(new Date()), 3), 1),
        endDate: subYears(addMonths(endOfYear(new Date()), 3), 1)
      })
    }, {
      label: t('DSS_THIS_YEAR'),
      range: () => ({
        startDate: addMonths(startOfYear(new Date()), 3),
        endDate: addMonths(endOfYear(new Date()), 3)
      })
    }]);
  }, []);
  const getDuration = (startDate, endDate) => {
    let noOfDays = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 3600 * 24);
    if (noOfDays > 91) {
      return "month";
    }
    if (noOfDays < 90 && noOfDays >= 14) {
      return "week";
    }
    if (noOfDays <= 14) {
      return "day";
    }
  };
  const handleSelect = ranges => {
    const {
      range1: selection
    } = ranges;
    const {
      startDate,
      endDate,
      title,
      duration
    } = selection;
    if (isStartDateFocused(focusedRange[1])) {
      setSelectionRange(selection);
    }
    if (isEndDateFocused(focusedRange[1])) {
      setSelectionRange({
        title,
        duration,
        startDate,
        endDate: addSeconds(addMinutes(addHours(endDate, 23), 59), 59)
      });
      setIsModalOpen(false);
    }
  };
  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("div", {
    className: "filter-label"
  }, t(`ES_DSS_DATE_RANGE`)), /*#__PURE__*/React.createElement("div", {
    className: "employee-select-wrap",
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "select"
  }, /*#__PURE__*/React.createElement("input", {
    className: "employee-select-wrap--elipses",
    type: "text",
    value: values !== null && values !== void 0 && values.title ? `${values === null || values === void 0 ? void 0 : values.title}` : "",
    readOnly: true
  }), /*#__PURE__*/React.createElement(Calender, {
    className: "cursorPointer",
    onClick: () => setIsModalOpen(prevState => !prevState)
  })), isModalOpen && /*#__PURE__*/React.createElement("div", {
    className: "options-card",
    style: {
      overflow: "visible",
      width: "unset",
      maxWidth: "unset"
    }
  }, /*#__PURE__*/React.createElement(DateRangePicker, {
    className: "pickerShadow",
    focusedRange: focusedRange,
    ranges: [selectionRange],
    rangeColors: ["#9E9E9E"],
    onChange: handleSelect,
    onRangeFocusChange: setFocusedRange,
    retainEndDateOnFirstSelection: true,
    showSelectionPreview: true,
    staticRanges: staticRanges,
    inputRanges: []
  }))));
};

const DateWrap = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "date-wrap"
  }, /*#__PURE__*/React.createElement(Calender, null), /*#__PURE__*/React.createElement("p", null, props.date));
};
DateWrap.propTypes = {
  date: propTypes.any
};
DateWrap.defaultProps = {
  date: 0
};

const ImageOrPDFIcon = ({
  source,
  index,
  last: _last = false,
  onClick
}) => {
  return Digit.Utils.getFileTypeFromFileStoreURL(source) === "pdf" ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      alignContent: "center"
    }
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    href: source,
    style: {
      minWidth: "100px",
      marginRight: "10px",
      maxWidth: "100px",
      height: "auto"
    },
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(PDFSvg, {
    style: {
      background: "#f6f6f6",
      padding: "8px",
      width: "100px"
    },
    width: "100px",
    height: "100px",
    minWidth: "100px"
  })))) : /*#__PURE__*/React.createElement("img", Object.assign({
    key: index,
    src: source
  }, _last ? {
    className: "last"
  } : {}, {
    alt: "issue thumbnail",
    onClick: () => onClick(source, index)
  }));
};
const DisplayPhotos = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "photos-wrap"
  }, props.srcs.map((source, index) => {
    return /*#__PURE__*/React.createElement(ImageOrPDFIcon, Object.assign({}, {
      source,
      index,
      ...props
    }, {
      last: ++index !== props.srcs.length ? false : true
    }));
  }));
};
DisplayPhotos.propTypes = {
  srcs: propTypes.array,
  onClick: propTypes.func
};
DisplayPhotos.defaultProps = {
  srcs: []
};

const OptionsList = ({
  props,
  optionIndex,
  filteredOption,
  hasCustomSelector,
  optionRef,
  onSelect
}) => {
  const getOptionText = option => {
    var _props$multiOptionKey, _props$multiOptionKey2;
    const singleKey = option[props.optionKey];
    const singleOption = props.t ? props.t(singleKey) : singleKey;
    const doubleKey = props.multiOptionKey ? `${option[(_props$multiOptionKey = props.multiOptionKey) === null || _props$multiOptionKey === void 0 ? void 0 : _props$multiOptionKey[0]]} - ${option[(_props$multiOptionKey2 = props.multiOptionKey) === null || _props$multiOptionKey2 === void 0 ? void 0 : _props$multiOptionKey2[1]]}` : singleOption;
    const doubleOptions = props.t ? props.t(doubleKey) : doubleKey;
    return typeof props.multiOptionKey === null ? props.isPropertyAssess ? /*#__PURE__*/React.createElement("div", null, singleOption) : /*#__PURE__*/React.createElement("span", null, singleOption) : props.isPropertyAssess ? /*#__PURE__*/React.createElement("div", null, doubleOptions) : /*#__PURE__*/React.createElement("span", null, doubleOptions);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "jk-dropdown-unique",
    className: `${hasCustomSelector ? "margin-top-10 display: table" : ""} options-card`,
    style: {
      ...props.optionCardStyles
    },
    ref: optionRef
  }, filteredOption === null || filteredOption === void 0 ? void 0 : filteredOption.map((option, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: `cp profile-dropdown--item display: flex `,
      style: index === optionIndex ? {
        opacity: 1,
        backgroundColor: "rgba(238, 238, 238, var(--bg-opacity))"
      } : {},
      key: index,
      onClick: () => onSelect(option)
    }, option.icon && /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, " ", option.icon, " "), getOptionText(option));
  }), filteredOption && filteredOption.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: `cp profile-dropdown--item display: flex `,
    key: "-1",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement("span", null, " ", props.t ? props.t("CMN_NOOPTION") : "CMN_NOOPTION")));
};
const TextField = props => {
  const [value, setValue] = useState(props.selectedVal ? props.selectedVal : "");
  useEffect(() => {
    if (!props.keepNull) {
      if (props.selectedVal) setValue(props.selectedVal);else {
        setValue("");
        props.setFilter("");
      }
    } else setValue("");
  }, [props.selectedVal, props.forceSet]);
  function inputChange(e) {
    if (props.freeze) return;
    setValue(e.target.value);
    props.setFilter(e.target.value);
  }
  function broadcastToOpen() {
    if (!props.disable) {
      props.dropdownDisplay(true);
    }
  }
  function broadcastToClose() {
    props.dropdownDisplay(false);
  }
  const keyChange = e => {
    if (e.key == "ArrowDown") {
      props.setOptionIndex(state => state + 1 == props.addProps.length ? 0 : state + 1);
      if (props.addProps.currentIndex + 1 == props.addProps.length) {
        var _e$target, _e$target$parentEleme, _e$target$parentEleme2, _e$target$parentEleme3, _e$target$parentEleme4, _e$target$parentEleme5;
        e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$parentEleme = _e$target.parentElement) === null || _e$target$parentEleme === void 0 ? void 0 : (_e$target$parentEleme2 = _e$target$parentEleme.parentElement) === null || _e$target$parentEleme2 === void 0 ? void 0 : (_e$target$parentEleme3 = _e$target$parentEleme2.children) === null || _e$target$parentEleme3 === void 0 ? void 0 : (_e$target$parentEleme4 = _e$target$parentEleme3.namedItem("jk-dropdown-unique")) === null || _e$target$parentEleme4 === void 0 ? void 0 : (_e$target$parentEleme5 = _e$target$parentEleme4.scrollTo) === null || _e$target$parentEleme5 === void 0 ? void 0 : _e$target$parentEleme5.call(_e$target$parentEleme4, 0, 0);
      } else {
        var _props$addProps, _e$target2, _e$target2$parentElem, _e$target2$parentElem2, _e$target2$parentElem3, _e$target2$parentElem4, _e$target2$parentElem5;
        (props === null || props === void 0 ? void 0 : (_props$addProps = props.addProps) === null || _props$addProps === void 0 ? void 0 : _props$addProps.currentIndex) > 2 && (e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$parentElem = _e$target2.parentElement) === null || _e$target2$parentElem === void 0 ? void 0 : (_e$target2$parentElem2 = _e$target2$parentElem.parentElement) === null || _e$target2$parentElem2 === void 0 ? void 0 : (_e$target2$parentElem3 = _e$target2$parentElem2.children) === null || _e$target2$parentElem3 === void 0 ? void 0 : (_e$target2$parentElem4 = _e$target2$parentElem3.namedItem("jk-dropdown-unique")) === null || _e$target2$parentElem4 === void 0 ? void 0 : (_e$target2$parentElem5 = _e$target2$parentElem4.scrollBy) === null || _e$target2$parentElem5 === void 0 ? void 0 : _e$target2$parentElem5.call(_e$target2$parentElem4, 0, 45));
      }
      e.preventDefault();
    } else if (e.key == "ArrowUp") {
      props.setOptionIndex(state => state !== 0 ? state - 1 : props.addProps.length - 1);
      if (props.addProps.currentIndex == 0) {
        var _e$target3, _e$target3$parentElem, _e$target3$parentElem2, _e$target3$parentElem3, _e$target3$parentElem4, _e$target3$parentElem5;
        e === null || e === void 0 ? void 0 : (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : (_e$target3$parentElem = _e$target3.parentElement) === null || _e$target3$parentElem === void 0 ? void 0 : (_e$target3$parentElem2 = _e$target3$parentElem.parentElement) === null || _e$target3$parentElem2 === void 0 ? void 0 : (_e$target3$parentElem3 = _e$target3$parentElem2.children) === null || _e$target3$parentElem3 === void 0 ? void 0 : (_e$target3$parentElem4 = _e$target3$parentElem3.namedItem("jk-dropdown-unique")) === null || _e$target3$parentElem4 === void 0 ? void 0 : (_e$target3$parentElem5 = _e$target3$parentElem4.scrollTo) === null || _e$target3$parentElem5 === void 0 ? void 0 : _e$target3$parentElem5.call(_e$target3$parentElem4, 100000, 100000);
      } else {
        var _props$addProps2, _e$target4, _e$target4$parentElem, _e$target4$parentElem2, _e$target4$parentElem3, _e$target4$parentElem4, _e$target4$parentElem5;
        (props === null || props === void 0 ? void 0 : (_props$addProps2 = props.addProps) === null || _props$addProps2 === void 0 ? void 0 : _props$addProps2.currentIndex) > 2 && (e === null || e === void 0 ? void 0 : (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : (_e$target4$parentElem = _e$target4.parentElement) === null || _e$target4$parentElem === void 0 ? void 0 : (_e$target4$parentElem2 = _e$target4$parentElem.parentElement) === null || _e$target4$parentElem2 === void 0 ? void 0 : (_e$target4$parentElem3 = _e$target4$parentElem2.children) === null || _e$target4$parentElem3 === void 0 ? void 0 : (_e$target4$parentElem4 = _e$target4$parentElem3.namedItem("jk-dropdown-unique")) === null || _e$target4$parentElem4 === void 0 ? void 0 : (_e$target4$parentElem5 = _e$target4$parentElem4.scrollBy) === null || _e$target4$parentElem5 === void 0 ? void 0 : _e$target4$parentElem5.call(_e$target4$parentElem4, 0, -45));
      }
      e.preventDefault();
    } else if (e.key == "Enter") {
      props.addProps.selectOption(props.addProps.currentIndex);
    }
  };
  return /*#__PURE__*/React.createElement("input", {
    ref: props.inputRef,
    className: `employee-select-wrap--elipses ${props.disable && "disabled"}`,
    type: "text",
    value: value,
    onChange: inputChange,
    onClick: props.onClick,
    onFocus: broadcastToOpen,
    onBlur: e => {
      var _props$onBlur;
      broadcastToClose();
      props === null || props === void 0 ? void 0 : (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, e);
      if (props.selectedVal !== props.filterVal) {
        setTimeout(() => {
          props.setforceSet(val => val + 1);
        }, 1000);
      }
    },
    onKeyDown: keyChange,
    readOnly: props.disable,
    autoFocus: props.autoFocus,
    placeholder: props.placeholder,
    autoComplete: "off",
    style: props.style
  });
};
const translateDummy = text => {
  return text;
};
const Dropdown = props => {
  var _props$option;
  const user_type = Digit.SessionStorage.get("userType");
  const [dropdownStatus, setDropdownStatus] = useState(false);
  const [selectedOption, setSelectedOption] = useState(props.selected ? props.selected : null);
  const [filterVal, setFilterVal] = useState("");
  const [forceSet, setforceSet] = useState(0);
  const [optionIndex, setOptionIndex] = useState(-1);
  const optionRef = useRef(null);
  const hasCustomSelector = props.customSelector ? true : false;
  const t = props.t || translateDummy;
  useEffect(() => {
    setSelectedOption(props.selected);
  }, [props.selected]);
  function dropdownSwitch() {
    if (!props.disable) {
      var _props$onBlur2;
      var current = dropdownStatus;
      if (!current) {
        document.addEventListener("mousedown", handleClick, false);
      }
      setDropdownStatus(!current);
      props === null || props === void 0 ? void 0 : (_props$onBlur2 = props.onBlur) === null || _props$onBlur2 === void 0 ? void 0 : _props$onBlur2.call(props);
    }
  }
  function handleClick(e) {
    if (!optionRef.current || !optionRef.current.contains(e.target)) {
      document.removeEventListener("mousedown", handleClick, false);
      setDropdownStatus(false);
    }
  }
  function dropdownOn(val) {
    const waitForOptions = () => setTimeout(() => setDropdownStatus(val), 500);
    const timerId = waitForOptions();
    return () => {
      clearTimeout(timerId);
    };
  }
  function onSelect(val) {
    if (val !== selectedOption || props.allowMultiselect) {
      props.select(val);
      setSelectedOption(val);
      setDropdownStatus(false);
    } else {
      setSelectedOption(val);
      setforceSet(forceSet + 1);
    }
  }
  function setFilter(val) {
    setFilterVal(val);
  }
  let filteredOption = props.option && ((_props$option = props.option) === null || _props$option === void 0 ? void 0 : _props$option.filter(option => {
    var _t, _t$toUpperCase;
    return ((_t = t(option[props.optionKey])) === null || _t === void 0 ? void 0 : (_t$toUpperCase = _t.toUpperCase()) === null || _t$toUpperCase === void 0 ? void 0 : _t$toUpperCase.indexOf(filterVal === null || filterVal === void 0 ? void 0 : filterVal.toUpperCase())) > -1;
  })) || [];
  function selectOption(ind) {
    onSelect(filteredOption[ind]);
  }
  if (props.isBPAREG && selectedOption) {
    var _props$option2, _props$option2$filter;
    let isSelectedSameAsOptions = ((_props$option2 = props.option) === null || _props$option2 === void 0 ? void 0 : (_props$option2$filter = _props$option2.filter(ob => (ob === null || ob === void 0 ? void 0 : ob.code) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.code))) === null || _props$option2$filter === void 0 ? void 0 : _props$option2$filter.length) > 0;
    if (!isSelectedSameAsOptions) setSelectedOption(null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${user_type === "employee" ? "employee-select-wrap" : "select-wrap"} ${props !== null && props !== void 0 && props.className ? props === null || props === void 0 ? void 0 : props.className : ""}`,
    style: {
      ...props.style
    }
  }, hasCustomSelector && /*#__PURE__*/React.createElement("div", {
    className: props.showArrow ? "cp flex-right column-gap-5" : "cp",
    onClick: dropdownSwitch
  }, props.customSelector, props.showArrow && /*#__PURE__*/React.createElement(ArrowDown, {
    onClick: dropdownSwitch,
    className: props.disable && "disabled"
  })), !hasCustomSelector && /*#__PURE__*/React.createElement("div", {
    className: `${dropdownStatus ? "select-active" : "select"} ${props.disable && "disabled"}`,
    style: props.errorStyle ? {
      border: "1px solid red"
    } : {}
  }, /*#__PURE__*/React.createElement(TextField, {
    autoComplete: props.autoComplete,
    setFilter: setFilter,
    forceSet: forceSet,
    setforceSet: setforceSet,
    setOptionIndex: setOptionIndex,
    keepNull: props.keepNull,
    selectedVal: selectedOption ? props.t ? props.isMultiSelectEmp ? `${selectedOption} ${t("BPA_SELECTED_TEXT")}` : props.t(props.optionKey ? props.multiOptionKey ? `${selectedOption[props.multiOptionKey[0]]} - ${selectedOption[props.multiOptionKey[1]]}` : selectedOption[props.optionKey] : selectedOption) : props.optionKey ? selectedOption[props.optionKey] : selectedOption : null,
    filterVal: filterVal,
    addProps: {
      length: filteredOption.length,
      currentIndex: optionIndex,
      selectOption: selectOption
    },
    dropdownDisplay: dropdownOn,
    handleClick: handleClick,
    disable: props.disable,
    freeze: props.freeze ? true : false,
    autoFocus: props.autoFocus,
    placeholder: props.placeholder,
    onBlur: props === null || props === void 0 ? void 0 : props.onBlur,
    inputRef: props.ref
  }), /*#__PURE__*/React.createElement(ArrowDown, {
    onClick: dropdownSwitch,
    className: "cp",
    disable: props.disable
  })), dropdownStatus ? props.optionKey ? /*#__PURE__*/React.createElement(OptionsList, {
    props,
    optionIndex,
    filteredOption,
    hasCustomSelector,
    optionRef,
    onSelect
  }) : /*#__PURE__*/React.createElement("div", {
    className: "options-card",
    style: {
      ...props.optionCardStyles,
      overflow: "scroll",
      maxHeight: "350px"
    },
    id: "jk-dropdown-unique",
    ref: optionRef
  }, props.option.filter(option => (option === null || option === void 0 ? void 0 : option.toUpperCase().indexOf(filterVal === null || filterVal === void 0 ? void 0 : filterVal.toUpperCase())) > -1).map((option, index) => {
    return /*#__PURE__*/React.createElement("p", {
      key: index,
      style: index === optionIndex ? {
        opacity: 1,
        backgroundColor: "rgba(238, 238, 238, var(--bg-opacity))"
      } : {},
      onClick: () => onSelect(option)
    }, option);
  })) : null);
};
Dropdown.propTypes = {
  customSelector: propTypes.any,
  showArrow: propTypes.bool,
  selected: propTypes.any,
  style: propTypes.object,
  option: propTypes.array,
  optionKey: propTypes.any,
  select: propTypes.any,
  t: propTypes.func
};
Dropdown.defaultProps = {
  customSelector: null,
  showArrow: true
};

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React.createContext && React.createContext(DefaultContext);

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function (props) {
    return React.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return React.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? React.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

function RxLapTimer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 15 15",
      "fill": "none"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fillRule": "evenodd",
        "clipRule": "evenodd",
        "d": "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
        "fill": "currentColor"
      }
    }]
  })(props);
}

var sweetalert2_all = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    function _assertClassBrand(e, t, n) {
      if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
      throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
      if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
      return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
      _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
      return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    const globalState = {};
    const focusPreviousActiveElement = () => {
      if (globalState.previousActiveElement instanceof HTMLElement) {
        globalState.previousActiveElement.focus();
        globalState.previousActiveElement = null;
      } else if (document.body) {
        document.body.focus();
      }
    };
    const restoreActiveElement = returnFocus => {
      return new Promise(resolve => {
        if (!returnFocus) {
          return resolve();
        }
        const x = window.scrollX;
        const y = window.scrollY;
        globalState.restoreFocusTimeout = setTimeout(() => {
          focusPreviousActiveElement();
          resolve();
        }, RESTORE_FOCUS_TIMEOUT);
        window.scrollTo(x, y);
      });
    };
    const swalPrefix = 'swal2-';
    const classNames = ['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'show', 'hide', 'close', 'title', 'html-container', 'actions', 'confirm', 'deny', 'cancel', 'default-outline', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'input-label', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loader', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error'];
    const swalClasses = classNames.reduce((acc, className) => {
      acc[className] = swalPrefix + className;
      return acc;
    }, {});
    const icons = ['success', 'warning', 'info', 'question', 'error'];
    const iconTypes = icons.reduce((acc, icon) => {
      acc[icon] = swalPrefix + icon;
      return acc;
    }, {});
    const consolePrefix = 'SweetAlert2:';
    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);
    const warn = message => {
      console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    const error = message => {
      console.error(`${consolePrefix} ${message}`);
    };
    const previousWarnOnceMessages = [];
    const warnOnce = message => {
      if (!previousWarnOnceMessages.includes(message)) {
        previousWarnOnceMessages.push(message);
        warn(message);
      }
    };
    const warnAboutDeprecation = function (deprecatedParam) {
      let useInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    const callIfFunction = arg => typeof arg === 'function' ? arg() : arg;
    const hasToPromiseFn = arg => arg && typeof arg.toPromise === 'function';
    const asPromise = arg => hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    const isPromise = arg => arg && Promise.resolve(arg) === arg;
    const getContainer = () => document.body.querySelector(`.${swalClasses.container}`);
    const elementBySelector = selectorString => {
      const container = getContainer();
      return container ? container.querySelector(selectorString) : null;
    };
    const elementByClass = className => {
      return elementBySelector(`.${className}`);
    };
    const getPopup = () => elementByClass(swalClasses.popup);
    const getIcon = () => elementByClass(swalClasses.icon);
    const getIconContent = () => elementByClass(swalClasses['icon-content']);
    const getTitle = () => elementByClass(swalClasses.title);
    const getHtmlContainer = () => elementByClass(swalClasses['html-container']);
    const getImage = () => elementByClass(swalClasses.image);
    const getProgressSteps = () => elementByClass(swalClasses['progress-steps']);
    const getValidationMessage = () => elementByClass(swalClasses['validation-message']);
    const getConfirmButton = () => (elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`));
    const getCancelButton = () => (elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`));
    const getDenyButton = () => (elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`));
    const getInputLabel = () => elementByClass(swalClasses['input-label']);
    const getLoader = () => elementBySelector(`.${swalClasses.loader}`);
    const getActions = () => elementByClass(swalClasses.actions);
    const getFooter = () => elementByClass(swalClasses.footer);
    const getTimerProgressBar = () => elementByClass(swalClasses['timer-progress-bar']);
    const getCloseButton = () => elementByClass(swalClasses.close);
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    const getFocusableElements = () => {
      const popup = getPopup();
      if (!popup) {
        return [];
      }
      const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
      const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex).sort((a, b) => {
        const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
        const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
        if (tabindexA > tabindexB) {
          return 1;
        } else if (tabindexA < tabindexB) {
          return -1;
        }
        return 0;
      });
      const otherFocusableElements = popup.querySelectorAll(focusable);
      const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter(el => el.getAttribute('tabindex') !== '-1');
      return [...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))].filter(el => isVisible$1(el));
    };
    const isModal = () => {
      return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    const isToast = () => {
      const popup = getPopup();
      if (!popup) {
        return false;
      }
      return hasClass(popup, swalClasses.toast);
    };
    const isLoading = () => {
      const popup = getPopup();
      if (!popup) {
        return false;
      }
      return popup.hasAttribute('data-loading');
    };
    const setInnerHtml = (elem, html) => {
      elem.textContent = '';
      if (html) {
        const parser = new DOMParser();
        const parsed = parser.parseFromString(html, `text/html`);
        const head = parsed.querySelector('head');
        if (head) {
          Array.from(head.childNodes).forEach(child => {
            elem.appendChild(child);
          });
        }
        const body = parsed.querySelector('body');
        if (body) {
          Array.from(body.childNodes).forEach(child => {
            if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) {
              elem.appendChild(child.cloneNode(true));
            } else {
              elem.appendChild(child);
            }
          });
        }
      }
    };
    const hasClass = (elem, className) => {
      if (!className) {
        return false;
      }
      const classList = className.split(/\s+/);
      for (let i = 0; i < classList.length; i++) {
        if (!elem.classList.contains(classList[i])) {
          return false;
        }
      }
      return true;
    };
    const removeCustomClasses = (elem, params) => {
      Array.from(elem.classList).forEach(className => {
        if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) {
          elem.classList.remove(className);
        }
      });
    };
    const applyCustomClass = (elem, params, className) => {
      removeCustomClasses(elem, params);
      if (!params.customClass) {
        return;
      }
      const customClass = params.customClass[(className)];
      if (!customClass) {
        return;
      }
      if (typeof customClass !== 'string' && !customClass.forEach) {
        warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
        return;
      }
      addClass(elem, customClass);
    };
    const getInput$1 = (popup, inputClass) => {
      if (!inputClass) {
        return null;
      }
      switch (inputClass) {
        case 'select':
        case 'textarea':
        case 'file':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
        case 'checkbox':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
        case 'radio':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
        case 'range':
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
        default:
          return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
      }
    };
    const focusInput = input => {
      input.focus();
      if (input.type !== 'file') {
        const val = input.value;
        input.value = '';
        input.value = val;
      }
    };
    const toggleClass = (target, classList, condition) => {
      if (!target || !classList) {
        return;
      }
      if (typeof classList === 'string') {
        classList = classList.split(/\s+/).filter(Boolean);
      }
      classList.forEach(className => {
        if (Array.isArray(target)) {
          target.forEach(elem => {
            if (condition) {
              elem.classList.add(className);
            } else {
              elem.classList.remove(className);
            }
          });
        } else {
          if (condition) {
            target.classList.add(className);
          } else {
            target.classList.remove(className);
          }
        }
      });
    };
    const addClass = (target, classList) => {
      toggleClass(target, classList, true);
    };
    const removeClass = (target, classList) => {
      toggleClass(target, classList, false);
    };
    const getDirectChildByClass = (elem, className) => {
      const children = Array.from(elem.children);
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child instanceof HTMLElement && hasClass(child, className)) {
          return child;
        }
      }
    };
    const applyNumericalStyle = (elem, property, value) => {
      if (value === `${parseInt(value)}`) {
        value = parseInt(value);
      }
      if (value || parseInt(value) === 0) {
        elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : value);
      } else {
        elem.style.removeProperty(property);
      }
    };
    const show = function (elem) {
      let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
      if (!elem) {
        return;
      }
      elem.style.display = display;
    };
    const hide = elem => {
      if (!elem) {
        return;
      }
      elem.style.display = 'none';
    };
    const showWhenInnerHtmlPresent = function (elem) {
      let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
      if (!elem) {
        return;
      }
      new MutationObserver(() => {
        toggle(elem, elem.innerHTML, display);
      }).observe(elem, {
        childList: true,
        subtree: true
      });
    };
    const setStyle = (parent, selector, property, value) => {
      const el = parent.querySelector(selector);
      if (el) {
        el.style.setProperty(property, value);
      }
    };
    const toggle = function (elem, condition) {
      let display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';
      if (condition) {
        show(elem, display);
      } else {
        hide(elem);
      }
    };
    const isVisible$1 = elem => !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    const allButtonsAreHidden = () => !isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    const isScrollable = elem => !!(elem.scrollHeight > elem.clientHeight);
    const hasCssAnimation = elem => {
      const style = window.getComputedStyle(elem);
      const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
      const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
      return animDuration > 0 || transDuration > 0;
    };
    const animateTimerProgressBar = function (timer) {
      let reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const timerProgressBar = getTimerProgressBar();
      if (!timerProgressBar) {
        return;
      }
      if (isVisible$1(timerProgressBar)) {
        if (reset) {
          timerProgressBar.style.transition = 'none';
          timerProgressBar.style.width = '100%';
        }
        setTimeout(() => {
          timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
          timerProgressBar.style.width = '0%';
        }, 10);
      }
    };
    const stopTimerProgressBar = () => {
      const timerProgressBar = getTimerProgressBar();
      if (!timerProgressBar) {
        return;
      }
      const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
      timerProgressBar.style.removeProperty('transition');
      timerProgressBar.style.width = '100%';
      const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
      const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
      timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    const isNodeEnv = () => typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    const resetOldContainer = () => {
      const oldContainer = getContainer();
      if (!oldContainer) {
        return false;
      }
      oldContainer.remove();
      removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
      return true;
    };
    const resetValidationMessage$1 = () => {
      globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = () => {
      const popup = getPopup();
      const input = getDirectChildByClass(popup, swalClasses.input);
      const file = getDirectChildByClass(popup, swalClasses.file);
      const range = popup.querySelector(`.${swalClasses.range} input`);
      const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
      const select = getDirectChildByClass(popup, swalClasses.select);
      const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
      const textarea = getDirectChildByClass(popup, swalClasses.textarea);
      input.oninput = resetValidationMessage$1;
      file.onchange = resetValidationMessage$1;
      select.onchange = resetValidationMessage$1;
      checkbox.onchange = resetValidationMessage$1;
      textarea.oninput = resetValidationMessage$1;
      range.oninput = () => {
        resetValidationMessage$1();
        rangeOutput.value = range.value;
      };
      range.onchange = () => {
        resetValidationMessage$1();
        rangeOutput.value = range.value;
      };
    };
    const getTarget = target => typeof target === 'string' ? document.querySelector(target) : target;
    const setupAccessibility = params => {
      const popup = getPopup();
      popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
      popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
      if (!params.toast) {
        popup.setAttribute('aria-modal', 'true');
      }
    };
    const setupRTL = targetElement => {
      if (window.getComputedStyle(targetElement).direction === 'rtl') {
        addClass(getContainer(), swalClasses.rtl);
      }
    };
    const init = params => {
      const oldContainerExisted = resetOldContainer();
      if (isNodeEnv()) {
        error('SweetAlert2 requires document to initialize');
        return;
      }
      const container = document.createElement('div');
      container.className = swalClasses.container;
      if (oldContainerExisted) {
        addClass(container, swalClasses['no-transition']);
      }
      setInnerHtml(container, sweetHTML);
      const targetElement = getTarget(params.target);
      targetElement.appendChild(container);
      setupAccessibility(params);
      setupRTL(targetElement);
      addInputChangeListeners();
    };
    const parseHtmlToContainer = (param, target) => {
      if (param instanceof HTMLElement) {
        target.appendChild(param);
      } else if (typeof param === 'object') {
        handleObject(param, target);
      } else if (param) {
        setInnerHtml(target, param);
      }
    };
    const handleObject = (param, target) => {
      if (param.jquery) {
        handleJqueryElem(target, param);
      } else {
        setInnerHtml(target, param.toString());
      }
    };
    const handleJqueryElem = (target, elem) => {
      target.textContent = '';
      if (0 in elem) {
        for (let i = 0; i in elem; i++) {
          target.appendChild(elem[i].cloneNode(true));
        }
      } else {
        target.appendChild(elem.cloneNode(true));
      }
    };
    const animationEndEvent = (() => {
      if (isNodeEnv()) {
        return false;
      }
      const testEl = document.createElement('div');
      if (typeof testEl.style.webkitAnimation !== 'undefined') {
        return 'webkitAnimationEnd';
      }
      if (typeof testEl.style.animation !== 'undefined') {
        return 'animationend';
      }
      return false;
    })();
    const renderActions = (instance, params) => {
      const actions = getActions();
      const loader = getLoader();
      if (!actions || !loader) {
        return;
      }
      if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) {
        hide(actions);
      } else {
        show(actions);
      }
      applyCustomClass(actions, params, 'actions');
      renderButtons(actions, loader, params);
      setInnerHtml(loader, params.loaderHtml || '');
      applyCustomClass(loader, params, 'loader');
    };
    function renderButtons(actions, loader, params) {
      const confirmButton = getConfirmButton();
      const denyButton = getDenyButton();
      const cancelButton = getCancelButton();
      if (!confirmButton || !denyButton || !cancelButton) {
        return;
      }
      renderButton(confirmButton, 'confirm', params);
      renderButton(denyButton, 'deny', params);
      renderButton(cancelButton, 'cancel', params);
      handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
      if (params.reverseButtons) {
        if (params.toast) {
          actions.insertBefore(cancelButton, confirmButton);
          actions.insertBefore(denyButton, confirmButton);
        } else {
          actions.insertBefore(cancelButton, loader);
          actions.insertBefore(denyButton, loader);
          actions.insertBefore(confirmButton, loader);
        }
      }
    }
    function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
      if (!params.buttonsStyling) {
        removeClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
        return;
      }
      addClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
      if (params.confirmButtonColor) {
        confirmButton.style.backgroundColor = params.confirmButtonColor;
        addClass(confirmButton, swalClasses['default-outline']);
      }
      if (params.denyButtonColor) {
        denyButton.style.backgroundColor = params.denyButtonColor;
        addClass(denyButton, swalClasses['default-outline']);
      }
      if (params.cancelButtonColor) {
        cancelButton.style.backgroundColor = params.cancelButtonColor;
        addClass(cancelButton, swalClasses['default-outline']);
      }
    }
    function renderButton(button, buttonType, params) {
      const buttonName = capitalizeFirstLetter(buttonType);
      toggle(button, params[`show${buttonName}Button`], 'inline-block');
      setInnerHtml(button, params[`${buttonType}ButtonText`] || '');
      button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || '');
      button.className = swalClasses[buttonType];
      applyCustomClass(button, params, `${buttonType}Button`);
    }
    const renderCloseButton = (instance, params) => {
      const closeButton = getCloseButton();
      if (!closeButton) {
        return;
      }
      setInnerHtml(closeButton, params.closeButtonHtml || '');
      applyCustomClass(closeButton, params, 'closeButton');
      toggle(closeButton, params.showCloseButton);
      closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    const renderContainer = (instance, params) => {
      const container = getContainer();
      if (!container) {
        return;
      }
      handleBackdropParam(container, params.backdrop);
      handlePositionParam(container, params.position);
      handleGrowParam(container, params.grow);
      applyCustomClass(container, params, 'container');
    };
    function handleBackdropParam(container, backdrop) {
      if (typeof backdrop === 'string') {
        container.style.background = backdrop;
      } else if (!backdrop) {
        addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
      }
    }
    function handlePositionParam(container, position) {
      if (!position) {
        return;
      }
      if (position in swalClasses) {
        addClass(container, swalClasses[position]);
      } else {
        warn('The "position" parameter is not valid, defaulting to "center"');
        addClass(container, swalClasses.center);
      }
    }
    function handleGrowParam(container, grow) {
      if (!grow) {
        return;
      }
      addClass(container, swalClasses[`grow-${grow}`]);
    }
    var privateProps = {
      innerParams: new WeakMap(),
      domCache: new WeakMap()
    };
    const inputClasses = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
    const renderInput = (instance, params) => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const innerParams = privateProps.innerParams.get(instance);
      const rerender = !innerParams || params.input !== innerParams.input;
      inputClasses.forEach(inputClass => {
        const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
        if (!inputContainer) {
          return;
        }
        setAttributes(inputClass, params.inputAttributes);
        inputContainer.className = swalClasses[inputClass];
        if (rerender) {
          hide(inputContainer);
        }
      });
      if (params.input) {
        if (rerender) {
          showInput(params);
        }
        setCustomClass(params);
      }
    };
    const showInput = params => {
      if (!params.input) {
        return;
      }
      if (!renderInputType[params.input]) {
        error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
        return;
      }
      const inputContainer = getInputContainer(params.input);
      if (!inputContainer) {
        return;
      }
      const input = renderInputType[params.input](inputContainer, params);
      show(inputContainer);
      if (params.inputAutoFocus) {
        setTimeout(() => {
          focusInput(input);
        });
      }
    };
    const removeAttributes = input => {
      for (let i = 0; i < input.attributes.length; i++) {
        const attrName = input.attributes[i].name;
        if (!['id', 'type', 'value', 'style'].includes(attrName)) {
          input.removeAttribute(attrName);
        }
      }
    };
    const setAttributes = (inputClass, inputAttributes) => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const input = getInput$1(popup, inputClass);
      if (!input) {
        return;
      }
      removeAttributes(input);
      for (const attr in inputAttributes) {
        input.setAttribute(attr, inputAttributes[attr]);
      }
    };
    const setCustomClass = params => {
      if (!params.input) {
        return;
      }
      const inputContainer = getInputContainer(params.input);
      if (inputContainer) {
        applyCustomClass(inputContainer, params, 'input');
      }
    };
    const setInputPlaceholder = (input, params) => {
      if (!input.placeholder && params.inputPlaceholder) {
        input.placeholder = params.inputPlaceholder;
      }
    };
    const setInputLabel = (input, prependTo, params) => {
      if (params.inputLabel) {
        const label = document.createElement('label');
        const labelClass = swalClasses['input-label'];
        label.setAttribute('for', input.id);
        label.className = labelClass;
        if (typeof params.customClass === 'object') {
          addClass(label, params.customClass.inputLabel);
        }
        label.innerText = params.inputLabel;
        prependTo.insertAdjacentElement('beforebegin', label);
      }
    };
    const getInputContainer = inputType => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      return getDirectChildByClass(popup, swalClasses[(inputType)] || swalClasses.input);
    };
    const checkAndSetInputValue = (input, inputValue) => {
      if (['string', 'number'].includes(typeof inputValue)) {
        input.value = `${inputValue}`;
      } else if (!isPromise(inputValue)) {
        warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
      }
    };
    const renderInputType = {};
    renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = (input, params) => {
      checkAndSetInputValue(input, params.inputValue);
      setInputLabel(input, input, params);
      setInputPlaceholder(input, params);
      input.type = params.input;
      return input;
    };
    renderInputType.file = (input, params) => {
      setInputLabel(input, input, params);
      setInputPlaceholder(input, params);
      return input;
    };
    renderInputType.range = (range, params) => {
      const rangeInput = range.querySelector('input');
      const rangeOutput = range.querySelector('output');
      checkAndSetInputValue(rangeInput, params.inputValue);
      rangeInput.type = params.input;
      checkAndSetInputValue(rangeOutput, params.inputValue);
      setInputLabel(rangeInput, range, params);
      return range;
    };
    renderInputType.select = (select, params) => {
      select.textContent = '';
      if (params.inputPlaceholder) {
        const placeholder = document.createElement('option');
        setInnerHtml(placeholder, params.inputPlaceholder);
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);
      }
      setInputLabel(select, select, params);
      return select;
    };
    renderInputType.radio = radio => {
      radio.textContent = '';
      return radio;
    };
    renderInputType.checkbox = (checkboxContainer, params) => {
      const checkbox = getInput$1(getPopup(), 'checkbox');
      checkbox.value = '1';
      checkbox.checked = Boolean(params.inputValue);
      const label = checkboxContainer.querySelector('span');
      setInnerHtml(label, params.inputPlaceholder || params.inputLabel);
      return checkbox;
    };
    renderInputType.textarea = (textarea, params) => {
      checkAndSetInputValue(textarea, params.inputValue);
      setInputPlaceholder(textarea, params);
      setInputLabel(textarea, textarea, params);
      const getMargin = el => parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
      setTimeout(() => {
        if ('MutationObserver' in window) {
          const initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
          const textareaResizeHandler = () => {
            if (!document.body.contains(textarea)) {
              return;
            }
            const textareaWidth = textarea.offsetWidth + getMargin(textarea);
            if (textareaWidth > initialPopupWidth) {
              getPopup().style.width = `${textareaWidth}px`;
            } else {
              applyNumericalStyle(getPopup(), 'width', params.width);
            }
          };
          new MutationObserver(textareaResizeHandler).observe(textarea, {
            attributes: true,
            attributeFilter: ['style']
          });
        }
      });
      return textarea;
    };
    const renderContent = (instance, params) => {
      const htmlContainer = getHtmlContainer();
      if (!htmlContainer) {
        return;
      }
      showWhenInnerHtmlPresent(htmlContainer);
      applyCustomClass(htmlContainer, params, 'htmlContainer');
      if (params.html) {
        parseHtmlToContainer(params.html, htmlContainer);
        show(htmlContainer, 'block');
      } else if (params.text) {
        htmlContainer.textContent = params.text;
        show(htmlContainer, 'block');
      } else {
        hide(htmlContainer);
      }
      renderInput(instance, params);
    };
    const renderFooter = (instance, params) => {
      const footer = getFooter();
      if (!footer) {
        return;
      }
      showWhenInnerHtmlPresent(footer);
      toggle(footer, params.footer, 'block');
      if (params.footer) {
        parseHtmlToContainer(params.footer, footer);
      }
      applyCustomClass(footer, params, 'footer');
    };
    const renderIcon = (instance, params) => {
      const innerParams = privateProps.innerParams.get(instance);
      const icon = getIcon();
      if (!icon) {
        return;
      }
      if (innerParams && params.icon === innerParams.icon) {
        setContent(icon, params);
        applyStyles(icon, params);
        return;
      }
      if (!params.icon && !params.iconHtml) {
        hide(icon);
        return;
      }
      if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
        error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
        hide(icon);
        return;
      }
      show(icon);
      setContent(icon, params);
      applyStyles(icon, params);
      addClass(icon, params.showClass && params.showClass.icon);
    };
    const applyStyles = (icon, params) => {
      for (const [iconType, iconClassName] of Object.entries(iconTypes)) {
        if (params.icon !== iconType) {
          removeClass(icon, iconClassName);
        }
      }
      addClass(icon, params.icon && iconTypes[params.icon]);
      setColor(icon, params);
      adjustSuccessIconBackgroundColor();
      applyCustomClass(icon, params, 'icon');
    };
    const adjustSuccessIconBackgroundColor = () => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
      const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
      for (let i = 0; i < successIconParts.length; i++) {
        successIconParts[i].style.backgroundColor = popupBackgroundColor;
      }
    };
    const successIconHtml = `
  <div class="swal2-success-circular-line-left"></div>
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>
  <div class="swal2-success-circular-line-right"></div>
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    const setContent = (icon, params) => {
      if (!params.icon && !params.iconHtml) {
        return;
      }
      let oldContent = icon.innerHTML;
      let newContent = '';
      if (params.iconHtml) {
        newContent = iconContent(params.iconHtml);
      } else if (params.icon === 'success') {
        newContent = successIconHtml;
        oldContent = oldContent.replace(/ style=".*?"/g, '');
      } else if (params.icon === 'error') {
        newContent = errorIconHtml;
      } else if (params.icon) {
        const defaultIconHtml = {
          question: '?',
          warning: '!',
          info: 'i'
        };
        newContent = iconContent(defaultIconHtml[params.icon]);
      }
      if (oldContent.trim() !== newContent.trim()) {
        setInnerHtml(icon, newContent);
      }
    };
    const setColor = (icon, params) => {
      if (!params.iconColor) {
        return;
      }
      icon.style.color = params.iconColor;
      icon.style.borderColor = params.iconColor;
      for (const sel of ['.swal2-success-line-tip', '.swal2-success-line-long', '.swal2-x-mark-line-left', '.swal2-x-mark-line-right']) {
        setStyle(icon, sel, 'background-color', params.iconColor);
      }
      setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    const iconContent = content => `<div class="${swalClasses['icon-content']}">${content}</div>`;
    const renderImage = (instance, params) => {
      const image = getImage();
      if (!image) {
        return;
      }
      if (!params.imageUrl) {
        hide(image);
        return;
      }
      show(image, '');
      image.setAttribute('src', params.imageUrl);
      image.setAttribute('alt', params.imageAlt || '');
      applyNumericalStyle(image, 'width', params.imageWidth);
      applyNumericalStyle(image, 'height', params.imageHeight);
      image.className = swalClasses.image;
      applyCustomClass(image, params, 'image');
    };
    const renderPopup = (instance, params) => {
      const container = getContainer();
      const popup = getPopup();
      if (!container || !popup) {
        return;
      }
      if (params.toast) {
        applyNumericalStyle(container, 'width', params.width);
        popup.style.width = '100%';
        const loader = getLoader();
        if (loader) {
          popup.insertBefore(loader, getIcon());
        }
      } else {
        applyNumericalStyle(popup, 'width', params.width);
      }
      applyNumericalStyle(popup, 'padding', params.padding);
      if (params.color) {
        popup.style.color = params.color;
      }
      if (params.background) {
        popup.style.background = params.background;
      }
      hide(getValidationMessage());
      addClasses$1(popup, params);
    };
    const addClasses$1 = (popup, params) => {
      const showClass = params.showClass || {};
      popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
      if (params.toast) {
        addClass([document.documentElement, document.body], swalClasses['toast-shown']);
        addClass(popup, swalClasses.toast);
      } else {
        addClass(popup, swalClasses.modal);
      }
      applyCustomClass(popup, params, 'popup');
      if (typeof params.customClass === 'string') {
        addClass(popup, params.customClass);
      }
      if (params.icon) {
        addClass(popup, swalClasses[`icon-${params.icon}`]);
      }
    };
    const renderProgressSteps = (instance, params) => {
      const progressStepsContainer = getProgressSteps();
      if (!progressStepsContainer) {
        return;
      }
      const {
        progressSteps,
        currentProgressStep
      } = params;
      if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
        hide(progressStepsContainer);
        return;
      }
      show(progressStepsContainer);
      progressStepsContainer.textContent = '';
      if (currentProgressStep >= progressSteps.length) {
        warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
      }
      progressSteps.forEach((step, index) => {
        const stepEl = createStepElement(step);
        progressStepsContainer.appendChild(stepEl);
        if (index === currentProgressStep) {
          addClass(stepEl, swalClasses['active-progress-step']);
        }
        if (index !== progressSteps.length - 1) {
          const lineEl = createLineElement(params);
          progressStepsContainer.appendChild(lineEl);
        }
      });
    };
    const createStepElement = step => {
      const stepEl = document.createElement('li');
      addClass(stepEl, swalClasses['progress-step']);
      setInnerHtml(stepEl, step);
      return stepEl;
    };
    const createLineElement = params => {
      const lineEl = document.createElement('li');
      addClass(lineEl, swalClasses['progress-step-line']);
      if (params.progressStepsDistance) {
        applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
      }
      return lineEl;
    };
    const renderTitle = (instance, params) => {
      const title = getTitle();
      if (!title) {
        return;
      }
      showWhenInnerHtmlPresent(title);
      toggle(title, params.title || params.titleText, 'block');
      if (params.title) {
        parseHtmlToContainer(params.title, title);
      }
      if (params.titleText) {
        title.innerText = params.titleText;
      }
      applyCustomClass(title, params, 'title');
    };
    const render = (instance, params) => {
      renderPopup(instance, params);
      renderContainer(instance, params);
      renderProgressSteps(instance, params);
      renderIcon(instance, params);
      renderImage(instance, params);
      renderTitle(instance, params);
      renderCloseButton(instance, params);
      renderContent(instance, params);
      renderActions(instance, params);
      renderFooter(instance, params);
      const popup = getPopup();
      if (typeof params.didRender === 'function' && popup) {
        params.didRender(popup);
      }
      globalState.eventEmitter.emit('didRender', popup);
    };
    const isVisible = () => {
      return isVisible$1(getPopup());
    };
    const clickConfirm = () => {
      var _dom$getConfirmButton;
      return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    const clickDeny = () => {
      var _dom$getDenyButton;
      return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    const clickCancel = () => {
      var _dom$getCancelButton;
      return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    const DismissReason = Object.freeze({
      cancel: 'cancel',
      backdrop: 'backdrop',
      close: 'close',
      esc: 'esc',
      timer: 'timer'
    });
    const removeKeydownHandler = globalState => {
      if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
        globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
          capture: globalState.keydownListenerCapture
        });
        globalState.keydownHandlerAdded = false;
      }
    };
    const addKeydownHandler = (globalState, innerParams, dismissWith) => {
      removeKeydownHandler(globalState);
      if (!innerParams.toast) {
        globalState.keydownHandler = e => keydownHandler(innerParams, e, dismissWith);
        globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
        globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
        globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
          capture: globalState.keydownListenerCapture
        });
        globalState.keydownHandlerAdded = true;
      }
    };
    const setFocus = (index, increment) => {
      var _dom$getPopup;
      const focusableElements = getFocusableElements();
      if (focusableElements.length) {
        index = index + increment;
        if (index === focusableElements.length) {
          index = 0;
        } else if (index === -1) {
          index = focusableElements.length - 1;
        }
        focusableElements[index].focus();
        return;
      }
      (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    const arrowKeysNextButton = ['ArrowRight', 'ArrowDown'];
    const arrowKeysPreviousButton = ['ArrowLeft', 'ArrowUp'];
    const keydownHandler = (innerParams, event, dismissWith) => {
      if (!innerParams) {
        return;
      }
      if (event.isComposing || event.keyCode === 229) {
        return;
      }
      if (innerParams.stopKeydownPropagation) {
        event.stopPropagation();
      }
      if (event.key === 'Enter') {
        handleEnter(event, innerParams);
      } else if (event.key === 'Tab') {
        handleTab(event);
      } else if ([...arrowKeysNextButton, ...arrowKeysPreviousButton].includes(event.key)) {
        handleArrows(event.key);
      } else if (event.key === 'Escape') {
        handleEsc(event, innerParams, dismissWith);
      }
    };
    const handleEnter = (event, innerParams) => {
      if (!callIfFunction(innerParams.allowEnterKey)) {
        return;
      }
      const input = getInput$1(getPopup(), innerParams.input);
      if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
        if (['textarea', 'file'].includes(innerParams.input)) {
          return;
        }
        clickConfirm();
        event.preventDefault();
      }
    };
    const handleTab = event => {
      const targetElement = event.target;
      const focusableElements = getFocusableElements();
      let btnIndex = -1;
      for (let i = 0; i < focusableElements.length; i++) {
        if (targetElement === focusableElements[i]) {
          btnIndex = i;
          break;
        }
      }
      if (!event.shiftKey) {
        setFocus(btnIndex, 1);
      } else {
        setFocus(btnIndex, -1);
      }
      event.stopPropagation();
      event.preventDefault();
    };
    const handleArrows = key => {
      const actions = getActions();
      const confirmButton = getConfirmButton();
      const denyButton = getDenyButton();
      const cancelButton = getCancelButton();
      if (!actions || !confirmButton || !denyButton || !cancelButton) {
        return;
      }
      const buttons = [confirmButton, denyButton, cancelButton];
      if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) {
        return;
      }
      const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
      let buttonToFocus = document.activeElement;
      if (!buttonToFocus) {
        return;
      }
      for (let i = 0; i < actions.children.length; i++) {
        buttonToFocus = buttonToFocus[sibling];
        if (!buttonToFocus) {
          return;
        }
        if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) {
          break;
        }
      }
      if (buttonToFocus instanceof HTMLButtonElement) {
        buttonToFocus.focus();
      }
    };
    const handleEsc = (event, innerParams, dismissWith) => {
      if (callIfFunction(innerParams.allowEscapeKey)) {
        event.preventDefault();
        dismissWith(DismissReason.esc);
      }
    };
    var privateMethods = {
      swalPromiseResolve: new WeakMap(),
      swalPromiseReject: new WeakMap()
    };
    const setAriaHidden = () => {
      const container = getContainer();
      const bodyChildren = Array.from(document.body.children);
      bodyChildren.forEach(el => {
        if (el.contains(container)) {
          return;
        }
        if (el.hasAttribute('aria-hidden')) {
          el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
        }
        el.setAttribute('aria-hidden', 'true');
      });
    };
    const unsetAriaHidden = () => {
      const bodyChildren = Array.from(document.body.children);
      bodyChildren.forEach(el => {
        if (el.hasAttribute('data-previous-aria-hidden')) {
          el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
          el.removeAttribute('data-previous-aria-hidden');
        } else {
          el.removeAttribute('aria-hidden');
        }
      });
    };
    const isSafariOrIOS = typeof window !== 'undefined' && !!window.GestureEvent;
    const iOSfix = () => {
      if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
        const offset = document.body.scrollTop;
        document.body.style.top = `${offset * -1}px`;
        addClass(document.body, swalClasses.iosfix);
        lockBodyScroll();
      }
    };
    const lockBodyScroll = () => {
      const container = getContainer();
      if (!container) {
        return;
      }
      let preventTouchMove;
      container.ontouchstart = event => {
        preventTouchMove = shouldPreventTouchMove(event);
      };
      container.ontouchmove = event => {
        if (preventTouchMove) {
          event.preventDefault();
          event.stopPropagation();
        }
      };
    };
    const shouldPreventTouchMove = event => {
      const target = event.target;
      const container = getContainer();
      const htmlContainer = getHtmlContainer();
      if (!container || !htmlContainer) {
        return false;
      }
      if (isStylus(event) || isZoom(event)) {
        return false;
      }
      if (target === container) {
        return true;
      }
      if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA' && !(isScrollable(htmlContainer) && htmlContainer.contains(target))) {
        return true;
      }
      return false;
    };
    const isStylus = event => {
      return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
    };
    const isZoom = event => {
      return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = () => {
      if (hasClass(document.body, swalClasses.iosfix)) {
        const offset = parseInt(document.body.style.top, 10);
        removeClass(document.body, swalClasses.iosfix);
        document.body.style.top = '';
        document.body.scrollTop = offset * -1;
      }
    };
    const measureScrollbar = () => {
      const scrollDiv = document.createElement('div');
      scrollDiv.className = swalClasses['scrollbar-measure'];
      document.body.appendChild(scrollDiv);
      const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    };
    let previousBodyPadding = null;
    const replaceScrollbarWithPadding = initialBodyOverflow => {
      if (previousBodyPadding !== null) {
        return;
      }
      if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll') {
        previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
        document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
      }
    };
    const undoReplaceScrollbarWithPadding = () => {
      if (previousBodyPadding !== null) {
        document.body.style.paddingRight = `${previousBodyPadding}px`;
        previousBodyPadding = null;
      }
    };
    function removePopupAndResetState(instance, container, returnFocus, didClose) {
      if (isToast()) {
        triggerDidCloseAndDispose(instance, didClose);
      } else {
        restoreActiveElement(returnFocus).then(() => triggerDidCloseAndDispose(instance, didClose));
        removeKeydownHandler(globalState);
      }
      if (isSafariOrIOS) {
        container.setAttribute('style', 'display:none !important');
        container.removeAttribute('class');
        container.innerHTML = '';
      } else {
        container.remove();
      }
      if (isModal()) {
        undoReplaceScrollbarWithPadding();
        undoIOSfix();
        unsetAriaHidden();
      }
      removeBodyClasses();
    }
    function removeBodyClasses() {
      removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown']]);
    }
    function close(resolveValue) {
      resolveValue = prepareResolveValue(resolveValue);
      const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
      const didClose = triggerClosePopup(this);
      if (this.isAwaitingPromise) {
        if (!resolveValue.isDismissed) {
          handleAwaitingPromise(this);
          swalPromiseResolve(resolveValue);
        }
      } else if (didClose) {
        swalPromiseResolve(resolveValue);
      }
    }
    const triggerClosePopup = instance => {
      const popup = getPopup();
      if (!popup) {
        return false;
      }
      const innerParams = privateProps.innerParams.get(instance);
      if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
        return false;
      }
      removeClass(popup, innerParams.showClass.popup);
      addClass(popup, innerParams.hideClass.popup);
      const backdrop = getContainer();
      removeClass(backdrop, innerParams.showClass.backdrop);
      addClass(backdrop, innerParams.hideClass.backdrop);
      handlePopupAnimation(instance, popup, innerParams);
      return true;
    };
    function rejectPromise(error) {
      const rejectPromise = privateMethods.swalPromiseReject.get(this);
      handleAwaitingPromise(this);
      if (rejectPromise) {
        rejectPromise(error);
      }
    }
    const handleAwaitingPromise = instance => {
      if (instance.isAwaitingPromise) {
        delete instance.isAwaitingPromise;
        if (!privateProps.innerParams.get(instance)) {
          instance._destroy();
        }
      }
    };
    const prepareResolveValue = resolveValue => {
      if (typeof resolveValue === 'undefined') {
        return {
          isConfirmed: false,
          isDenied: false,
          isDismissed: true
        };
      }
      return Object.assign({
        isConfirmed: false,
        isDenied: false,
        isDismissed: false
      }, resolveValue);
    };
    const handlePopupAnimation = (instance, popup, innerParams) => {
      const container = getContainer();
      const animationIsSupported = animationEndEvent && hasCssAnimation(popup);
      if (typeof innerParams.willClose === 'function') {
        innerParams.willClose(popup);
      }
      globalState.eventEmitter.emit('willClose', popup);
      if (animationIsSupported) {
        animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
      } else {
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
      }
    };
    const animatePopup = (instance, popup, container, returnFocus, didClose) => {
      if (!animationEndEvent) {
        return;
      }
      globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
      popup.addEventListener(animationEndEvent, function (e) {
        if (e.target === popup) {
          globalState.swalCloseEventFinishedCallback();
          delete globalState.swalCloseEventFinishedCallback;
        }
      });
    };
    const triggerDidCloseAndDispose = (instance, didClose) => {
      setTimeout(() => {
        if (typeof didClose === 'function') {
          didClose.bind(instance.params)();
        }
        globalState.eventEmitter.emit('didClose');
        if (instance._destroy) {
          instance._destroy();
        }
      });
    };
    const showLoading = buttonToReplace => {
      let popup = getPopup();
      if (!popup) {
        new Swal();
      }
      popup = getPopup();
      if (!popup) {
        return;
      }
      const loader = getLoader();
      if (isToast()) {
        hide(getIcon());
      } else {
        replaceButton(popup, buttonToReplace);
      }
      show(loader);
      popup.setAttribute('data-loading', 'true');
      popup.setAttribute('aria-busy', 'true');
      popup.focus();
    };
    const replaceButton = (popup, buttonToReplace) => {
      const actions = getActions();
      const loader = getLoader();
      if (!actions || !loader) {
        return;
      }
      if (!buttonToReplace && isVisible$1(getConfirmButton())) {
        buttonToReplace = getConfirmButton();
      }
      show(actions);
      if (buttonToReplace) {
        hide(buttonToReplace);
        loader.setAttribute('data-button-to-replace', buttonToReplace.className);
        actions.insertBefore(loader, buttonToReplace);
      }
      addClass([popup, actions], swalClasses.loading);
    };
    const handleInputOptionsAndValue = (instance, params) => {
      if (params.input === 'select' || params.input === 'radio') {
        handleInputOptions(instance, params);
      } else if (['text', 'email', 'number', 'tel', 'textarea'].some(i => i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
        showLoading(getConfirmButton());
        handleInputValue(instance, params);
      }
    };
    const getInputValue = (instance, innerParams) => {
      const input = instance.getInput();
      if (!input) {
        return null;
      }
      switch (innerParams.input) {
        case 'checkbox':
          return getCheckboxValue(input);
        case 'radio':
          return getRadioValue(input);
        case 'file':
          return getFileValue(input);
        default:
          return innerParams.inputAutoTrim ? input.value.trim() : input.value;
      }
    };
    const getCheckboxValue = input => input.checked ? 1 : 0;
    const getRadioValue = input => input.checked ? input.value : null;
    const getFileValue = input => input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    const handleInputOptions = (instance, params) => {
      const popup = getPopup();
      if (!popup) {
        return;
      }
      const processInputOptions = inputOptions => {
        if (params.input === 'select') {
          populateSelectOptions(popup, formatInputOptions(inputOptions), params);
        } else if (params.input === 'radio') {
          populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        }
      };
      if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
        showLoading(getConfirmButton());
        asPromise(params.inputOptions).then(inputOptions => {
          instance.hideLoading();
          processInputOptions(inputOptions);
        });
      } else if (typeof params.inputOptions === 'object') {
        processInputOptions(params.inputOptions);
      } else {
        error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
      }
    };
    const handleInputValue = (instance, params) => {
      const input = instance.getInput();
      if (!input) {
        return;
      }
      hide(input);
      asPromise(params.inputValue).then(inputValue => {
        input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
        show(input);
        input.focus();
        instance.hideLoading();
      }).catch(err => {
        error(`Error in inputValue promise: ${err}`);
        input.value = '';
        show(input);
        input.focus();
        instance.hideLoading();
      });
    };
    function populateSelectOptions(popup, inputOptions, params) {
      const select = getDirectChildByClass(popup, swalClasses.select);
      if (!select) {
        return;
      }
      const renderOption = (parent, optionLabel, optionValue) => {
        const option = document.createElement('option');
        option.value = optionValue;
        setInnerHtml(option, optionLabel);
        option.selected = isSelected(optionValue, params.inputValue);
        parent.appendChild(option);
      };
      inputOptions.forEach(inputOption => {
        const optionValue = inputOption[0];
        const optionLabel = inputOption[1];
        if (Array.isArray(optionLabel)) {
          const optgroup = document.createElement('optgroup');
          optgroup.label = optionValue;
          optgroup.disabled = false;
          select.appendChild(optgroup);
          optionLabel.forEach(o => renderOption(optgroup, o[1], o[0]));
        } else {
          renderOption(select, optionLabel, optionValue);
        }
      });
      select.focus();
    }
    function populateRadioOptions(popup, inputOptions, params) {
      const radio = getDirectChildByClass(popup, swalClasses.radio);
      if (!radio) {
        return;
      }
      inputOptions.forEach(inputOption => {
        const radioValue = inputOption[0];
        const radioLabel = inputOption[1];
        const radioInput = document.createElement('input');
        const radioLabelElement = document.createElement('label');
        radioInput.type = 'radio';
        radioInput.name = swalClasses.radio;
        radioInput.value = radioValue;
        if (isSelected(radioValue, params.inputValue)) {
          radioInput.checked = true;
        }
        const label = document.createElement('span');
        setInnerHtml(label, radioLabel);
        label.className = swalClasses.label;
        radioLabelElement.appendChild(radioInput);
        radioLabelElement.appendChild(label);
        radio.appendChild(radioLabelElement);
      });
      const radios = radio.querySelectorAll('input');
      if (radios.length) {
        radios[0].focus();
      }
    }
    const formatInputOptions = inputOptions => {
      const result = [];
      if (inputOptions instanceof Map) {
        inputOptions.forEach((value, key) => {
          let valueFormatted = value;
          if (typeof valueFormatted === 'object') {
            valueFormatted = formatInputOptions(valueFormatted);
          }
          result.push([key, valueFormatted]);
        });
      } else {
        Object.keys(inputOptions).forEach(key => {
          let valueFormatted = inputOptions[key];
          if (typeof valueFormatted === 'object') {
            valueFormatted = formatInputOptions(valueFormatted);
          }
          result.push([key, valueFormatted]);
        });
      }
      return result;
    };
    const isSelected = (optionValue, inputValue) => {
      return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    const handleConfirmButtonClick = instance => {
      const innerParams = privateProps.innerParams.get(instance);
      instance.disableButtons();
      if (innerParams.input) {
        handleConfirmOrDenyWithInput(instance, 'confirm');
      } else {
        confirm(instance, true);
      }
    };
    const handleDenyButtonClick = instance => {
      const innerParams = privateProps.innerParams.get(instance);
      instance.disableButtons();
      if (innerParams.returnInputValueOnDeny) {
        handleConfirmOrDenyWithInput(instance, 'deny');
      } else {
        deny(instance, false);
      }
    };
    const handleCancelButtonClick = (instance, dismissWith) => {
      instance.disableButtons();
      dismissWith(DismissReason.cancel);
    };
    const handleConfirmOrDenyWithInput = (instance, type) => {
      const innerParams = privateProps.innerParams.get(instance);
      if (!innerParams.input) {
        error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
        return;
      }
      const input = instance.getInput();
      const inputValue = getInputValue(instance, innerParams);
      if (innerParams.inputValidator) {
        handleInputValidator(instance, inputValue, type);
      } else if (input && !input.checkValidity()) {
        instance.enableButtons();
        instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
      } else if (type === 'deny') {
        deny(instance, inputValue);
      } else {
        confirm(instance, inputValue);
      }
    };
    const handleInputValidator = (instance, inputValue, type) => {
      const innerParams = privateProps.innerParams.get(instance);
      instance.disableInput();
      const validationPromise = Promise.resolve().then(() => asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
      validationPromise.then(validationMessage => {
        instance.enableButtons();
        instance.enableInput();
        if (validationMessage) {
          instance.showValidationMessage(validationMessage);
        } else if (type === 'deny') {
          deny(instance, inputValue);
        } else {
          confirm(instance, inputValue);
        }
      });
    };
    const deny = (instance, value) => {
      const innerParams = privateProps.innerParams.get(instance || undefined);
      if (innerParams.showLoaderOnDeny) {
        showLoading(getDenyButton());
      }
      if (innerParams.preDeny) {
        instance.isAwaitingPromise = true;
        const preDenyPromise = Promise.resolve().then(() => asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
        preDenyPromise.then(preDenyValue => {
          if (preDenyValue === false) {
            instance.hideLoading();
            handleAwaitingPromise(instance);
          } else {
            instance.close({
              isDenied: true,
              value: typeof preDenyValue === 'undefined' ? value : preDenyValue
            });
          }
        }).catch(error => rejectWith(instance || undefined, error));
      } else {
        instance.close({
          isDenied: true,
          value
        });
      }
    };
    const succeedWith = (instance, value) => {
      instance.close({
        isConfirmed: true,
        value
      });
    };
    const rejectWith = (instance, error) => {
      instance.rejectPromise(error);
    };
    const confirm = (instance, value) => {
      const innerParams = privateProps.innerParams.get(instance || undefined);
      if (innerParams.showLoaderOnConfirm) {
        showLoading();
      }
      if (innerParams.preConfirm) {
        instance.resetValidationMessage();
        instance.isAwaitingPromise = true;
        const preConfirmPromise = Promise.resolve().then(() => asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
        preConfirmPromise.then(preConfirmValue => {
          if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
            instance.hideLoading();
            handleAwaitingPromise(instance);
          } else {
            succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
          }
        }).catch(error => rejectWith(instance || undefined, error));
      } else {
        succeedWith(instance, value);
      }
    };
    function hideLoading() {
      const innerParams = privateProps.innerParams.get(this);
      if (!innerParams) {
        return;
      }
      const domCache = privateProps.domCache.get(this);
      hide(domCache.loader);
      if (isToast()) {
        if (innerParams.icon) {
          show(getIcon());
        }
      } else {
        showRelatedButton(domCache);
      }
      removeClass([domCache.popup, domCache.actions], swalClasses.loading);
      domCache.popup.removeAttribute('aria-busy');
      domCache.popup.removeAttribute('data-loading');
      domCache.confirmButton.disabled = false;
      domCache.denyButton.disabled = false;
      domCache.cancelButton.disabled = false;
    }
    const showRelatedButton = domCache => {
      const buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
      if (buttonToReplace.length) {
        show(buttonToReplace[0], 'inline-block');
      } else if (allButtonsAreHidden()) {
        hide(domCache.actions);
      }
    };
    function getInput() {
      const innerParams = privateProps.innerParams.get(this);
      const domCache = privateProps.domCache.get(this);
      if (!domCache) {
        return null;
      }
      return getInput$1(domCache.popup, innerParams.input);
    }
    function setButtonsDisabled(instance, buttons, disabled) {
      const domCache = privateProps.domCache.get(instance);
      buttons.forEach(button => {
        domCache[button].disabled = disabled;
      });
    }
    function setInputDisabled(input, disabled) {
      const popup = getPopup();
      if (!popup || !input) {
        return;
      }
      if (input.type === 'radio') {
        const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
        for (let i = 0; i < radios.length; i++) {
          radios[i].disabled = disabled;
        }
      } else {
        input.disabled = disabled;
      }
    }
    function enableButtons() {
      setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], false);
    }
    function disableButtons() {
      setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], true);
    }
    function enableInput() {
      setInputDisabled(this.getInput(), false);
    }
    function disableInput() {
      setInputDisabled(this.getInput(), true);
    }
    function showValidationMessage(error) {
      const domCache = privateProps.domCache.get(this);
      const params = privateProps.innerParams.get(this);
      setInnerHtml(domCache.validationMessage, error);
      domCache.validationMessage.className = swalClasses['validation-message'];
      if (params.customClass && params.customClass.validationMessage) {
        addClass(domCache.validationMessage, params.customClass.validationMessage);
      }
      show(domCache.validationMessage);
      const input = this.getInput();
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', swalClasses['validation-message']);
        focusInput(input);
        addClass(input, swalClasses.inputerror);
      }
    }
    function resetValidationMessage() {
      const domCache = privateProps.domCache.get(this);
      if (domCache.validationMessage) {
        hide(domCache.validationMessage);
      }
      const input = this.getInput();
      if (input) {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        removeClass(input, swalClasses.inputerror);
      }
    }
    const defaultParams = {
      title: '',
      titleText: '',
      text: '',
      html: '',
      footer: '',
      icon: undefined,
      iconColor: undefined,
      iconHtml: undefined,
      template: undefined,
      toast: false,
      animation: true,
      showClass: {
        popup: 'swal2-show',
        backdrop: 'swal2-backdrop-show',
        icon: 'swal2-icon-show'
      },
      hideClass: {
        popup: 'swal2-hide',
        backdrop: 'swal2-backdrop-hide',
        icon: 'swal2-icon-hide'
      },
      customClass: {},
      target: 'body',
      color: undefined,
      backdrop: true,
      heightAuto: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: true,
      stopKeydownPropagation: true,
      keydownListenerCapture: false,
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: false,
      preConfirm: undefined,
      preDeny: undefined,
      confirmButtonText: 'OK',
      confirmButtonAriaLabel: '',
      confirmButtonColor: undefined,
      denyButtonText: 'No',
      denyButtonAriaLabel: '',
      denyButtonColor: undefined,
      cancelButtonText: 'Cancel',
      cancelButtonAriaLabel: '',
      cancelButtonColor: undefined,
      buttonsStyling: true,
      reverseButtons: false,
      focusConfirm: true,
      focusDeny: false,
      focusCancel: false,
      returnFocus: true,
      showCloseButton: false,
      closeButtonHtml: '&times;',
      closeButtonAriaLabel: 'Close this dialog',
      loaderHtml: '',
      showLoaderOnConfirm: false,
      showLoaderOnDeny: false,
      imageUrl: undefined,
      imageWidth: undefined,
      imageHeight: undefined,
      imageAlt: '',
      timer: undefined,
      timerProgressBar: false,
      width: undefined,
      padding: undefined,
      background: undefined,
      input: undefined,
      inputPlaceholder: '',
      inputLabel: '',
      inputValue: '',
      inputOptions: {},
      inputAutoFocus: true,
      inputAutoTrim: true,
      inputAttributes: {},
      inputValidator: undefined,
      returnInputValueOnDeny: false,
      validationMessage: undefined,
      grow: false,
      position: 'center',
      progressSteps: [],
      currentProgressStep: undefined,
      progressStepsDistance: undefined,
      willOpen: undefined,
      didOpen: undefined,
      didRender: undefined,
      willClose: undefined,
      didClose: undefined,
      didDestroy: undefined,
      scrollbarPadding: true
    };
    const updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'background', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'color', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'denyButtonAriaLabel', 'denyButtonColor', 'denyButtonText', 'didClose', 'didDestroy', 'footer', 'hideClass', 'html', 'icon', 'iconColor', 'iconHtml', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'preConfirm', 'preDeny', 'progressSteps', 'returnFocus', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'showDenyButton', 'text', 'title', 'titleText', 'willClose'];
    const deprecatedParams = {
      allowEnterKey: undefined
    };
    const toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusDeny', 'focusCancel', 'returnFocus', 'heightAuto', 'keydownListenerCapture'];
    const isValidParameter = paramName => {
      return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    const isUpdatableParameter = paramName => {
      return updatableParams.indexOf(paramName) !== -1;
    };
    const isDeprecatedParameter = paramName => {
      return deprecatedParams[paramName];
    };
    const checkIfParamIsValid = param => {
      if (!isValidParameter(param)) {
        warn(`Unknown parameter "${param}"`);
      }
    };
    const checkIfToastParamIsValid = param => {
      if (toastIncompatibleParams.includes(param)) {
        warn(`The parameter "${param}" is incompatible with toasts`);
      }
    };
    const checkIfParamIsDeprecated = param => {
      const isDeprecated = isDeprecatedParameter(param);
      if (isDeprecated) {
        warnAboutDeprecation(param, isDeprecated);
      }
    };
    const showWarningsForParams = params => {
      if (params.backdrop === false && params.allowOutsideClick) {
        warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
      }
      for (const param in params) {
        checkIfParamIsValid(param);
        if (params.toast) {
          checkIfToastParamIsValid(param);
        }
        checkIfParamIsDeprecated(param);
      }
    };
    function update(params) {
      const popup = getPopup();
      const innerParams = privateProps.innerParams.get(this);
      if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
        warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
        return;
      }
      const validUpdatableParams = filterValidParams(params);
      const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
      render(this, updatedParams);
      privateProps.innerParams.set(this, updatedParams);
      Object.defineProperties(this, {
        params: {
          value: Object.assign({}, this.params, params),
          writable: false,
          enumerable: true
        }
      });
    }
    const filterValidParams = params => {
      const validUpdatableParams = {};
      Object.keys(params).forEach(param => {
        if (isUpdatableParameter(param)) {
          validUpdatableParams[param] = params[param];
        } else {
          warn(`Invalid parameter to update: ${param}`);
        }
      });
      return validUpdatableParams;
    };
    function _destroy() {
      const domCache = privateProps.domCache.get(this);
      const innerParams = privateProps.innerParams.get(this);
      if (!innerParams) {
        disposeWeakMaps(this);
        return;
      }
      if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
        globalState.swalCloseEventFinishedCallback();
        delete globalState.swalCloseEventFinishedCallback;
      }
      if (typeof innerParams.didDestroy === 'function') {
        innerParams.didDestroy();
      }
      globalState.eventEmitter.emit('didDestroy');
      disposeSwal(this);
    }
    const disposeSwal = instance => {
      disposeWeakMaps(instance);
      delete instance.params;
      delete globalState.keydownHandler;
      delete globalState.keydownTarget;
      delete globalState.currentInstance;
    };
    const disposeWeakMaps = instance => {
      if (instance.isAwaitingPromise) {
        unsetWeakMaps(privateProps, instance);
        instance.isAwaitingPromise = true;
      } else {
        unsetWeakMaps(privateMethods, instance);
        unsetWeakMaps(privateProps, instance);
        delete instance.isAwaitingPromise;
        delete instance.disableButtons;
        delete instance.enableButtons;
        delete instance.getInput;
        delete instance.disableInput;
        delete instance.enableInput;
        delete instance.hideLoading;
        delete instance.disableLoading;
        delete instance.showValidationMessage;
        delete instance.resetValidationMessage;
        delete instance.close;
        delete instance.closePopup;
        delete instance.closeModal;
        delete instance.closeToast;
        delete instance.rejectPromise;
        delete instance.update;
        delete instance._destroy;
      }
    };
    const unsetWeakMaps = (obj, instance) => {
      for (const i in obj) {
        obj[i].delete(instance);
      }
    };
    var instanceMethods = /*#__PURE__*/Object.freeze({
      __proto__: null,
      _destroy: _destroy,
      close: close,
      closeModal: close,
      closePopup: close,
      closeToast: close,
      disableButtons: disableButtons,
      disableInput: disableInput,
      disableLoading: hideLoading,
      enableButtons: enableButtons,
      enableInput: enableInput,
      getInput: getInput,
      handleAwaitingPromise: handleAwaitingPromise,
      hideLoading: hideLoading,
      rejectPromise: rejectPromise,
      resetValidationMessage: resetValidationMessage,
      showValidationMessage: showValidationMessage,
      update: update
    });
    const handlePopupClick = (innerParams, domCache, dismissWith) => {
      if (innerParams.toast) {
        handleToastClick(innerParams, domCache, dismissWith);
      } else {
        handleModalMousedown(domCache);
        handleContainerMousedown(domCache);
        handleModalClick(innerParams, domCache, dismissWith);
      }
    };
    const handleToastClick = (innerParams, domCache, dismissWith) => {
      domCache.popup.onclick = () => {
        if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) {
          return;
        }
        dismissWith(DismissReason.close);
      };
    };
    const isAnyButtonShown = innerParams => {
      return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    const handleModalMousedown = domCache => {
      domCache.popup.onmousedown = () => {
        domCache.container.onmouseup = function (e) {
          domCache.container.onmouseup = () => {};
          if (e.target === domCache.container) {
            ignoreOutsideClick = true;
          }
        };
      };
    };
    const handleContainerMousedown = domCache => {
      domCache.container.onmousedown = e => {
        if (e.target === domCache.container) {
          e.preventDefault();
        }
        domCache.popup.onmouseup = function (e) {
          domCache.popup.onmouseup = () => {};
          if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) {
            ignoreOutsideClick = true;
          }
        };
      };
    };
    const handleModalClick = (innerParams, domCache, dismissWith) => {
      domCache.container.onclick = e => {
        if (ignoreOutsideClick) {
          ignoreOutsideClick = false;
          return;
        }
        if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
          dismissWith(DismissReason.backdrop);
        }
      };
    };
    const isJqueryElement = elem => typeof elem === 'object' && elem.jquery;
    const isElement = elem => elem instanceof Element || isJqueryElement(elem);
    const argsToParams = args => {
      const params = {};
      if (typeof args[0] === 'object' && !isElement(args[0])) {
        Object.assign(params, args[0]);
      } else {
        ['title', 'html', 'icon'].forEach((name, index) => {
          const arg = args[index];
          if (typeof arg === 'string' || isElement(arg)) {
            params[name] = arg;
          } else if (arg !== undefined) {
            error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
          }
        });
      }
      return params;
    };
    function fire() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return new this(...args);
    }
    function mixin(mixinParams) {
      class MixinSwal extends this {
        _main(params, priorityMixinParams) {
          return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
        }
      }
      return MixinSwal;
    }
    const getTimerLeft = () => {
      return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    const stopTimer = () => {
      if (globalState.timeout) {
        stopTimerProgressBar();
        return globalState.timeout.stop();
      }
    };
    const resumeTimer = () => {
      if (globalState.timeout) {
        const remaining = globalState.timeout.start();
        animateTimerProgressBar(remaining);
        return remaining;
      }
    };
    const toggleTimer = () => {
      const timer = globalState.timeout;
      return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    const increaseTimer = ms => {
      if (globalState.timeout) {
        const remaining = globalState.timeout.increase(ms);
        animateTimerProgressBar(remaining, true);
        return remaining;
      }
    };
    const isTimerRunning = () => {
      return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    const clickHandlers = {};
    function bindClickHandler() {
      let attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
      clickHandlers[attr] = this;
      if (!bodyClickListenerAdded) {
        document.body.addEventListener('click', bodyClickListener);
        bodyClickListenerAdded = true;
      }
    }
    const bodyClickListener = event => {
      for (let el = event.target; el && el !== document; el = el.parentNode) {
        for (const attr in clickHandlers) {
          const template = el.getAttribute(attr);
          if (template) {
            clickHandlers[attr].fire({
              template
            });
            return;
          }
        }
      }
    };
    class EventEmitter {
      constructor() {
        this.events = {};
      }
      _getHandlersByEventName(eventName) {
        if (typeof this.events[eventName] === 'undefined') {
          this.events[eventName] = [];
        }
        return this.events[eventName];
      }
      on(eventName, eventHandler) {
        const currentHandlers = this._getHandlersByEventName(eventName);
        if (!currentHandlers.includes(eventHandler)) {
          currentHandlers.push(eventHandler);
        }
      }
      once(eventName, eventHandler) {
        var _this = this;
        const onceFn = function () {
          _this.removeListener(eventName, onceFn);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          eventHandler.apply(_this, args);
        };
        this.on(eventName, onceFn);
      }
      emit(eventName) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        this._getHandlersByEventName(eventName).forEach(eventHandler => {
          try {
            eventHandler.apply(this, args);
          } catch (error) {
            console.error(error);
          }
        });
      }
      removeListener(eventName, eventHandler) {
        const currentHandlers = this._getHandlersByEventName(eventName);
        const index = currentHandlers.indexOf(eventHandler);
        if (index > -1) {
          currentHandlers.splice(index, 1);
        }
      }
      removeAllListeners(eventName) {
        if (this.events[eventName] !== undefined) {
          this.events[eventName].length = 0;
        }
      }
      reset() {
        this.events = {};
      }
    }
    globalState.eventEmitter = new EventEmitter();
    const on = (eventName, eventHandler) => {
      globalState.eventEmitter.on(eventName, eventHandler);
    };
    const once = (eventName, eventHandler) => {
      globalState.eventEmitter.once(eventName, eventHandler);
    };
    const off = (eventName, eventHandler) => {
      if (!eventName) {
        globalState.eventEmitter.reset();
        return;
      }
      if (eventHandler) {
        globalState.eventEmitter.removeListener(eventName, eventHandler);
      } else {
        globalState.eventEmitter.removeAllListeners(eventName);
      }
    };
    var staticMethods = /*#__PURE__*/Object.freeze({
      __proto__: null,
      argsToParams: argsToParams,
      bindClickHandler: bindClickHandler,
      clickCancel: clickCancel,
      clickConfirm: clickConfirm,
      clickDeny: clickDeny,
      enableLoading: showLoading,
      fire: fire,
      getActions: getActions,
      getCancelButton: getCancelButton,
      getCloseButton: getCloseButton,
      getConfirmButton: getConfirmButton,
      getContainer: getContainer,
      getDenyButton: getDenyButton,
      getFocusableElements: getFocusableElements,
      getFooter: getFooter,
      getHtmlContainer: getHtmlContainer,
      getIcon: getIcon,
      getIconContent: getIconContent,
      getImage: getImage,
      getInputLabel: getInputLabel,
      getLoader: getLoader,
      getPopup: getPopup,
      getProgressSteps: getProgressSteps,
      getTimerLeft: getTimerLeft,
      getTimerProgressBar: getTimerProgressBar,
      getTitle: getTitle,
      getValidationMessage: getValidationMessage,
      increaseTimer: increaseTimer,
      isDeprecatedParameter: isDeprecatedParameter,
      isLoading: isLoading,
      isTimerRunning: isTimerRunning,
      isUpdatableParameter: isUpdatableParameter,
      isValidParameter: isValidParameter,
      isVisible: isVisible,
      mixin: mixin,
      off: off,
      on: on,
      once: once,
      resumeTimer: resumeTimer,
      showLoading: showLoading,
      stopTimer: stopTimer,
      toggleTimer: toggleTimer
    });
    class Timer {
      constructor(callback, delay) {
        this.callback = callback;
        this.remaining = delay;
        this.running = false;
        this.start();
      }
      start() {
        if (!this.running) {
          this.running = true;
          this.started = new Date();
          this.id = setTimeout(this.callback, this.remaining);
        }
        return this.remaining;
      }
      stop() {
        if (this.started && this.running) {
          this.running = false;
          clearTimeout(this.id);
          this.remaining -= new Date().getTime() - this.started.getTime();
        }
        return this.remaining;
      }
      increase(n) {
        const running = this.running;
        if (running) {
          this.stop();
        }
        this.remaining += n;
        if (running) {
          this.start();
        }
        return this.remaining;
      }
      getTimerLeft() {
        if (this.running) {
          this.stop();
          this.start();
        }
        return this.remaining;
      }
      isRunning() {
        return this.running;
      }
    }
    const swalStringParams = ['swal-title', 'swal-html', 'swal-footer'];
    const getTemplateParams = params => {
      const template = typeof params.template === 'string' ? (document.querySelector(params.template)) : params.template;
      if (!template) {
        return {};
      }
      const templateContent = template.content;
      showWarningsForElements(templateContent);
      const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
      return result;
    };
    const getSwalParams = templateContent => {
      const result = {};
      const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
      swalParams.forEach(param => {
        showWarningsForAttributes(param, ['name', 'value']);
        const paramName = param.getAttribute('name');
        const value = param.getAttribute('value');
        if (!paramName || !value) {
          return;
        }
        if (typeof defaultParams[paramName] === 'boolean') {
          result[paramName] = value !== 'false';
        } else if (typeof defaultParams[paramName] === 'object') {
          result[paramName] = JSON.parse(value);
        } else {
          result[paramName] = value;
        }
      });
      return result;
    };
    const getSwalFunctionParams = templateContent => {
      const result = {};
      const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
      swalFunctions.forEach(param => {
        const paramName = param.getAttribute('name');
        const value = param.getAttribute('value');
        if (!paramName || !value) {
          return;
        }
        result[paramName] = new Function(`return ${value}`)();
      });
      return result;
    };
    const getSwalButtons = templateContent => {
      const result = {};
      const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
      swalButtons.forEach(button => {
        showWarningsForAttributes(button, ['type', 'color', 'aria-label']);
        const type = button.getAttribute('type');
        if (!type || !['confirm', 'cancel', 'deny'].includes(type)) {
          return;
        }
        result[`${type}ButtonText`] = button.innerHTML;
        result[`show${capitalizeFirstLetter(type)}Button`] = true;
        if (button.hasAttribute('color')) {
          result[`${type}ButtonColor`] = button.getAttribute('color');
        }
        if (button.hasAttribute('aria-label')) {
          result[`${type}ButtonAriaLabel`] = button.getAttribute('aria-label');
        }
      });
      return result;
    };
    const getSwalImage = templateContent => {
      const result = {};
      const image = templateContent.querySelector('swal-image');
      if (image) {
        showWarningsForAttributes(image, ['src', 'width', 'height', 'alt']);
        if (image.hasAttribute('src')) {
          result.imageUrl = image.getAttribute('src') || undefined;
        }
        if (image.hasAttribute('width')) {
          result.imageWidth = image.getAttribute('width') || undefined;
        }
        if (image.hasAttribute('height')) {
          result.imageHeight = image.getAttribute('height') || undefined;
        }
        if (image.hasAttribute('alt')) {
          result.imageAlt = image.getAttribute('alt') || undefined;
        }
      }
      return result;
    };
    const getSwalIcon = templateContent => {
      const result = {};
      const icon = templateContent.querySelector('swal-icon');
      if (icon) {
        showWarningsForAttributes(icon, ['type', 'color']);
        if (icon.hasAttribute('type')) {
          result.icon = icon.getAttribute('type');
        }
        if (icon.hasAttribute('color')) {
          result.iconColor = icon.getAttribute('color');
        }
        result.iconHtml = icon.innerHTML;
      }
      return result;
    };
    const getSwalInput = templateContent => {
      const result = {};
      const input = templateContent.querySelector('swal-input');
      if (input) {
        showWarningsForAttributes(input, ['type', 'label', 'placeholder', 'value']);
        result.input = input.getAttribute('type') || 'text';
        if (input.hasAttribute('label')) {
          result.inputLabel = input.getAttribute('label');
        }
        if (input.hasAttribute('placeholder')) {
          result.inputPlaceholder = input.getAttribute('placeholder');
        }
        if (input.hasAttribute('value')) {
          result.inputValue = input.getAttribute('value');
        }
      }
      const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
      if (inputOptions.length) {
        result.inputOptions = {};
        inputOptions.forEach(option => {
          showWarningsForAttributes(option, ['value']);
          const optionValue = option.getAttribute('value');
          if (!optionValue) {
            return;
          }
          const optionName = option.innerHTML;
          result.inputOptions[optionValue] = optionName;
        });
      }
      return result;
    };
    const getSwalStringParams = (templateContent, paramNames) => {
      const result = {};
      for (const i in paramNames) {
        const paramName = paramNames[i];
        const tag = templateContent.querySelector(paramName);
        if (tag) {
          showWarningsForAttributes(tag, []);
          result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
        }
      }
      return result;
    };
    const showWarningsForElements = templateContent => {
      const allowedElements = swalStringParams.concat(['swal-param', 'swal-function-param', 'swal-button', 'swal-image', 'swal-icon', 'swal-input', 'swal-input-option']);
      Array.from(templateContent.children).forEach(el => {
        const tagName = el.tagName.toLowerCase();
        if (!allowedElements.includes(tagName)) {
          warn(`Unrecognized element <${tagName}>`);
        }
      });
    };
    const showWarningsForAttributes = (el, allowedAttributes) => {
      Array.from(el.attributes).forEach(attribute => {
        if (allowedAttributes.indexOf(attribute.name) === -1) {
          warn([`Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`, `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`]);
        }
      });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    const openPopup = params => {
      const container = getContainer();
      const popup = getPopup();
      if (typeof params.willOpen === 'function') {
        params.willOpen(popup);
      }
      globalState.eventEmitter.emit('willOpen', popup);
      const bodyStyles = window.getComputedStyle(document.body);
      const initialBodyOverflow = bodyStyles.overflowY;
      addClasses(container, popup, params);
      setTimeout(() => {
        setScrollingVisibility(container, popup);
      }, SHOW_CLASS_TIMEOUT);
      if (isModal()) {
        fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
        setAriaHidden();
      }
      if (!isToast() && !globalState.previousActiveElement) {
        globalState.previousActiveElement = document.activeElement;
      }
      if (typeof params.didOpen === 'function') {
        setTimeout(() => params.didOpen(popup));
      }
      globalState.eventEmitter.emit('didOpen', popup);
      removeClass(container, swalClasses['no-transition']);
    };
    const swalOpenAnimationFinished = event => {
      const popup = getPopup();
      if (event.target !== popup || !animationEndEvent) {
        return;
      }
      const container = getContainer();
      popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
      container.style.overflowY = 'auto';
    };
    const setScrollingVisibility = (container, popup) => {
      if (animationEndEvent && hasCssAnimation(popup)) {
        container.style.overflowY = 'hidden';
        popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
      } else {
        container.style.overflowY = 'auto';
      }
    };
    const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow) => {
      iOSfix();
      if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
        replaceScrollbarWithPadding(initialBodyOverflow);
      }
      setTimeout(() => {
        container.scrollTop = 0;
      });
    };
    const addClasses = (container, popup, params) => {
      addClass(container, params.showClass.backdrop);
      if (params.animation) {
        popup.style.setProperty('opacity', '0', 'important');
        show(popup, 'grid');
        setTimeout(() => {
          addClass(popup, params.showClass.popup);
          popup.style.removeProperty('opacity');
        }, SHOW_CLASS_TIMEOUT);
      } else {
        show(popup, 'grid');
      }
      addClass([document.documentElement, document.body], swalClasses.shown);
      if (params.heightAuto && params.backdrop && !params.toast) {
        addClass([document.documentElement, document.body], swalClasses['height-auto']);
      }
    };
    var defaultInputValidators = {
      email: (string, validationMessage) => {
        return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
      },
      url: (string, validationMessage) => {
        return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
      }
    };
    function setDefaultInputValidators(params) {
      if (params.inputValidator) {
        return;
      }
      if (params.input === 'email') {
        params.inputValidator = defaultInputValidators['email'];
      }
      if (params.input === 'url') {
        params.inputValidator = defaultInputValidators['url'];
      }
    }
    function validateCustomTargetElement(params) {
      if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
        warn('Target parameter is not valid, defaulting to "body"');
        params.target = 'body';
      }
    }
    function setParameters(params) {
      setDefaultInputValidators(params);
      if (params.showLoaderOnConfirm && !params.preConfirm) {
        warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
      }
      validateCustomTargetElement(params);
      if (typeof params.title === 'string') {
        params.title = params.title.split('\n').join('<br />');
      }
      init(params);
    }
    let currentInstance;
    var _promise = /*#__PURE__*/new WeakMap();
    class SweetAlert {
      constructor() {
        _classPrivateFieldInitSpec(this, _promise, void 0);
        if (typeof window === 'undefined') {
          return;
        }
        currentInstance = this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        const outerParams = Object.freeze(this.constructor.argsToParams(args));
        this.params = outerParams;
        this.isAwaitingPromise = false;
        _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
      }
      _main(userParams) {
        let mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        showWarningsForParams(Object.assign({}, mixinParams, userParams));
        if (globalState.currentInstance) {
          const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
          const {
            isAwaitingPromise
          } = globalState.currentInstance;
          globalState.currentInstance._destroy();
          if (!isAwaitingPromise) {
            swalPromiseResolve({
              isDismissed: true
            });
          }
          if (isModal()) {
            unsetAriaHidden();
          }
        }
        globalState.currentInstance = currentInstance;
        const innerParams = prepareParams(userParams, mixinParams);
        setParameters(innerParams);
        Object.freeze(innerParams);
        if (globalState.timeout) {
          globalState.timeout.stop();
          delete globalState.timeout;
        }
        clearTimeout(globalState.restoreFocusTimeout);
        const domCache = populateDomCache(currentInstance);
        render(currentInstance, innerParams);
        privateProps.innerParams.set(currentInstance, innerParams);
        return swalPromise(currentInstance, domCache, innerParams);
      }
      then(onFulfilled) {
        return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
      }
      finally(onFinally) {
        return _classPrivateFieldGet2(_promise, this).finally(onFinally);
      }
    }
    const swalPromise = (instance, domCache, innerParams) => {
      return new Promise((resolve, reject) => {
        const dismissWith = dismiss => {
          instance.close({
            isDismissed: true,
            dismiss
          });
        };
        privateMethods.swalPromiseResolve.set(instance, resolve);
        privateMethods.swalPromiseReject.set(instance, reject);
        domCache.confirmButton.onclick = () => {
          handleConfirmButtonClick(instance);
        };
        domCache.denyButton.onclick = () => {
          handleDenyButtonClick(instance);
        };
        domCache.cancelButton.onclick = () => {
          handleCancelButtonClick(instance, dismissWith);
        };
        domCache.closeButton.onclick = () => {
          dismissWith(DismissReason.close);
        };
        handlePopupClick(innerParams, domCache, dismissWith);
        addKeydownHandler(globalState, innerParams, dismissWith);
        handleInputOptionsAndValue(instance, innerParams);
        openPopup(innerParams);
        setupTimer(globalState, innerParams, dismissWith);
        initFocus(domCache, innerParams);
        setTimeout(() => {
          domCache.container.scrollTop = 0;
        });
      });
    };
    const prepareParams = (userParams, mixinParams) => {
      const templateParams = getTemplateParams(userParams);
      const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams);
      params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
      params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
      if (params.animation === false) {
        params.showClass = {
          backdrop: 'swal2-noanimation'
        };
        params.hideClass = {};
      }
      return params;
    };
    const populateDomCache = instance => {
      const domCache = {
        popup: getPopup(),
        container: getContainer(),
        actions: getActions(),
        confirmButton: getConfirmButton(),
        denyButton: getDenyButton(),
        cancelButton: getCancelButton(),
        loader: getLoader(),
        closeButton: getCloseButton(),
        validationMessage: getValidationMessage(),
        progressSteps: getProgressSteps()
      };
      privateProps.domCache.set(instance, domCache);
      return domCache;
    };
    const setupTimer = (globalState, innerParams, dismissWith) => {
      const timerProgressBar = getTimerProgressBar();
      hide(timerProgressBar);
      if (innerParams.timer) {
        globalState.timeout = new Timer(() => {
          dismissWith('timer');
          delete globalState.timeout;
        }, innerParams.timer);
        if (innerParams.timerProgressBar) {
          show(timerProgressBar);
          applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
          setTimeout(() => {
            if (globalState.timeout && globalState.timeout.running) {
              animateTimerProgressBar(innerParams.timer);
            }
          });
        }
      }
    };
    const initFocus = (domCache, innerParams) => {
      if (innerParams.toast) {
        return;
      }
      if (!callIfFunction(innerParams.allowEnterKey)) {
        warnAboutDeprecation('allowEnterKey');
        blurActiveElement();
        return;
      }
      if (focusAutofocus(domCache)) {
        return;
      }
      if (focusButton(domCache, innerParams)) {
        return;
      }
      setFocus(-1, 1);
    };
    const focusAutofocus = domCache => {
      const autofocusElements = domCache.popup.querySelectorAll('[autofocus]');
      for (const autofocusElement of autofocusElements) {
        if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
          autofocusElement.focus();
          return true;
        }
      }
      return false;
    };
    const focusButton = (domCache, innerParams) => {
      if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
        domCache.denyButton.focus();
        return true;
      }
      if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
        domCache.cancelButton.focus();
        return true;
      }
      if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
        domCache.confirmButton.focus();
        return true;
      }
      return false;
    };
    const blurActiveElement = () => {
      if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    };
    if (typeof window !== 'undefined' && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
      const now = new Date();
      const initiationDate = localStorage.getItem('swal-initiation');
      if (!initiationDate) {
        localStorage.setItem('swal-initiation', `${now}`);
      } else if ((now.getTime() - Date.parse(initiationDate)) / (1000 * 60 * 60 * 24) > 3) {
        setTimeout(() => {
          document.body.style.pointerEvents = 'none';
          const ukrainianAnthem = document.createElement('audio');
          ukrainianAnthem.src = 'https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3';
          ukrainianAnthem.loop = true;
          document.body.appendChild(ukrainianAnthem);
          setTimeout(() => {
            ukrainianAnthem.play().catch(() => {});
          }, 2500);
        }, 500);
      }
    }
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    Object.assign(SweetAlert, staticMethods);
    Object.keys(instanceMethods).forEach(key => {
      SweetAlert[key] = function () {
        if (currentInstance && currentInstance[key]) {
          return currentInstance[key](...arguments);
        }
        return null;
      };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.14.0';
    const Swal = SweetAlert;
    Swal.default = Swal;
    return Swal;
  });
  if (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.Sweetalert2) {
    commonjsGlobal.swal = commonjsGlobal.sweetAlert = commonjsGlobal.Swal = commonjsGlobal.SweetAlert = commonjsGlobal.Sweetalert2;
  }
  "undefined" != typeof document && function (e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);else try {
      n.innerHTML = t;
    } catch (e) {
      n.innerText = t;
    }
  }(document, ".swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:rgba(0,0,0,.4)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):focus-visible{box-shadow:0 0 0 3px rgba(112,102,224,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):focus-visible{box-shadow:0 0 0 3px rgba(220,55,65,.5)}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):focus-visible{box-shadow:0 0 0 3px rgba(110,120,129,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-default-outline:focus-visible{box-shadow:0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em;text-align:center}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em}div:where(.swal2-container) button:where(.swal2-close){z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:none;background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) .swal2-html-container{z-index:1;justify-content:center;margin:0;padding:1em 1.6em .3em;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:#fff}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:0.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#facea8;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#9de0f6;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#c9dae1;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static !important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}");
});

const AutoLogoutWarning = props => {
  const [counter, setCounter] = useState(1800);
  const location = useLocation();
  useEffect(() => {
    setCounter(1800);
  }, [location]);
  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      sweetalert2_all.fire({
        title: "Session Expired",
        text: "Your session has expired. Click OK to refresh, or you’ll be logged out automatically.",
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: "OK",
        allowOutsideClick: false,
        timer: 5000,
        timerProgressBar: true
      }).then(result => {
        if (result.isConfirmed) {
          window.location.reload();
        } else if (result.dismiss === sweetalert2_all.DismissReason.timer) {
          Digit.UserService.logout();
        }
      });
    }
  }, [counter]);
  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
  return /*#__PURE__*/React.createElement("p", {
    className: "mx-2",
    style: {
      color: props.color ? props.color : "#ffffff",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(RxLapTimer, {
    width: 50
  })), /*#__PURE__*/React.createElement("span", null, formatTime(counter)));
};

const Menu = ({
  menu,
  displayKey,
  onSelect
}) => /*#__PURE__*/React.createElement("div", {
  className: "menu"
}, menu.map((item, index) => /*#__PURE__*/React.createElement("div", {
  className: "item",
  onClick: () => onSelect(item),
  key: index
}, item.icon, /*#__PURE__*/React.createElement("span", null, item[displayKey]))));
const EllipsisMenu = ({
  menuItems,
  displayKey,
  onSelect
}) => {
  const menuRef = useRef();
  const [active, setActive] = useState(false);
  Digit.Hooks.useClickOutside(menuRef, () => setActive(false), active);
  function onItemSelect(item) {
    setActive(false);
    onSelect(item);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ellipsis-menu-wrap",
    ref: menuRef
  }, /*#__PURE__*/React.createElement(Ellipsis, {
    className: "cursorPointer",
    onClick: () => setActive(true)
  }), active ? /*#__PURE__*/React.createElement(Menu, {
    menu: menuItems,
    displayKey: displayKey,
    onSelect: onItemSelect
  }) : null);
};

const EmployeeAppContainer = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "employee-app-container"
  }, props.children);
};

const EmployeeModuleCard = ({
  Icon,
  moduleName,
  kpis: _kpis = [],
  links: _links = [],
  isCitizen: _isCitizen = false,
  className,
  styles
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "ServiceCardOptions empCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ServiceCardData "
  }, /*#__PURE__*/React.createElement("div", {
    className: "ServiceCardHeader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Icon-side"
  }, Icon)), /*#__PURE__*/React.createElement("div", {
    className: "ServiceCardCaption"
  }, /*#__PURE__*/React.createElement("h3", null, moduleName), /*#__PURE__*/React.createElement("div", {
    className: "links-redirect"
  }, _links.map(({
    count,
    label,
    link
  }, index) => /*#__PURE__*/React.createElement("div", {
    className: "link",
    key: index
  }, link ? /*#__PURE__*/React.createElement(Link, {
    to: link
  }, label, " ", count ? /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("span", {
    className: "inbox-total"
  }, count || "-")) : null) : null))))));
};
const ModuleCardFullWidth = ({
  moduleName,
  links: _links2 = [],
  isCitizen: _isCitizen2 = false,
  className,
  styles,
  headerStyle,
  subHeader,
  subHeaderLink
}) => {
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "ServiceCardOptions empCard"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ServiceCardData "
    }, /*#__PURE__*/React.createElement("div", {
      className: "ServiceCardHeader"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Icon-side"
    }, Icon)), /*#__PURE__*/React.createElement("div", {
      className: "ServiceCardCaption"
    }, /*#__PURE__*/React.createElement("h3", null, moduleName), /*#__PURE__*/React.createElement("span", {
      className: "link"
    }, /*#__PURE__*/React.createElement("a", {
      href: subHeaderLink
    }, /*#__PURE__*/React.createElement("span", {
      className: "inbox-total",
      style: {
        display: "flex",
        alignItems: "center",
        color: "#F47738",
        fontWeight: "bold"
      }
    }, subHeader || "-", /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "10px"
      }
    }, " ", /*#__PURE__*/React.createElement(ArrowRightInbox, null))))), /*#__PURE__*/React.createElement("div", {
      className: "links-redirect"
    }, _links2.map(({
      count,
      label,
      link
    }, index) => /*#__PURE__*/React.createElement("span", {
      className: "link full-employee-card-link",
      key: index
    }, link ? link !== null && link !== void 0 && link.includes("digit-ui/") ? /*#__PURE__*/React.createElement(Link, {
      to: link
    }, label) : /*#__PURE__*/React.createElement("a", {
      href: link
    }, label) : null))))))
  );
};

const EmployeeOBPSModuleCard = ({
  Icon,
  moduleName,
  kpis: _kpis = [],
  links: _links = [],
  isCitizen: _isCitizen = false,
  className,
  styles,
  FsmHideCount
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className ? className : "employeeCard card-home customEmployeeCard",
    style: styles ? styles : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "complaint-links-container-obps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header",
    style: _isCitizen ? {
      padding: "0px"
    } : {}
  }, /*#__PURE__*/React.createElement("span", {
    className: "text removeHeight"
  }, moduleName), /*#__PURE__*/React.createElement("span", {
    className: "logo removeBorderRadiusLogo"
  }, Icon)), /*#__PURE__*/React.createElement("div", {
    className: "body",
    style: {
      margin: "0px",
      padding: "0px"
    }
  }, _kpis.length !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex-fit",
    style: _isCitizen ? {
      paddingLeft: "17px"
    } : {}
  }, _kpis.map(({
    count,
    label,
    link
  }, index) => /*#__PURE__*/React.createElement("div", {
    className: "card-count",
    key: index
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, count || "-")), /*#__PURE__*/React.createElement("div", null, link ? /*#__PURE__*/React.createElement(Link, {
    to: link,
    className: "employeeTotalLink"
  }, label) : null)))), /*#__PURE__*/React.createElement("div", {
    className: "links-wrapper",
    style: {
      width: "80%"
    }
  }, _links.map(({
    count,
    label,
    link
  }, index) => /*#__PURE__*/React.createElement("span", {
    className: "link",
    key: index
  }, link ? /*#__PURE__*/React.createElement(Link, {
    to: link
  }, label) : null, count ? /*#__PURE__*/React.createElement(Fragment$1, null, FsmHideCount ? null : /*#__PURE__*/React.createElement("span", {
    className: "inbox-total"
  }, count || "-"), /*#__PURE__*/React.createElement(Link, {
    to: link
  }, /*#__PURE__*/React.createElement(ArrowRightInbox, null))) : null)))))));
};

const GreyOutText = props => /*#__PURE__*/React.createElement("div", {
  className: "grey"
}, props.children);

const Hamburger = ({
  handleClick,
  color
}) => /*#__PURE__*/React.createElement("span", {
  style: {
    marginRight: "10px"
  },
  className: "cp",
  onClick: handleClick
}, /*#__PURE__*/React.createElement(HamburgerIcon, {
  styles: {
    display: "inline"
  },
  color: color
}));

const Header = props => {
  return /*#__PURE__*/React.createElement("header", {
    className: "h1",
    style: props.styles
  }, props.children);
};

const HomeLink = ({
  to,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "home-link"
}, /*#__PURE__*/React.createElement(Link, {
  to: to
}, children));
HomeLink.propTypes = {
  to: propTypes.oneOfType([propTypes.string, propTypes.object]),
  children: propTypes.string
};
HomeLink.defaultProps = {
  to: "#",
  children: "Link"
};

const MiniUpload = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "upload-img-container"
  }, /*#__PURE__*/React.createElement(CameraSvg, {
    className: "upload-camera-img"
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    id: "miniupload",
    accept: "image/*",
    onChange: e => props.onUpload(e)
  }));
};
const UploadImages = props => {
  if (props.thumbnails && props.thumbnails.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "multi-upload-wrap"
    }, props.thumbnails.map((thumbnail, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement(DeleteBtn, {
        onClick: () => props.onDelete(thumbnail),
        className: "delete",
        fill: "#d4351c"
      }), /*#__PURE__*/React.createElement("img", {
        src: thumbnail,
        alt: "uploaded thumbnail"
      }));
    }), props.thumbnails.length < 3 ? /*#__PURE__*/React.createElement(MiniUpload, {
      onUpload: props.onUpload
    }) : null);
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "upload-wrap",
      onClick: e => props.onUpload(e)
    }, /*#__PURE__*/React.createElement(CameraSvg, null), /*#__PURE__*/React.createElement("input", {
      type: "file",
      id: "upload",
      accept: "image/*",
      onChange: e => props.onUpload(e)
    }));
  }
};
UploadImages.propTypes = {
  thumbnail: propTypes.array,
  onUpload: propTypes.func
};
UploadImages.defaultProps = {
  thumbnail: [],
  onUpload: undefined
};

const ImageUploadHandler = props => {
  const [image, setImage] = useState(null);
  const [uploadedImagesThumbs, setUploadedImagesThumbs] = useState(null);
  const [uploadedImagesIds, setUploadedImagesIds] = useState(props.uploadedImages);
  const [rerender, setRerender] = useState(1);
  const [imageFile, setImageFile] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (image) {
      uploadImage();
    }
  }, [image]);
  useEffect(() => {
    if (!isDeleting) {
      (async () => {
        if (uploadedImagesIds !== null) {
          await submit();
          setRerender(rerender + 1);
          props.onPhotoChange(uploadedImagesIds);
        }
      })();
    } else {
      setIsDeleting(false);
    }
  }, [uploadedImagesIds]);
  useEffect(() => {
    if (imageFile && imageFile.size > 2097152) {
      setError("File is too large");
    } else {
      setImage(imageFile);
    }
  }, [imageFile]);
  const addUploadedImageIds = useCallback(imageIdData => {
    if (uploadedImagesIds === null) {
      var arr = [];
    } else {
      arr = uploadedImagesIds;
    }
    return [...arr, imageIdData.data.files[0].fileStoreId];
  }, [uploadedImagesIds]);
  function getImage(e) {
    setError(null);
    setImageFile(e.target.files[0]);
  }
  const uploadImage = useCallback(async () => {
    const response = await Digit.UploadServices.Filestorage("property-upload", image, props.tenantId);
    setUploadedImagesIds(addUploadedImageIds(response));
  }, [addUploadedImageIds, image]);
  function addImageThumbnails(thumbnailsData) {
    var keys = Object.keys(thumbnailsData.data);
    var index = keys.findIndex(key => key === "fileStoreIds");
    if (index > -1) {
      keys.splice(index, 1);
    }
    var thumbnails = [];
    const newThumbnails = keys.map(key => {
      return {
        image: thumbnailsData.data[key].split(",")[2],
        key
      };
    });
    setUploadedImagesThumbs([...thumbnails, ...newThumbnails]);
  }
  const submit = useCallback(async () => {
    if (uploadedImagesIds !== null && uploadedImagesIds.length > 0) {
      const res = await Digit.UploadServices.Filefetch(uploadedImagesIds, props.tenantId);
      addImageThumbnails(res);
    }
  }, [uploadedImagesIds]);
  function deleteImage(img) {
    setIsDeleting(true);
    var deleteImageKey = uploadedImagesThumbs.filter((o, index) => o.image === img);
    var uploadedthumbs = uploadedImagesThumbs;
    var newThumbsList = uploadedthumbs.filter(thumbs => thumbs != deleteImageKey[0]);
    var newUploadedImagesIds = uploadedImagesIds.filter(key => key !== deleteImageKey[0].key);
    setUploadedImagesThumbs(newThumbsList);
    setUploadedImagesIds(newUploadedImagesIds);
    Digit.SessionStorage.set("PGR_CREATE_IMAGES", newUploadedImagesIds);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Toast$1, {
    error: true,
    label: error,
    onClose: () => setError(null)
  }), /*#__PURE__*/React.createElement(UploadImages, {
    onUpload: getImage,
    onDelete: deleteImage,
    thumbnails: uploadedImagesThumbs ? uploadedImagesThumbs.map(o => o.image) : []
  }));
};

const ImageViewer = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "image-viewer-wrap"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "white",
    width: "18px",
    height: "18px",
    onClick: props.onClose
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
  })), /*#__PURE__*/React.createElement("img", {
    src: props.imageSrc
  }));
};
ImageViewer.propTypes = {
  imageSrc: propTypes.string
};
ImageViewer.defaultProps = {
  imageSrc: ""
};

const InfoBanner = ({
  label,
  text
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "info-banner-wrap"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InfoBannerIcon, null), /*#__PURE__*/React.createElement("h2", null, label)), /*#__PURE__*/React.createElement("p", null, text));
};

const KeyNote = ({
  keyValue,
  note,
  caption,
  noteStyle,
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "key-note-pair"
  }, /*#__PURE__*/React.createElement("h3", null, keyValue), /*#__PURE__*/React.createElement("p", {
    style: noteStyle
  }, note), /*#__PURE__*/React.createElement("p", {
    className: "caption"
  }, caption), children);
};
KeyNote.propTypes = {
  keyValue: propTypes.string,
  note: propTypes.oneOfType([propTypes.string, propTypes.number]),
  noteStyle: propTypes.any
};
KeyNote.defaultProps = {
  keyValue: "",
  note: "",
  noteStyle: {}
};

const Label = props => {
  return /*#__PURE__*/React.createElement("h4", {
    className: "h4"
  }, props.children);
};

const LabelFieldPair = props => {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...props.style
    },
    className: "label-field-pair"
  }, props.children);
};

const LinkButton = props => {
  return /*#__PURE__*/React.createElement("span", {
    className: `card-link cp ${props.className}`,
    onClick: props.onClick,
    style: props.style
  }, props.label);
};
LinkButton.propTypes = {
  label: propTypes.any,
  onClick: propTypes.func
};
LinkButton.defaultProps = {};

const LinkLabel = props => {
  return /*#__PURE__*/React.createElement("label", {
    className: "link-label",
    onClick: props.onClick,
    style: {
      ...props.style
    }
  }, props.children);
};

const Loader = ({
  page: _page = false
}) => /*#__PURE__*/React.createElement("div", {
  className: `${_page ? "page" : "module"}-loader`
}, /*#__PURE__*/React.createElement("div", {
  className: "loadingio-spinner-rolling-faewnb8ux8"
}, /*#__PURE__*/React.createElement("div", {
  className: "ldio-pjg92h09b2o"
}, /*#__PURE__*/React.createElement("div", null))));
Loader.propTypes = {
  page: propTypes.bool
};
Loader.defaultProps = {
  page: false
};

let defaultBounds = {};
const updateDefaultBounds = center => {
  if (!center.lat || !center.lng) {
    return;
  }
  defaultBounds = {
    north: center.lat + 0.1,
    south: center.lat - 0.1,
    east: center.lng + 0.1,
    west: center.lng - 0.1
  };
};
const GetPinCode = places => {
  var _places$address_compo;
  let postalCode = null;
  places === null || places === void 0 ? void 0 : (_places$address_compo = places.address_components) === null || _places$address_compo === void 0 ? void 0 : _places$address_compo.forEach(place => {
    let hasPostalCode = place.types.includes("postal_code");
    postalCode = hasPostalCode ? place.long_name : null;
  });
  return postalCode;
};
const getName = places => {
  var _places$address_compo2;
  let name = "";
  places === null || places === void 0 ? void 0 : (_places$address_compo2 = places.address_components) === null || _places$address_compo2 === void 0 ? void 0 : _places$address_compo2.forEach(place => {
    let hasName = place.types.includes("sublocality_level_2") || place.types.includes("sublocality_level_1");
    if (hasName) {
      name = hasName ? place.long_name : null;
    }
  });
  return name;
};
const loadGoogleMaps = callback => {
  var _globalConfigs;
  const key = (_globalConfigs = globalConfigs) === null || _globalConfigs === void 0 ? void 0 : _globalConfigs.getConfig("GMAPS_API_KEY");
  const loader = new Loader$1({
    apiKey: key,
    version: "weekly",
    libraries: ["places"]
  });
  loader.load().then(() => {
    if (callback) callback();
  }).catch(e => {});
};
const mapStyles = [{
  elementType: "geometry",
  stylers: [{
    color: "#f5f5f5"
  }]
}, {
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  elementType: "labels.text.fill",
  stylers: [{
    color: "#616161"
  }]
}, {
  elementType: "labels.text.stroke",
  stylers: [{
    color: "#f5f5f5"
  }]
}, {
  featureType: "administrative.land_parcel",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#bdbdbd"
  }]
}, {
  featureType: "poi",
  elementType: "geometry",
  stylers: [{
    color: "#eeeeee"
  }]
}, {
  featureType: "poi",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#757575"
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{
    color: "#e5e5e5"
  }]
}, {
  featureType: "poi.park",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#9e9e9e"
  }]
}, {
  featureType: "road",
  elementType: "geometry",
  stylers: [{
    color: "#ffffff"
  }]
}, {
  featureType: "road.arterial",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#757575"
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry",
  stylers: [{
    color: "#dadada"
  }]
}, {
  featureType: "road.highway",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#616161"
  }]
}, {
  featureType: "road.local",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#9e9e9e"
  }]
}, {
  featureType: "transit.line",
  elementType: "geometry",
  stylers: [{
    color: "#e5e5e5"
  }]
}, {
  featureType: "transit.station",
  elementType: "geometry",
  stylers: [{
    color: "#eeeeee"
  }]
}, {
  featureType: "water",
  elementType: "geometry",
  stylers: [{
    color: "#c9c9c9"
  }]
}, {
  featureType: "water",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#9e9e9e"
  }]
}];
const setLocationText = (location, onChange, isPlaceRequired = false) => {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({
    location
  }, function (results, status) {
    if (status === "OK") {
      if (results[0]) {
        let pincode = GetPinCode(results[0]);
        const infoWindowContent = document.getElementById("pac-input");
        infoWindowContent.value = getName(results[0]);
        if (onChange) {
          if (isPlaceRequired) onChange(pincode, {
            longitude: location.lng,
            latitude: location.lat
          }, infoWindowContent.value);else onChange(pincode, {
            longitude: location.lng,
            latitude: location.lat
          });
        }
      }
    }
  });
};
const onMarkerDragged = (marker, onChange, isPlaceRequired = false) => {
  if (!marker) return;
  const {
    latLng
  } = marker;
  const currLat = latLng.lat();
  const currLang = latLng.lng();
  const location = {
    lat: currLat,
    lng: currLang
  };
  if (isPlaceRequired) setLocationText(location, onChange, true);else setLocationText(location, onChange);
};
const initAutocomplete = (onChange, position, isPlaceRequired = false) => {
  const map = new window.google.maps.Map(document.getElementById("map"), {
    center: position,
    zoom: 15,
    mapTypeId: "roadmap",
    styles: mapStyles
  });
  const input = document.getElementById("pac-input");
  updateDefaultBounds(position);
  const options = {
    bounds: defaultBounds,
    componentRestrictions: {
      country: "in"
    },
    fields: ["address_components", "geometry", "icon", "name"],
    origin: position,
    strictBounds: false,
    types: ["address"]
  };
  const searchBox = new window.google.maps.places.Autocomplete(input, options);
  map.addListener("bounds_changed", () => {
    searchBox.setBounds(map.getBounds());
  });
  let markers = [new window.google.maps.Marker({
    map,
    title: "a",
    position: position,
    draggable: true,
    clickable: true
  })];
  if (isPlaceRequired) setLocationText(position, onChange, true);else setLocationText(position, onChange);
  markers[0].addListener("dragend", marker => onMarkerDragged(marker, onChange, isPlaceRequired));
  searchBox.addListener("place_changed", () => {
    const place = searchBox.getPlace();
    if (!place) {
      return;
    }
    let pincode = GetPinCode(place);
    if (pincode) {
      const {
        geometry
      } = place;
      const geoLocation = {
        latitude: geometry.location.lat(),
        longitude: geometry.location.lng()
      };
      if (isPlaceRequired) onChange(pincode, geoLocation, place.name);else onChange(pincode, geoLocation);
    }
    markers.forEach(marker => {
      marker.setMap(null);
    });
    markers = [];
    const bounds = new window.google.maps.LatLngBounds();
    if (!place.geometry) {
      return;
    }
    markers.push(new window.google.maps.Marker({
      map,
      title: place.name,
      position: place.geometry.location,
      draggable: true,
      clickable: true
    }));
    markers[0].addListener("dragend", marker => onMarkerDragged(marker, onChange, isPlaceRequired));
    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }
    map.fitBounds(bounds);
  });
};
const LocationSearch = props => {
  useEffect(() => {
    async function mapScriptCall() {
      const getLatLng = position => {
        initAutocomplete(props.onChange, {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }, props.isPlaceRequired);
      };
      const getLatLngError = error => {
        let defaultLatLong = {};
        if (props !== null && props !== void 0 && props.isPTDefault) {
          var _props$PTdefaultcoord;
          defaultLatLong = (props === null || props === void 0 ? void 0 : (_props$PTdefaultcoord = props.PTdefaultcoord) === null || _props$PTdefaultcoord === void 0 ? void 0 : _props$PTdefaultcoord.defaultConfig) || {
            lat: 31.6160638,
            lng: 74.8978579
          };
        } else {
          defaultLatLong = {
            lat: 31.6160638,
            lng: 74.8978579
          };
        }
        initAutocomplete(props.onChange, defaultLatLong, props.isPlaceRequired);
      };
      const initMaps = () => {
        var _props$position, _props$position2, _navigator;
        if ((_props$position = props.position) !== null && _props$position !== void 0 && _props$position.latitude && (_props$position2 = props.position) !== null && _props$position2 !== void 0 && _props$position2.longitude) {
          getLatLng({
            coords: props.position
          });
        } else if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(getLatLng, getLatLngError);
        } else {
          getLatLngError();
        }
      };
      loadGoogleMaps(initMaps);
    }
    mapScriptCall();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "map-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "map-search-bar-wrap"
  }, /*#__PURE__*/React.createElement(SearchIconSvg, {
    className: "map-search-bar-icon"
  }), /*#__PURE__*/React.createElement("input", {
    id: "pac-input",
    className: "map-search-bar",
    type: "text",
    placeholder: "Search Address"
  })), /*#__PURE__*/React.createElement("div", {
    id: "map",
    className: "map"
  }));
};

const Menu$1 = props => {
  const keyPrefix = props.localeKeyPrefix || "CS_ACTION";
  return /*#__PURE__*/React.createElement("div", {
    className: "menu-wrap",
    style: props.style
  }, props.options.map((option, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      onClick: () => props.onSelect(option)
    }, /*#__PURE__*/React.createElement("p", null, props.t ? props.t(option.forcedName || `${keyPrefix}_${props.optionKey ? option[props.optionKey] : option}`) : option));
  }));
};
Menu$1.propTypes = {
  options: propTypes.array,
  onSelect: propTypes.func
};
Menu$1.defaultProps = {
  options: [],
  onSelect: () => {}
};

const MobileNumber = props => {
  const user_type = Digit.SessionStorage.get("userType");
  const onChange = e => {
    var _props$onChange;
    let val = e.target.value;
    if (isNaN(val) || [" ", "e", "E"].some(e => val.includes(e)) || val.length > (props.maxLength || 10)) {
      val = val.slice(0, -1);
    }
    props === null || props === void 0 ? void 0 : (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, val);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "field-container"
  }, !props.hideSpan ? /*#__PURE__*/React.createElement("span", {
    style: {
      maxWidth: "50px",
      marginTop: "unset",
      ...props.labelStyle
    },
    className: "citizen-card-input citizen-card-input--front"
  }, "+91") : null, /*#__PURE__*/React.createElement("div", {
    className: `text-input ${props.className}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: props.name,
    id: props.id,
    className: `${user_type ? "employee-card-input" : "citizen-card-input"} ${props.disable && "disabled"} focus-visible ${props.errorStyle && "employee-card-input-error"}`,
    placeholder: props.placeholder,
    onChange: onChange,
    ref: props.inputRef,
    value: props.value,
    style: {
      ...props.style
    },
    minLength: props.minlength,
    maxLength: props.maxlength,
    max: props.max,
    pattern: props.pattern,
    min: props.min,
    readOnly: props.disable,
    title: props.title,
    step: props.step,
    autoFocus: props.autoFocus,
    onBlur: props.onBlur,
    autoComplete: "off"
  }))));
};
MobileNumber.propTypes = {
  userType: propTypes.string,
  isMandatory: propTypes.bool,
  name: propTypes.string,
  placeholder: propTypes.string,
  onChange: propTypes.func,
  ref: propTypes.func,
  value: propTypes.any
};
MobileNumber.defaultProps = {
  isMandatory: false
};

const MultiLink = ({
  className,
  onHeadClick,
  displayOptions: _displayOptions = false,
  options,
  label,
  icon,
  showOptions,
  downloadBtnClassName,
  optionsClassName,
  style,
  optionsStyle
}) => {
  const {
    t
  } = useTranslation();
  const menuRef = useRef();
  const handleOnClick = useCallback(() => {
    showOptions === null || showOptions === void 0 ? void 0 : showOptions(false);
  }, []);
  Digit.Hooks.useClickOutside(menuRef, handleOnClick, _displayOptions);
  const MenuWrapper = React.forwardRef((props, ref) => {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: `multilink-optionWrap ${optionsClassName}`,
      style: optionsStyle
    }, options.map((option, index) => /*#__PURE__*/React.createElement("div", {
      onClick: () => option.onClick(),
      key: index,
      className: "multilink-option"
    }, option === null || option === void 0 ? void 0 : option.icon, option.label)));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: menuRef
  }, /*#__PURE__*/React.createElement("div", {
    className: `multilink-labelWrap ${downloadBtnClassName}`,
    onClick: onHeadClick,
    style: style
  }, /*#__PURE__*/React.createElement(LinkButton, {
    label: label || t("CS_COMMON_DOWNLOAD"),
    className: "multilink-link-letter-button"
  })), _displayOptions ? /*#__PURE__*/React.createElement(MenuWrapper, {
    ref: menuRef
  }) : null);
};

const MultiSelectDropdown = ({
  options,
  optionsKey,
  selected: _selected = [],
  onSelect,
  defaultLabel: _defaultLabel = "",
  defaultUnit: _defaultUnit = "",
  BlockNumber: _BlockNumber = 1,
  isOBPSMultiple: _isOBPSMultiple = false,
  props: _props = {},
  isPropsNeeded: _isPropsNeeded = false,
  ServerStyle: _ServerStyle = {}
}) => {
  const [active, setActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [optionIndex, setOptionIndex] = useState(-1);
  const dropdownRef = useRef();
  const {
    t
  } = useTranslation();
  function reducer(state, action) {
    var _action$payload, _action$payload$;
    switch (action.type) {
      case "ADD_TO_SELECTED_EVENT_QUEUE":
        return [...state, {
          [optionsKey]: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$ = _action$payload[1]) === null || _action$payload$ === void 0 ? void 0 : _action$payload$[optionsKey],
          propsData: action.payload
        }];
      case "REMOVE_FROM_SELECTED_EVENT_QUEUE":
        return state.filter(e => {
          var _action$payload2, _action$payload2$;
          return (e === null || e === void 0 ? void 0 : e[optionsKey]) !== ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$ = _action$payload2[1]) === null || _action$payload2$ === void 0 ? void 0 : _action$payload2$[optionsKey]);
        });
      case "REPLACE_COMPLETE_STATE":
        return action.payload;
      default:
        return state;
    }
  }
  useEffect(() => {
    dispatch({
      type: "REPLACE_COMPLETE_STATE",
      payload: fnToSelectOptionThroughProvidedSelection(_selected)
    });
  }, [_selected]);
  function fnToSelectOptionThroughProvidedSelection(selected) {
    return selected === null || selected === void 0 ? void 0 : selected.map(e => ({
      [optionsKey]: e === null || e === void 0 ? void 0 : e[optionsKey],
      propsData: [null, e]
    }));
  }
  const [alreadyQueuedSelectedState, dispatch] = useReducer(reducer, _selected, fnToSelectOptionThroughProvidedSelection);
  useEffect(() => {
    if (!active) {
      onSelect(alreadyQueuedSelectedState === null || alreadyQueuedSelectedState === void 0 ? void 0 : alreadyQueuedSelectedState.map(e => e.propsData), _props);
    }
  }, [active]);
  function handleOutsideClickAndSubmitSimultaneously() {
    setActive(false);
  }
  Digit.Hooks.useClickOutside(dropdownRef, handleOutsideClickAndSubmitSimultaneously, active, {
    capture: true
  });
  const filtOptns = (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0 ? options.filter(option => t(option[optionsKey] && typeof option[optionsKey] == "string" && option[optionsKey].toUpperCase()).toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) : options;
  function onSearch(e) {
    setSearchQuery(e.target.value);
  }
  function onSelectToAddToQueue(...props) {
    const isChecked = arguments[0].target.checked;
    isChecked ? dispatch({
      type: "ADD_TO_SELECTED_EVENT_QUEUE",
      payload: arguments
    }) : dispatch({
      type: "REMOVE_FROM_SELECTED_EVENT_QUEUE",
      payload: arguments
    });
  }
  const keyChange = e => {
    if (e.key == "ArrowDown") {
      setOptionIndex(state => state + 1 == filtOptns.length ? 0 : state + 1);
      if (optionIndex + 1 == filtOptns.length) {
        var _e$target, _e$target$parentEleme, _e$target$parentEleme2, _e$target$parentEleme3, _e$target$parentEleme4, _e$target$parentEleme5;
        e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$parentEleme = _e$target.parentElement) === null || _e$target$parentEleme === void 0 ? void 0 : (_e$target$parentEleme2 = _e$target$parentEleme.parentElement) === null || _e$target$parentEleme2 === void 0 ? void 0 : (_e$target$parentEleme3 = _e$target$parentEleme2.children) === null || _e$target$parentEleme3 === void 0 ? void 0 : (_e$target$parentEleme4 = _e$target$parentEleme3.namedItem("jk-dropdown-unique")) === null || _e$target$parentEleme4 === void 0 ? void 0 : (_e$target$parentEleme5 = _e$target$parentEleme4.scrollTo) === null || _e$target$parentEleme5 === void 0 ? void 0 : _e$target$parentEleme5.call(_e$target$parentEleme4, 0, 0);
      } else {
        var _e$target2, _e$target2$parentElem, _e$target2$parentElem2, _e$target2$parentElem3, _e$target2$parentElem4, _e$target2$parentElem5;
        optionIndex > 2 && (e === null || e === void 0 ? void 0 : (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : (_e$target2$parentElem = _e$target2.parentElement) === null || _e$target2$parentElem === void 0 ? void 0 : (_e$target2$parentElem2 = _e$target2$parentElem.parentElement) === null || _e$target2$parentElem2 === void 0 ? void 0 : (_e$target2$parentElem3 = _e$target2$parentElem2.children) === null || _e$target2$parentElem3 === void 0 ? void 0 : (_e$target2$parentElem4 = _e$target2$parentElem3.namedItem("jk-dropdown-unique")) === null || _e$target2$parentElem4 === void 0 ? void 0 : (_e$target2$parentElem5 = _e$target2$parentElem4.scrollBy) === null || _e$target2$parentElem5 === void 0 ? void 0 : _e$target2$parentElem5.call(_e$target2$parentElem4, 0, 45));
      }
      e.preventDefault();
    } else if (e.key == "ArrowUp") {
      setOptionIndex(state => state !== 0 ? state - 1 : filtOptns.length - 1);
      if (optionIndex === 0) {
        var _e$target3, _e$target3$parentElem, _e$target3$parentElem2, _e$target3$parentElem3, _e$target3$parentElem4, _e$target3$parentElem5;
        e === null || e === void 0 ? void 0 : (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : (_e$target3$parentElem = _e$target3.parentElement) === null || _e$target3$parentElem === void 0 ? void 0 : (_e$target3$parentElem2 = _e$target3$parentElem.parentElement) === null || _e$target3$parentElem2 === void 0 ? void 0 : (_e$target3$parentElem3 = _e$target3$parentElem2.children) === null || _e$target3$parentElem3 === void 0 ? void 0 : (_e$target3$parentElem4 = _e$target3$parentElem3.namedItem("jk-dropdown-unique")) === null || _e$target3$parentElem4 === void 0 ? void 0 : (_e$target3$parentElem5 = _e$target3$parentElem4.scrollTo) === null || _e$target3$parentElem5 === void 0 ? void 0 : _e$target3$parentElem5.call(_e$target3$parentElem4, 100000, 100000);
      } else {
        var _e$target4, _e$target4$parentElem, _e$target4$parentElem2, _e$target4$parentElem3, _e$target4$parentElem4, _e$target4$parentElem5;
        optionIndex > 2 && (e === null || e === void 0 ? void 0 : (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : (_e$target4$parentElem = _e$target4.parentElement) === null || _e$target4$parentElem === void 0 ? void 0 : (_e$target4$parentElem2 = _e$target4$parentElem.parentElement) === null || _e$target4$parentElem2 === void 0 ? void 0 : (_e$target4$parentElem3 = _e$target4$parentElem2.children) === null || _e$target4$parentElem3 === void 0 ? void 0 : (_e$target4$parentElem4 = _e$target4$parentElem3.namedItem("jk-dropdown-unique")) === null || _e$target4$parentElem4 === void 0 ? void 0 : (_e$target4$parentElem5 = _e$target4$parentElem4.scrollBy) === null || _e$target4$parentElem5 === void 0 ? void 0 : _e$target4$parentElem5.call(_e$target4$parentElem4, 0, -45));
      }
      e.preventDefault();
    } else if (e.key == "Enter") {
      onSelectToAddToQueue(e, filtOptns[optionIndex]);
    }
  };
  const MenuItem = ({
    option,
    index
  }) => /*#__PURE__*/React.createElement("div", {
    key: index,
    style: _isOBPSMultiple ? index % 2 !== 0 ? {
      background: "#EEEEEE"
    } : {} : {}
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: option[optionsKey],
    checked: alreadyQueuedSelectedState !== null && alreadyQueuedSelectedState !== void 0 && alreadyQueuedSelectedState.find(selectedOption => selectedOption[optionsKey] === option[optionsKey]) ? true : false,
    onChange: e => _isPropsNeeded ? onSelectToAddToQueue(e, option, _props) : _isOBPSMultiple ? onSelectToAddToQueue(e, option, _BlockNumber) : onSelectToAddToQueue(e, option),
    style: {
      minWidth: "24px",
      width: "100%"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "custom-checkbox"
  }, /*#__PURE__*/React.createElement(CheckSvg, {
    style: {
      innerWidth: "24px",
      width: "24px"
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "label",
    style: index === optionIndex ? {
      opacity: 1,
      backgroundColor: "rgba(238, 238, 238, var(--bg-opacity))"
    } : {}
  }, t(option[optionsKey] && typeof option[optionsKey] == "string" && option[optionsKey])));
  const Menu = () => {
    const filteredOptions = (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0 ? options.filter(option => t(option[optionsKey] && typeof option[optionsKey] == "string" && option[optionsKey].toUpperCase()).toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) : options;
    return filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map((option, index) => /*#__PURE__*/React.createElement(MenuItem, {
      option: option,
      key: index,
      index: index
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "multi-select-dropdown-wrap",
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement("div", {
    className: `master${active ? `-active` : ``}`
  }, /*#__PURE__*/React.createElement("input", {
    className: "cursorPointer",
    type: "text",
    onKeyDown: keyChange,
    onFocus: () => setActive(true),
    value: searchQuery,
    onChange: onSearch
  }), /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, /*#__PURE__*/React.createElement("p", null, (alreadyQueuedSelectedState === null || alreadyQueuedSelectedState === void 0 ? void 0 : alreadyQueuedSelectedState.length) > 0 ? `${alreadyQueuedSelectedState.length} ${_defaultUnit}` : _defaultLabel), /*#__PURE__*/React.createElement(ArrowDown, null))), active ? /*#__PURE__*/React.createElement("div", {
    className: "server",
    id: "jk-dropdown-unique",
    style: _ServerStyle ? _ServerStyle : {}
  }, /*#__PURE__*/React.createElement(Menu, null)) : null);
};

const MenuItem = ({
  item
}) => {
  let itemComponent;
  if (item.type === "component") {
    itemComponent = item.action;
  } else {
    itemComponent = item.text;
  }
  const Item = () => /*#__PURE__*/React.createElement("span", Object.assign({
    className: "menu-item"
  }, item.populators), (item === null || item === void 0 ? void 0 : item.icon) && item.icon, /*#__PURE__*/React.createElement("div", {
    className: "menu-label"
  }, itemComponent));
  if (item.type === "external-link") {
    return /*#__PURE__*/React.createElement("a", {
      href: item.link
    }, /*#__PURE__*/React.createElement(Item, null));
  }
  if (item.type === "link") {
    return /*#__PURE__*/React.createElement(Link, {
      to: item.link
    }, /*#__PURE__*/React.createElement(Item, null));
  }
  return /*#__PURE__*/React.createElement(Item, null);
};
const NavBar = ({
  open,
  profileItem,
  menuItems,
  onClose,
  Footer
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      height: "100%",
      width: "100%",
      top: "0px",
      left: `${open ? "0px" : "-100%"}`,
      opacity: "1",
      backgroundColor: "rgba(0, 0, 0, 0.54)",
      willChange: "opacity",
      transform: "translateZ(0px)",
      transition: "left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
      zIndex: "1200",
      pointerzevents: "auto"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      marginTop: "56px",
      height: "calc(100vh - 56px)",
      position: "fixed",
      top: 0,
      left: 0,
      transition: "transform 0.3s ease-in-out",
      background: "#fff",
      zIndex: "1999",
      width: "300px",
      transform: `${open ? "translateX(0)" : "translateX(-450px)"}`,
      boxShadow: "rgb(0 0 0 / 16%) 8px 0px 16px"
    }
  }, profileItem, /*#__PURE__*/React.createElement("div", {
    className: "drawer-list"
  }, menuItems.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index
  }, /*#__PURE__*/React.createElement(MenuItem, {
    item: item
  })))), /*#__PURE__*/React.createElement("div", {
    className: "side-bar-footer"
  }, Footer))));
};

const BACKSPACE = 8;
const SingleInput = ({
  isFocus,
  onChange,
  onFocus,
  value,
  ...rest
}) => {
  const inputRef = useRef();
  useEffect(() => {
    if (isFocus) {
      inputRef.current.focus();
    }
  }, [isFocus]);
  return /*#__PURE__*/React.createElement("input", Object.assign({
    className: "input-otp",
    maxLength: 1,
    onChange: onChange,
    onFocus: onFocus,
    ref: inputRef,
    type: "number",
    value: value ? value : ""
  }, rest));
};
const OTPInput = props => {
  const [activeInput, setActiveInput] = useState(0);
  const isInputValueValid = value => {
    return typeof value === "string" && value.trim().length === 1;
  };
  const changeCodeAtFocus = value => {
    const {
      onChange
    } = props;
    const otp = getOtpValue();
    otp[activeInput] = value[0];
    const otpValue = otp.join("");
    onChange(otpValue);
  };
  const focusNextInput = () => {
    setActiveInput(activeInput => Math.min(activeInput + 1, props.length - 1));
  };
  const focusPrevInput = () => {
    setActiveInput(activeInput => Math.max(activeInput - 1, 0));
  };
  const getOtpValue = () => props.value ? props.value.toString().split("") : [];
  const handleKeyDown = event => {
    if (event.keyCode === BACKSPACE || event.key === "Backspace") {
      event.preventDefault();
      changeCodeAtFocus("");
      focusPrevInput();
    }
  };
  function inputChange(event) {
    const {
      value
    } = event.target;
    changeCodeAtFocus(value);
    if (isInputValueValid(value)) {
      focusNextInput();
    }
  }
  const OTPStack = [];
  const otp = getOtpValue();
  for (let i = 0; i < props.length; i++) {
    OTPStack.push( /*#__PURE__*/React.createElement(SingleInput, {
      key: i,
      isFocus: activeInput === i,
      onChange: inputChange,
      onKeyDown: handleKeyDown,
      onFocus: e => {
        setActiveInput(i);
        e.target.select();
      },
      value: otp[i]
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "input-otp-wrap"
  }, OTPStack);
};
OTPInput.propTypes = {
  length: propTypes.number
};
OTPInput.defaultProps = {
  length: 0
};

const PrivateRoute = ({
  component: Component,
  roles,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Route, Object.assign({}, rest, {
    render: props => {
      const user = Digit.UserService.getUser();
      const userType = Digit.UserService.getType();
      function getLoginRedirectionLink() {
        if (userType === "employee") {
          return "/digit-ui/employee";
        } else {
          return "/digit-ui/citizen";
        }
      }
      if (!user || !user.access_token) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: {
            pathname: getLoginRedirectionLink(),
            state: {
              from: props.location.pathname + props.location.search
            }
          }
        });
      }
      return /*#__PURE__*/React.createElement(Component, props);
    }
  }));
};

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear;

function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq;

function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf;

var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete;

function listCacheGet(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet;

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas;

function listCacheSet(key, value) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet;

function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;

function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}
var _stackClear = stackClear;

function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete;

function stackGet(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet;

function stackHas(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas;

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;

var objectProto = Object.prototype;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var _getRawTag = getRawTag;

var objectProto$1 = Object.prototype;
var nativeObjectToString$1 = objectProto$1.toString;
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}
var _objectToString = objectToString;

var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}
var _baseGetTag = baseGetTag;

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction;

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked;

var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource;

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype,
  objectProto$2 = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}
var _baseIsNative = baseIsNative;

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue;

function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}
var _getNative = getNative;

var Map$1 = _getNative(_root, 'Map');
var _Map = Map$1;

var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}
var _hashClear = hashClear;

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete;

var HASH_UNDEFINED = '__lodash_hash_undefined__';
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet;

var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$4.call(data, key);
}
var _hashHas = hashHas;

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet;

function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}
var _mapCacheClear = mapCacheClear;

function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable;

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData;

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete;

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}
var _mapCacheGet = mapCacheGet;

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}
var _mapCacheHas = mapCacheHas;

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet;

function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;

var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet;

function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}
var _setCacheAdd = setCacheAdd;

function setCacheHas(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas;

function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new _MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;
var _SetCache = SetCache;

function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome;

function cacheHas(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas;

var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG ? new _SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!_arraySome(other, function (othValue, othIndex) {
        if (!_cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}
var _equalArrays = equalArrays;

var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;

function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray;

function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray;

var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;
var boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]';
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq_1(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == other + '';
    case mapTag:
      var convert = _mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag;

function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush;

var isArray = Array.isArray;
var isArray_1 = isArray;

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys;

function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter;

function stubArray() {
  return [];
}
var stubArray_1 = stubArray;

var objectProto$5 = Object.prototype;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols;

function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes;

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike;

var argsTag = '[object Arguments]';
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}
var _baseIsArguments = baseIsArguments;

var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments;

function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
  var freeExports =  exports && !exports.nodeType && exports;
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? _root.Buffer : undefined;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});

var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex;

var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength;

var argsTag$1 = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$1 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag$1 = '[object String]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}
var _baseIsTypedArray = baseIsTypedArray;

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  var freeExports =  exports && !exports.nodeType && exports;
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && _freeGlobal.process;
  var nodeUtil = function () {
    try {
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
});

var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;

var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
    isArg = !isArr && isArguments_1(value),
    isBuff = !isArr && !isArg && isBuffer_1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? _baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || _isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys;

var objectProto$8 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
  return value === proto;
}
var _isPrototype = isPrototype;

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg;

var nativeKeys = _overArg(Object.keys, Object);
var _nativeKeys = nativeKeys;

var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys;

function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}
var isArrayLike_1 = isArrayLike;

function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}
var keys_1 = keys;

function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}
var _getAllKeys = getAllKeys;

var COMPARE_PARTIAL_FLAG$2 = 1;
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
    objProps = _getAllKeys(object),
    objLength = objProps.length,
    othProps = _getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}
var _equalObjects = equalObjects;

var DataView = _getNative(_root, 'DataView');
var _DataView = DataView;

var Promise$1 = _getNative(_root, 'Promise');
var _Promise = Promise$1;

var Set$1 = _getNative(_root, 'Set');
var _Set = Set$1;

var WeakMap$1 = _getNative(_root, 'WeakMap');
var _WeakMap = WeakMap$1;

var mapTag$2 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$2 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
var dataViewCtorString = _toSource(_DataView),
  mapCtorString = _toSource(_Map),
  promiseCtorString = _toSource(_Promise),
  setCtorString = _toSource(_Set),
  weakMapCtorString = _toSource(_WeakMap);
var getTag = _baseGetTag;
if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$2 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$2 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function (value) {
    var result = _baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? _toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var _getTag = getTag;

var COMPARE_PARTIAL_FLAG$3 = 1;
var argsTag$2 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  objectTag$2 = '[object Object]';
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
    othIsArr = isArray_1(other),
    objTag = objIsArr ? arrayTag$1 : _getTag(object),
    othTag = othIsArr ? arrayTag$1 : _getTag(other);
  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;
  var objIsObj = objTag == objectTag$2,
    othIsObj = othTag == objectTag$2,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack());
    return objIsArr || isTypedArray_1(object) ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack) : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new _Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack());
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep;

function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike_1(value) && !isObjectLike_1(other)) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
var _baseIsEqual = baseIsEqual;

function isEqual(value, other) {
  return _baseIsEqual(value, other);
}
var isEqual_1 = isEqual;

const RadioButtons = props => {
  var _props$options;
  const {
    t
  } = useTranslation();
  var selected = props.selectedOption;
  function selectOption(value) {
    props.onSelect(value);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: props.style,
    className: `radio-wrap ${props === null || props === void 0 ? void 0 : props.additionalWrapperClass}`
  }, props === null || props === void 0 ? void 0 : (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.map((option, ind) => {
    if (props !== null && props !== void 0 && props.optionsKey && !(props !== null && props !== void 0 && props.isDependent)) {
      return /*#__PURE__*/React.createElement("div", {
        style: props.innerStyles,
        key: ind
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          justifyContent: 'space-between',
          flexDirection: 'row-reverse',
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          ...props.labelStyles
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "radio-btn-wrap"
      }, /*#__PURE__*/React.createElement("input", {
        className: "radio-btn",
        type: "radio",
        value: option,
        checked: props.isPTFlow && (selected === null || selected === void 0 ? void 0 : selected.code) === option.code || isEqual_1(selected, option) ? 1 : 0,
        onChange: () => selectOption(option),
        disabled: props === null || props === void 0 ? void 0 : props.disabled,
        name: props.name,
        ref: props.inputRef
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn-checkmark"
      })), /*#__PURE__*/React.createElement("span", {
        style: props.inputStyle
      }, t(option[props.optionsKey]))));
    } else if (props !== null && props !== void 0 && props.optionsKey && props !== null && props !== void 0 && props.isDependent) {
      return /*#__PURE__*/React.createElement("div", {
        style: props.innerStyles,
        key: ind
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          alignItems: 'center',
          display: 'flex',
          marginLeft: 0,
          gap: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "radio-btn-wrap"
      }, /*#__PURE__*/React.createElement("input", {
        className: "radio-btn",
        type: "radio",
        value: option,
        checked: (selected === null || selected === void 0 ? void 0 : selected.code) === option.code ? 1 : 0,
        onChange: () => selectOption(option),
        disabled: props === null || props === void 0 ? void 0 : props.disabled,
        name: props.name,
        ref: props.inputRef
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn-checkmark"
      })), /*#__PURE__*/React.createElement("span", {
        style: props.inputStyle
      }, t(props.labelKey ? `${props.labelKey}_${option.code}` : option.code))));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        style: props.innerStyles,
        key: ind
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          alignItems: 'center',
          display: 'flex',
          marginLeft: 0,
          gap: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "radio-btn-wrap"
      }, /*#__PURE__*/React.createElement("input", {
        className: "radio-btn",
        type: "radio",
        value: option,
        checked: selected === option ? 1 : 0,
        onChange: () => selectOption(option),
        disabled: props === null || props === void 0 ? void 0 : props.disabled,
        name: props.name,
        ref: props.inputRef
      }), /*#__PURE__*/React.createElement("span", {
        className: "radio-btn-checkmark"
      })), /*#__PURE__*/React.createElement("span", {
        style: props.inputStyle
      }, t(option))));
    }
  }));
};
RadioButtons.propTypes = {
  selectedOption: propTypes.any,
  onSelect: propTypes.func,
  options: propTypes.any,
  optionsKey: propTypes.string,
  innerStyles: propTypes.any,
  style: propTypes.any
};
RadioButtons.defaultProps = {};

const Rating = props => {
  var stars = [];
  const star = useRef(null);
  for (var i = 1; i <= props.maxRating; i++) {
    if (i - props.currentRating <= 0) {
      const index = i;
      stars.push( /*#__PURE__*/React.createElement(StarFilled, {
        key: i,
        id: `${props.id}gradient${i}`,
        className: "rating-star",
        styles: props.starStyles,
        onClick: e => props.onFeedback(e, star, index)
      }));
    } else if (i - props.currentRating > 0 && i - props.currentRating < 1) {
      const index = i;
      stars.push( /*#__PURE__*/React.createElement(StarFilled, {
        key: i,
        id: `${props.id}gradient${i}`,
        className: "rating-star",
        styles: props.starStyles,
        onClick: e => props.onFeedback(e, star, index),
        percentage: Math.round((props.currentRating - parseInt(props.currentRating)) * 100)
      }));
    } else {
      const index = i;
      stars.push( /*#__PURE__*/React.createElement(StarEmpty, {
        key: i,
        className: "rating-star",
        styles: props.starStyles,
        onClick: e => props.onFeedback(e, star, index)
      }));
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${props.withText ? "rating-with-text" : "rating-star-wrap"}`,
    style: {
      ...props.styles
    }
  }, props.text ? props.text : "", " ", stars);
};
Rating.propTypes = {
  maxRating: propTypes.number,
  currentRating: propTypes.number,
  onFeedback: propTypes.func
};
Rating.defaultProps = {
  maxRating: 5,
  id: '0',
  currentRating: 0,
  onFeedback: () => {}
};

const RoundedLabel = ({
  count
}) => count ? /*#__PURE__*/React.createElement("div", {
  className: "roundedLabel"
}, count) : /*#__PURE__*/React.createElement(React.Fragment, null);

const TextField$1 = props => {
  const [value, setValue] = useState(props.selectedVal ? props.selectedVal : "");
  useEffect(() => {
    props.selectedVal ? setValue(props.selectedVal) : null;
  }, [props.selectedVal]);
  function inputChange(e) {
    setValue(e.target.value);
    props.setFilter(e.target.value);
  }
  return /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: value,
    onChange: inputChange,
    onClick: props.onClick
  });
};
const SectionalDropdown = props => {
  const [dropdownStatus, setDropdownStatus] = useState(false);
  const [selectedOption, setSelectedOption] = useState(props.selected ? props.selected : null);
  const [filterVal, setFilterVal] = useState("");
  useEffect(() => {
    setSelectedOption(props.selected);
  }, [props.selected]);
  function dropdownSwitch() {
    var current = dropdownStatus;
    setDropdownStatus(!current);
  }
  function dropdownOn() {
    setDropdownStatus(true);
  }
  function onSelect(selectedOption) {
    props.select(selectedOption);
    setSelectedOption(selectedOption);
    setDropdownStatus(false);
  }
  function setFilter(val) {
    setFilterVal(val);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "sect-dropdown-wrap",
    style: {
      ...props.style
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "sect-dropdown-input-wrap"
  }, /*#__PURE__*/React.createElement(TextField$1, {
    setFilter: setFilter,
    selectedVal: selectedOption ? props.t ? props.t(props.displayKey ? selectedOption[props.displayKey] : selectedOption) : props.displayKey ? selectedOption[props.displayKey] : selectedOption : null,
    filterVal: filterVal,
    onClick: dropdownOn
  }), /*#__PURE__*/React.createElement(ArrowDown, {
    onClick: dropdownSwitch
  })), dropdownStatus ? /*#__PURE__*/React.createElement("div", {
    className: "sect-dropdown-card"
  }, props.menuData.filter(subMenu => subMenu.options.filter(option => option[props.displayKey].toUpperCase().includes(filterVal.toUpperCase()))).map((subMenu, index) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement("h1", null, subMenu.heading), subMenu.options.map((option, index) => {
      return /*#__PURE__*/React.createElement("p", {
        key: index,
        onClick: () => onSelect(option)
      }, props.t ? props.t(option[props.displayKey]) : option[props.displayKey]);
    }));
  })) : null);
};

const LastRow = props => {
  return /*#__PURE__*/React.createElement("div", {
    styles: props.rowContainerStyle,
    className: "row-last"
  }, /*#__PURE__*/React.createElement("h2", null, props.label), /*#__PURE__*/React.createElement("p", null, props.text));
};
const Row = props => {
  let value = props.text;
  let valueStyle = props.textStyle || {};
  let labelStyle = props.labelStyle || {};
  if (Array.isArray(props.text)) {
    value = props.text.map((val, index) => {
      if (val !== null && val !== void 0 && val.className) {
        return /*#__PURE__*/React.createElement("p", {
          className: val === null || val === void 0 ? void 0 : val.className,
          style: val === null || val === void 0 ? void 0 : val.style,
          key: index
        }, val === null || val === void 0 ? void 0 : val.value);
      }
      return /*#__PURE__*/React.createElement("p", {
        key: index
      }, val);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    style: props.rowContainerStyle,
    className: `${props.last ? "row last" : "row"} ${(props === null || props === void 0 ? void 0 : props.className) || ""}`
  }, /*#__PURE__*/React.createElement("h2", {
    style: labelStyle
  }, props.label), /*#__PURE__*/React.createElement("div", {
    className: "value",
    style: valueStyle
  }, value, props.caption && /*#__PURE__*/React.createElement("div", {
    className: "caption"
  }, props.caption)), props.actionButton ? /*#__PURE__*/React.createElement("div", {
    style: props.actionButtonStyle,
    className: "action-button"
  }, props.actionButton) : null);
};
const MediaRow = props => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, props.label), /*#__PURE__*/React.createElement("span", null, props.children));
};
const StatusTable = props => {
  const employee = Digit.SessionStorage.get("user_type") === "employee" ? true : false;
  if (props.dataObject) {
    return /*#__PURE__*/React.createElement("div", {
      className: employee ? "employee-data-table" : "data-table",
      style: props.style
    }, Object.keys(props.dataObject).map((name, index) => {
      if (++index === Object.keys(props.dataObject).length) {
        return /*#__PURE__*/React.createElement(LastRow, {
          key: index,
          label: name,
          text: props.dataObject[name]
        });
      }
      return /*#__PURE__*/React.createElement(Row, {
        key: index,
        label: name,
        text: props.dataObject[name]
      });
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: employee ? "employee-data-table" : "data-table",
      style: props.style
    }, props.children);
  }
};

const SubmitBar = props => {
  return /*#__PURE__*/React.createElement("button", Object.assign({
    disabled: props.disabled ? true : false,
    className: `${props.disabled ? "submit-bar-disabled" : "submit-bar"} ${props.className ? props.className : ""}`,
    type: props.submit ? "submit" : "button",
    style: {
      ...props.style
    },
    onClick: props.onSubmit
  }, props.form ? {
    form: props.form
  } : {}), /*#__PURE__*/React.createElement("header", null, props.label));
};
SubmitBar.propTypes = {
  submit: propTypes.any,
  style: propTypes.object,
  label: propTypes.string,
  onSubmit: propTypes.func
};
SubmitBar.defaultProps = {};

const StandaloneSearchBar = ({
  placeholder
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "StandaloneSearchBar"
  }, /*#__PURE__*/React.createElement(SearchIconSvg, null), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: placeholder
  }));
};

const noop = () => {};
const Table = ({
  className: _className = "table",
  t,
  data,
  columns,
  getCellProps,
  currentPage: _currentPage = 0,
  pageSizeLimit: _pageSizeLimit = 10,
  disableSort: _disableSort = true,
  autoSort: _autoSort = false,
  initSortId: _initSortId = "",
  onSearch: _onSearch = false,
  manualPagination: _manualPagination = true,
  totalRecords,
  onNextPage,
  onPrevPage,
  globalSearch,
  onSort: _onSort = noop,
  onPageSizeChange,
  onLastPage,
  onFirstPage,
  isPaginationRequired: _isPaginationRequired = true,
  sortParams: _sortParams = [],
  showAutoSerialNo: _showAutoSerialNo = false,
  customTableWrapperClassName: _customTableWrapperClassName = "",
  styles: _styles = {}
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: {
      pageIndex,
      pageSize,
      sortBy,
      globalFilter
    }
  } = useTable({
    columns,
    data,
    initialState: {
      pageIndex: _currentPage,
      pageSize: _pageSizeLimit,
      sortBy: _autoSort ? [{
        id: _initSortId,
        desc: false
      }] : _sortParams
    },
    pageCount: totalRecords > 0 ? Math.ceil(totalRecords / _pageSizeLimit) : -1,
    manualPagination: _manualPagination,
    disableMultiSort: false,
    disableSortBy: _disableSort,
    manualSortBy: _autoSort ? false : true,
    autoResetPage: false,
    autoResetSortBy: false,
    disableSortRemove: true,
    disableGlobalFilter: _onSearch === false ? true : false,
    globalFilter: globalSearch || "text",
    useControlledState: state => {
      return React.useMemo(() => ({
        ...state,
        pageIndex: _manualPagination ? _currentPage : state.pageIndex
      }));
    }
  }, useGlobalFilter, useSortBy, usePagination, useRowSelect);
  useEffect(() => {
    _onSort(sortBy);
  }, [_onSort, sortBy]);
  useEffect(() => setGlobalFilter(_onSearch), [_onSearch, setGlobalFilter]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: _customTableWrapperClassName
  }, /*#__PURE__*/React.createElement("table", Object.assign({
    className: _className
  }, getTableProps(), {
    style: _styles
  }), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(headerGroup => /*#__PURE__*/React.createElement("tr", headerGroup.getHeaderGroupProps(), _showAutoSerialNo && /*#__PURE__*/React.createElement("th", {
    style: {
      verticalAlign: "top"
    }
  }, _showAutoSerialNo && typeof _showAutoSerialNo == "string" ? t(_showAutoSerialNo) : t("TB_SNO")), headerGroup.headers.map(column => /*#__PURE__*/React.createElement("th", Object.assign({}, column.getHeaderProps(column.getSortByToggleProps()), {
    style: {
      verticalAlign: "top"
    }
  }), column.render("Header"), /*#__PURE__*/React.createElement("span", null, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(SortDown, null) : /*#__PURE__*/React.createElement(SortUp, null) : "")))))), /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), page.map((row, i) => {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", row.getRowProps(), _showAutoSerialNo && /*#__PURE__*/React.createElement("td", null, i + 1), row.cells.map(cell => {
      return /*#__PURE__*/React.createElement("td", cell.getCellProps([getCellProps(cell)]), cell.attachment_link ? /*#__PURE__*/React.createElement("a", {
        style: {
          color: "#1D70B8"
        },
        href: cell.attachment_link
      }, cell.render("Cell")) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", cell.render("Cell"), " "));
    }));
  })))), _isPaginationRequired && /*#__PURE__*/React.createElement("div", {
    className: "pagination dss-white-pre"
  }, `${t("CS_COMMON_ROWS_PER_PAGE")} :`, /*#__PURE__*/React.createElement("select", {
    className: "cp",
    value: pageSize,
    style: {
      marginRight: "15px"
    },
    onChange: _manualPagination ? onPageSizeChange : e => setPageSize(Number(e.target.value))
  }, [10, 20, 30, 40, 50].map(pageSize => /*#__PURE__*/React.createElement("option", {
    key: pageSize,
    value: pageSize
  }, pageSize))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, pageIndex * pageSize + 1, "-", _manualPagination ? (_currentPage + 1) * _pageSizeLimit > totalRecords ? totalRecords : (_currentPage + 1) * _pageSizeLimit : pageIndex * pageSize + (page === null || page === void 0 ? void 0 : page.length), " ", totalRecords ? `of ${_manualPagination ? totalRecords : rows.length}` : ""), " "), !_manualPagination && pageIndex != 0 && /*#__PURE__*/React.createElement(ArrowToFirst, {
    onClick: () => gotoPage(0),
    className: "cp"
  }), canPreviousPage && _manualPagination && onFirstPage && /*#__PURE__*/React.createElement(ArrowToFirst, {
    onClick: () => _manualPagination && onFirstPage(),
    className: "cp"
  }), canPreviousPage && /*#__PURE__*/React.createElement(ArrowBack, {
    onClick: () => _manualPagination ? onPrevPage() : previousPage(),
    className: "cp"
  }), canNextPage && /*#__PURE__*/React.createElement(ArrowForward, {
    onClick: () => _manualPagination ? onNextPage() : nextPage(),
    className: "cp"
  }), !_manualPagination && pageIndex != pageCount - 1 && /*#__PURE__*/React.createElement(ArrowToLast, {
    onClick: () => gotoPage(pageCount - 1),
    className: "cp"
  }), rows.length == _pageSizeLimit && canNextPage && _manualPagination && onLastPage && /*#__PURE__*/React.createElement(ArrowToLast, {
    onClick: () => _manualPagination && onLastPage(),
    className: "cp"
  })));
};

const TelePhone = ({
  mobile,
  text
}) => /*#__PURE__*/React.createElement(React.Fragment, null, text, /*#__PURE__*/React.createElement("div", {
  className: "telephone"
}, /*#__PURE__*/React.createElement("div", {
  className: "call"
}, /*#__PURE__*/React.createElement(Phone, {
  fillcolor: "FFFFFF",
  style: {
    marginLeft: "0px"
  }
}), /*#__PURE__*/React.createElement("a", {
  href: `tel:${mobile}`
}, "+91", " ", mobile))));
TelePhone.propTypes = {
  mobile: propTypes.any,
  text: propTypes.string
};
TelePhone.defaultProps = {
  mobile: "",
  text: ""
};

const TextArea = props => {
  const user_type = Digit.SessionStorage.get("userType");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", {
    name: props.name,
    ref: props.inputRef,
    style: props.style,
    id: props.id,
    value: props.value,
    onChange: props.onChange,
    className: `${user_type ? "employee-card-textarea" : "card-textarea"} ${props.disable && "disabled"} ${props !== null && props !== void 0 && props.className ? props === null || props === void 0 ? void 0 : props.className : ""}`,
    minLength: props.minLength,
    maxLength: props.maxLength,
    autoComplete: "off",
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement("p", {
    className: "cell-text"
  }, props.hintText));
};
TextArea.propTypes = {
  userType: propTypes.string,
  name: propTypes.string.isRequired,
  ref: propTypes.func,
  value: propTypes.string,
  onChange: propTypes.func,
  id: propTypes.string
};
TextArea.defaultProps = {
  ref: undefined,
  onChange: undefined
};

const PasswordVisibility = ({
  isPasswordVisible,
  setIsPasswordVisible
}) => {
  const IconButton = ({
    children,
    ...props
  }) => /*#__PURE__*/React.createElement("button", Object.assign({}, props, {
    style: {
      boxSizing: 'content-box',
      position: 'absolute',
      padding: 8,
      height: 24,
      width: 24,
      right: 0,
      top: 0,
      '& svg': {
        height: 24,
        width: 24
      }
    }
  }), children);
  const VisibilityIcon = () => /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    "data-testid": "VisibilityIcon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
  }));
  const VisibilityOffIcon = () => /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    "data-testid": "VisibilityOffIcon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
  }));
  return /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => setIsPasswordVisible(currState => !currState)
  }, isPasswordVisible ? /*#__PURE__*/React.createElement(VisibilityOffIcon, null) : /*#__PURE__*/React.createElement(VisibilityIcon, null));
};

const TextInput = React.forwardRef((props, ref) => {
  var _props$validation, _props$validation2, _props$validation3, _props$validation4, _props$validation5, _props$validation6, _props$validation7;
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const user_type = Digit.SessionStorage.get("userType");
  const [date, setDate] = useState();
  const data = props !== null && props !== void 0 && props.watch ? {
    fromDate: props === null || props === void 0 ? void 0 : props.watch("fromDate"),
    toDate: props === null || props === void 0 ? void 0 : props.watch("toDate")
  } : {};
  const handleDate = event => {
    const {
      value
    } = event.target;
    setDate(getDDMMYYYY(value));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `text-input ${props.className}`,
    style: props !== null && props !== void 0 && props.textInputStyle ? {
      ...props.textInputStyle
    } : {}
  }, props.isMandatory ? /*#__PURE__*/React.createElement("input", {
    type: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation = props.validation) === null || _props$validation === void 0 ? void 0 : _props$validation.type : props.type === 'password' && isPasswordVisible ? 'text' : props.type || "text",
    name: props.name,
    id: props.id,
    className: `${user_type ? "employee-card-input-error" : "card-input-error"} ${props.disable && "disabled"}`,
    placeholder: props.placeholder,
    onChange: event => {
      if (props !== null && props !== void 0 && props.onChange) {
        props === null || props === void 0 ? void 0 : props.onChange(event);
      }
      if (props.type === "date") {
        handleDate(event);
      }
    },
    ref: props.inputRef || ref,
    value: props.value,
    style: {
      ...props.style
    },
    defaultValue: props.defaultValue,
    minLength: props.minlength,
    maxLength: props.maxlength,
    max: props.max,
    pattern: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation2 = props.validation) === null || _props$validation2 === void 0 ? void 0 : _props$validation2.pattern : props.pattern,
    min: props.min,
    readOnly: props.disable,
    title: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation3 = props.validation) === null || _props$validation3 === void 0 ? void 0 : _props$validation3.title : props.title,
    step: props.step,
    autoFocus: props.autoFocus,
    onBlur: props.onBlur,
    autoComplete: 'off',
    disabled: props.disabled
  }) : /*#__PURE__*/React.createElement("input", {
    type: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation4 = props.validation) === null || _props$validation4 === void 0 ? void 0 : _props$validation4.type : props.type === 'password' && isPasswordVisible ? 'text' : props.type || "text",
    name: props.name,
    id: props.id,
    className: `${user_type ? "employee-card-input" : "citizen-card-input"} ${props.disable && "disabled"} focus-visible ${props.errorStyle && "employee-card-input-error"}`,
    placeholder: props.placeholder,
    onChange: event => {
      if (props !== null && props !== void 0 && props.onChange) {
        props === null || props === void 0 ? void 0 : props.onChange(event);
      }
      if (props.type === "date") {
        handleDate(event);
      }
    },
    ref: props.inputRef || ref,
    value: props.value,
    style: {
      ...props.style
    },
    defaultValue: props.defaultValue,
    minLength: props.minlength,
    maxLength: props.maxlength,
    max: props.max,
    required: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation5 = props.validation) === null || _props$validation5 === void 0 ? void 0 : _props$validation5.isRequired : props.isRequired || props.type === "date" && (props.name === "fromDate" ? data.toDate : data.fromDate),
    pattern: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation6 = props.validation) === null || _props$validation6 === void 0 ? void 0 : _props$validation6.pattern : props.pattern,
    min: props.min,
    readOnly: props.disable,
    title: props !== null && props !== void 0 && props.validation && props.ValidationRequired ? props === null || props === void 0 ? void 0 : (_props$validation7 = props.validation) === null || _props$validation7 === void 0 ? void 0 : _props$validation7.title : props.title,
    step: props.step,
    autoFocus: props.autoFocus,
    onBlur: props.onBlur,
    onKeyPress: props.onKeyPress,
    autoComplete: 'off',
    disabled: props.disabled
  }), props.type === "date" && /*#__PURE__*/React.createElement(DatePicker$1, Object.assign({}, props, {
    date: date,
    setDate: setDate,
    data: data
  })), props.type === "password" && /*#__PURE__*/React.createElement(PasswordVisibility, {
    isPasswordVisible,
    setIsPasswordVisible
  }), props.signature ? props.signatureImg : null));
});
TextInput.propTypes = {
  userType: propTypes.string,
  isMandatory: propTypes.bool,
  name: propTypes.string,
  placeholder: propTypes.string,
  onChange: propTypes.func,
  inputRef: propTypes.func,
  value: propTypes.any
};
TextInput.defaultProps = {
  isMandatory: false
};
function DatePicker$1(props) {
  useEffect(() => {
    if (props !== null && props !== void 0 && props.shouldUpdate) {
      props === null || props === void 0 ? void 0 : props.setDate(getDDMMYYYY(props === null || props === void 0 ? void 0 : props.data[props.name]));
    }
  }, [props === null || props === void 0 ? void 0 : props.data]);
  useEffect(() => {
    props.setDate(getDDMMYYYY(props === null || props === void 0 ? void 0 : props.defaultValue));
  }, []);
  return /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `${props.disable && "disabled"} card-date-input`,
    name: props.name,
    id: props.id,
    placeholder: props.placeholder,
    defaultValue: props.date,
    readOnly: true
  });
}
function getDDMMYYYY(date) {
  if (!date) return "";
  return new Date(date).toLocaleString("en-In").split(",")[0];
}

const TopBar = ({
  img,
  isMobile,
  logoUrl,
  onLogout,
  toggleSidebar,
  ulb,
  userDetails,
  notificationCount,
  notificationCountLoaded,
  cityOfCitizenShownBesideLogo,
  onNotificationIconClick,
  hideNotificationIconOnSomeUrlsWhenNotLoggedIn,
  sidebarOpen,
  sidebarToggle
}) => {
  var _Digit$UserService$ge, _userData$roles;
  const [userData, setUserData] = useState(null);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const getUserInfo = async () => {
    const tenant = Digit.ULBService.getCurrentTenantId();
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      try {
        var _usersResponse$user;
        const usersResponse = await Digit.UserService.userSearch(tenant, {
          uuid: [uuid]
        }, {});
        setUserData(usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0]);
      } catch (error) {
        return error;
      }
    }
  };
  const designationName = (userData === null || userData === void 0 ? void 0 : (_userData$roles = userData.roles) === null || _userData$roles === void 0 ? void 0 : _userData$roles.filter(item => item.code !== "CITIZEN").map(item => item.name).join(",")) || "Citizen";
  useEffect(() => {
    getUserInfo();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "navbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "center-container"
  }, isMobile && /*#__PURE__*/React.createElement(Hamburger, {
    handleClick: () => sidebarToggle(sidebarOpen)
  }), /*#__PURE__*/React.createElement("img", {
    className: "city",
    id: "topbar-logo",
    src: logoUrl,
    alt: "Himachal",
    style: {
      background: "white"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "RightMostTopBarOptions",
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AutoLogoutWarning, null)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 18,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: "mx-2 fw-bold"
  }, userData !== null && userData !== void 0 && userData.name ? userData === null || userData === void 0 ? void 0 : userData.name : userInfo === null || userInfo === void 0 ? void 0 : userInfo.name))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mx-2"
  }, designationName))))));
};
TopBar.propTypes = {
  img: propTypes.string
};
TopBar.defaultProps = {
  img: undefined
};

const RemoveableTag = ({
  text,
  onClick,
  extraStyles
}) => /*#__PURE__*/React.createElement("div", {
  className: "tag",
  style: extraStyles ? extraStyles === null || extraStyles === void 0 ? void 0 : extraStyles.tagStyles : {}
}, /*#__PURE__*/React.createElement("span", {
  className: "text",
  style: extraStyles ? extraStyles === null || extraStyles === void 0 ? void 0 : extraStyles.textStyles : {}
}, text), /*#__PURE__*/React.createElement("span", {
  onClick: onClick
}, /*#__PURE__*/React.createElement(Close, {
  className: "close",
  style: extraStyles ? extraStyles === null || extraStyles === void 0 ? void 0 : extraStyles.closeIconStyles : {}
})));

const getRandomId = () => {
  return Math.floor((Math.random() || 1) * 139);
};
const getCitizenStyles = value => {
  let citizenStyles = {};
  if (value == "propertyCreate") {
    citizenStyles = {
      textStyles: {
        whiteSpace: "nowrap",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "80%"
      },
      tagStyles: {
        width: "90%",
        flexWrap: "nowrap"
      },
      inputStyles: {
        width: "44%",
        minHeight: "2rem",
        maxHeight: "3rem",
        top: "20%"
      },
      buttonStyles: {
        height: "auto",
        minHeight: "2rem",
        width: "40%",
        maxHeight: "3rem"
      },
      tagContainerStyles: {
        width: "60%",
        display: "flex",
        marginTop: "0px"
      },
      closeIconStyles: {
        width: "20px"
      },
      containerStyles: {
        padding: "10px",
        marginTop: "0px"
      }
    };
  } else if (value == "IP") {
    citizenStyles = {
      textStyles: {
        whiteSpace: "nowrap",
        maxWidth: "250px",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      tagStyles: {
        marginLeft: "-30px"
      },
      inputStyles: {},
      closeIconStyles: {
        position: "absolute",
        marginTop: "-12px"
      },
      buttonStyles: {},
      tagContainerStyles: {}
    };
  } else if (value == "OBPS") {
    citizenStyles = {
      containerStyles: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexWrap: "wrap",
        margin: "0px",
        padding: "0px"
      },
      tagContainerStyles: {
        margin: "0px",
        padding: "0px",
        width: "46%"
      },
      tagStyles: {
        height: "auto",
        padding: "5px",
        margin: 0,
        width: "100%",
        margin: "5px"
      },
      textStyles: {
        wordBreak: "break-all",
        height: "auto",
        lineHeight: "16px",
        overflow: "hidden",
        maxHeight: "34px"
      },
      inputStyles: {
        width: "43%",
        minHeight: "42px",
        maxHeight: "42px",
        top: "5px",
        left: "5px"
      },
      buttonStyles: {
        height: "auto",
        minHeight: "40px",
        width: "43%",
        maxHeight: "40px",
        margin: "5px",
        padding: "0px"
      },
      closeIconStyles: {
        width: "20px"
      },
      uploadFile: {
        minHeight: "50px"
      }
    };
  } else {
    citizenStyles = {
      textStyles: {},
      tagStyles: {},
      inputStyles: {},
      buttonStyles: {},
      tagContainerStyles: {}
    };
  }
  return citizenStyles;
};
const UploadFile = props => {
  var _inpRef$current, _extraStyles, _extraStyles2, _extraStyles3, _extraStyles4, _props$uploadedFiles, _extraStyles6, _extraStyles7, _extraStyles8, _inpRef$current$files, _inpRef$current$files2, _props$file, _extraStyles9, _extraStyles10;
  const {
    t
  } = useTranslation();
  const inpRef = useRef();
  const [hasFile, setHasFile] = useState(false);
  const [prevSate, setprevSate] = useState(null);
  let extraStyles = {};
  const handleChange = () => {
    if (inpRef.current.files[0]) {
      setHasFile(true);
      setprevSate(inpRef.current.files[0]);
    } else setHasFile(false);
  };
  extraStyles = getCitizenStyles("OBPS");
  const handleDelete = () => {
    inpRef.current.value = "";
    props.onDelete();
  };
  const handleEmpty = () => {
    if (inpRef.current.files.length <= 0 && prevSate !== null) {
      inpRef.current.value = "";
      props.onDelete();
    }
  };
  if (props.uploadMessage && inpRef.current.value) {
    handleDelete();
    setHasFile(false);
  }
  useEffect(() => handleEmpty(), [inpRef === null || inpRef === void 0 ? void 0 : (_inpRef$current = inpRef.current) === null || _inpRef$current === void 0 ? void 0 : _inpRef$current.files]);
  useEffect(() => handleChange(), [props.message]);
  const showHint = (props === null || props === void 0 ? void 0 : props.showHint) || false;
  return /*#__PURE__*/React.createElement(Fragment$1, null, showHint && /*#__PURE__*/React.createElement("p", {
    className: "cell-text"
  }, t(props === null || props === void 0 ? void 0 : props.hintText)), /*#__PURE__*/React.createElement("div", {
    className: `upload-file ${props.disabled ? " disabled" : ""}`,
    style: (_extraStyles = extraStyles) !== null && _extraStyles !== void 0 && _extraStyles.uploadFile ? (_extraStyles2 = extraStyles) === null || _extraStyles2 === void 0 ? void 0 : _extraStyles2.uploadFile : {}
  }, /*#__PURE__*/React.createElement("div", {
    style: extraStyles ? (_extraStyles3 = extraStyles) === null || _extraStyles3 === void 0 ? void 0 : _extraStyles3.containerStyles : null
  }, /*#__PURE__*/React.createElement(ButtonSelector, {
    theme: "border",
    label: t("CS_COMMON_CHOOSE_FILE"),
    style: {
      ...(extraStyles ? (_extraStyles4 = extraStyles) === null || _extraStyles4 === void 0 ? void 0 : _extraStyles4.buttonStyles : {}),
      ...(props.disabled ? {
        display: "none"
      } : {})
    },
    textStyles: props === null || props === void 0 ? void 0 : props.textStyles,
    type: props.buttonType
  }), props === null || props === void 0 ? void 0 : (_props$uploadedFiles = props.uploadedFiles) === null || _props$uploadedFiles === void 0 ? void 0 : _props$uploadedFiles.map((file, index) => {
    var _extraStyles5;
    const fileDetailsData = file[1];
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "tag-container",
      style: extraStyles ? (_extraStyles5 = extraStyles) === null || _extraStyles5 === void 0 ? void 0 : _extraStyles5.tagContainerStyles : null
    }, /*#__PURE__*/React.createElement(RemoveableTag, {
      extraStyles: extraStyles,
      text: file[0],
      onClick: e => props === null || props === void 0 ? void 0 : props.removeTargetedFile(fileDetailsData, e)
    }));
  }), !hasFile || props.error ? /*#__PURE__*/React.createElement("h2", {
    className: "file-upload-status"
  }, props.message) : /*#__PURE__*/React.createElement("div", {
    className: "tag-container",
    style: extraStyles ? (_extraStyles6 = extraStyles) === null || _extraStyles6 === void 0 ? void 0 : _extraStyles6.tagContainerStyles : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "tag",
    style: extraStyles ? (_extraStyles7 = extraStyles) === null || _extraStyles7 === void 0 ? void 0 : _extraStyles7.tagStyles : null
  }, /*#__PURE__*/React.createElement("span", {
    className: "text",
    style: extraStyles ? (_extraStyles8 = extraStyles) === null || _extraStyles8 === void 0 ? void 0 : _extraStyles8.textStyles : null
  }, typeof ((_inpRef$current$files = inpRef.current.files[0]) === null || _inpRef$current$files === void 0 ? void 0 : _inpRef$current$files.name) !== "undefined" && !(props !== null && props !== void 0 && props.file) ? (_inpRef$current$files2 = inpRef.current.files[0]) === null || _inpRef$current$files2 === void 0 ? void 0 : _inpRef$current$files2.name : (_props$file = props.file) === null || _props$file === void 0 ? void 0 : _props$file.name), /*#__PURE__*/React.createElement("span", {
    onClick: () => handleDelete(),
    style: extraStyles ? (_extraStyles9 = extraStyles) === null || _extraStyles9 === void 0 ? void 0 : _extraStyles9.closeIconStyles : null
  }, /*#__PURE__*/React.createElement(Close, {
    style: props.Multistyle,
    className: "close"
  }))))), /*#__PURE__*/React.createElement("input", {
    className: props.disabled ? "disabled" : "" + "input-mirror-selector-button",
    style: extraStyles ? {
      ...((_extraStyles10 = extraStyles) === null || _extraStyles10 === void 0 ? void 0 : _extraStyles10.inputStyles),
      ...(props === null || props === void 0 ? void 0 : props.inputStyles)
    } : {
      ...(props === null || props === void 0 ? void 0 : props.inputStyles)
    },
    ref: inpRef,
    type: "file",
    id: props.id || `document-${getRandomId()}`,
    name: "file",
    multiple: props.multiple,
    accept: props.accept,
    disabled: props.disabled,
    onChange: e => props.onUpload(e),
    onClick: event => {
      const {
        target = {}
      } = event || {};
      target.value = "";
    }
  })), props.iserror && /*#__PURE__*/React.createElement("p", {
    style: {
      color: "red"
    }
  }, props.iserror), (props === null || props === void 0 ? void 0 : props.showHintBelow) && /*#__PURE__*/React.createElement("p", {
    className: "cell-text"
  }, t(props === null || props === void 0 ? void 0 : props.hintText)));
};

const Option = ({
  name,
  Icon,
  onClick,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: className || `CardBasedOptionsMainChildOption`,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "ChildOptionImageWrapper"
  }, Icon), /*#__PURE__*/React.createElement("p", {
    className: "ChildOptionName"
  }, name));
};
const CardBasedOptions = ({
  header,
  sideOption,
  options,
  styles: _styles = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "CardBasedOptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headContent"
  }, /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement("p", {
    onClick: sideOption.onClick
  }, sideOption.name)), /*#__PURE__*/React.createElement("div", {
    className: "mainContent citizenAllServiceGrid"
  }, options.map((props, index) => /*#__PURE__*/React.createElement(Option, Object.assign({
    key: index
  }, props)))));
};

const Option$1 = ({
  name,
  Icon,
  onClick,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: className || `CardBasedOptionsMainChildOption`,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "ChildOptionFormImageWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: Icon,
    alt: "formicons"
  })), /*#__PURE__*/React.createElement("p", {
    className: "ChildOptionFormName"
  }, name));
};
const CardBasedFormsOptions = ({
  header,
  sideOption,
  options,
  styles: _styles = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "CardBasedOptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headContent"
  }, /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement("p", {
    onClick: sideOption.onClick
  }, sideOption.name)), /*#__PURE__*/React.createElement("div", {
    className: "mainContent citizenAllServiceGrid"
  }, options.map((props, index) => /*#__PURE__*/React.createElement(Option$1, Object.assign({
    key: index
  }, props)))));
};

const WhatsNewCard = ({
  header,
  actions,
  eventNotificationText,
  timePastAfterEventCreation,
  timeApproxiamationInUnits
}) => {
  const {
    t
  } = useTranslation();
  const getTransformedLocale = label => {
    if (typeof label === "number") return label;
    return label && label.toUpperCase().replace(/[.:-\s\/]/g, "_");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "WhatsNewCard"
  }, /*#__PURE__*/React.createElement("h2", null, t(header)), /*#__PURE__*/React.createElement("p", null, eventNotificationText), actions === null || actions === void 0 ? void 0 : actions.map(i => /*#__PURE__*/React.createElement("a", {
    href: i === null || i === void 0 ? void 0 : i.actionUrl
  }, `${t(`CS_COMMON_${getTransformedLocale(i === null || i === void 0 ? void 0 : i.code)}`)}`)), /*#__PURE__*/React.createElement("p", null, timePastAfterEventCreation + ` ${t(timeApproxiamationInUnits)}`));
};

const EventCalendarView = ({
  onGroundEventMonth,
  onGroundEventDate
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "EventCalendarView"
  }, /*#__PURE__*/React.createElement("div", {
    className: "MonthViewInEventCalendar"
  }, /*#__PURE__*/React.createElement("h2", null, onGroundEventMonth)), /*#__PURE__*/React.createElement("div", {
    className: "DateViewInEventCalendar"
  }, /*#__PURE__*/React.createElement("h2", null, onGroundEventDate)));
};

const InboxLinks = ({
  logoIcon,
  headerText,
  links
}) => {
  const {
    t
  } = useTranslation();
  const GetLogo = () => /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logo"
  }, logoIcon), " ", /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, t(headerText)));
  return /*#__PURE__*/React.createElement(Card, {
    className: "employeeCard filter inboxLinks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "complaint-links-container"
  }, GetLogo(), /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, links.map(({
    link,
    text,
    hyperlink: _hyperlink = false,
    accessTo: _accessTo = []
  }, index) => {
    return /*#__PURE__*/React.createElement("span", {
      className: "link",
      key: index
    }, _hyperlink ? /*#__PURE__*/React.createElement("a", {
      href: link
    }, t(text)) : /*#__PURE__*/React.createElement(Link, {
      to: link
    }, t(text)));
  }))));
};

const PopupHeadingLabel = ({
  IconSVG,
  headingLabel,
  onResetSortForm
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "popupModalHeading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headingIconAndLabel"
  }, /*#__PURE__*/React.createElement(IconSVG, null), /*#__PURE__*/React.createElement("h3", null, headingLabel, ":")), /*#__PURE__*/React.createElement("span", {
    className: "popupResetFormButton",
    onClick: onResetSortForm
  }, /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5V8L12 4L8 0V3C3.58 3 0 6.58 0 11C0 12.57 0.46 14.03 1.24 15.26L2.7 13.8C2.25 12.97 2 12.01 2 11C2 7.69 4.69 5 8 5ZM14.76 6.74L13.3 8.2C13.74 9.04 14 9.99 14 11C14 14.31 11.31 17 8 17V14L4 18L8 22V19C12.42 19 16 15.42 16 11C16 9.43 15.54 7.97 14.76 6.74Z",
    fill: "#505A5F"
  }))));
};

const FormComposer = props => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    control,
    formState,
    errors,
    setError,
    clearErrors,
    unregister
  } = useForm({
    defaultValues: props.defaultValues
  });
  const {
    t
  } = useTranslation();
  const formData = watch();
  useEffect(() => {
    props.getFormAccessors && props.getFormAccessors({
      setValue,
      getValues
    });
  }, []);
  function onSubmit(data) {
    props.onSubmit(data);
  }
  function onSecondayActionClick(data) {
    props.onSecondayActionClick();
  }
  useEffect(() => {
    props.onFormValueChange && props.onFormValueChange(setValue, formData, formState);
  }, [formData]);
  const fieldSelector = (type, populators, isMandatory, disable = false, component, config) => {
    const Component = typeof component === "string" ? Digit.ComponentRegistryService.getComponent(component) : component;
    switch (type) {
      case "text":
      case "date":
      case "number":
      case "password":
      case "time":
        return /*#__PURE__*/React.createElement("div", {
          className: "field-container"
        }, populators !== null && populators !== void 0 && populators.componentInFront ? /*#__PURE__*/React.createElement("span", {
          className: `component-in-front ${disable && "disabled"}`
        }, populators.componentInFront) : null, /*#__PURE__*/React.createElement(TextInput, Object.assign({
          className: "field"
        }, populators, {
          inputRef: register(populators.validation),
          isRequired: isMandatory,
          type: type,
          disable: disable,
          watch: watch
        })));
      case "textarea":
        return /*#__PURE__*/React.createElement(TextArea, Object.assign({
          className: "field",
          name: (populators === null || populators === void 0 ? void 0 : populators.name) || ""
        }, populators, {
          inputRef: register(populators.validation),
          disable: disable
        }));
      case "mobileNumber":
        return /*#__PURE__*/React.createElement(Controller, {
          render: props => /*#__PURE__*/React.createElement(MobileNumber, {
            className: "field",
            onChange: props.onChange,
            value: props.value,
            disable: disable
          }),
          defaultValue: populators.defaultValue,
          name: populators === null || populators === void 0 ? void 0 : populators.name,
          control: control
        });
      case "custom":
        return /*#__PURE__*/React.createElement(Controller, {
          render: props => populators.component({
            ...props,
            setValue
          }, populators.customProps),
          defaultValue: populators.defaultValue,
          name: populators === null || populators === void 0 ? void 0 : populators.name,
          control: control
        });
      case "component":
        return /*#__PURE__*/React.createElement(Controller, {
          render: props => /*#__PURE__*/React.createElement(Component, {
            defaultValues: props.defaultValues,
            userType: "employee",
            t: t,
            setValue: setValue,
            onSelect: setValue,
            config: config,
            data: formData,
            formData: formData,
            register: register,
            errors: errors,
            props: props,
            setError: setError,
            clearErrors: clearErrors,
            formState: formState,
            onBlur: props.onBlur
          }),
          name: config.key,
          control: control
        });
      case "form":
        return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Component, {
          userType: "employee",
          t: t,
          setValue: setValue,
          onSelect: setValue,
          config: config,
          data: formData,
          formData: formData,
          register: register,
          errors: errors,
          setError: setError,
          clearErrors: clearErrors,
          formState: formState,
          control: control
        }));
      default:
        return (populators === null || populators === void 0 ? void 0 : populators.dependency) !== false ? populators : null;
    }
  };
  const getCombinedStyle = placementinBox => {
    switch (placementinBox) {
      case 0:
        return {
          border: "solid",
          borderRadius: "5px",
          padding: "10px",
          paddingTop: "20px",
          marginTop: "10px",
          borderColor: "#f3f3f3",
          background: "#FAFAFA",
          marginBottom: "20px"
        };
      case 1:
        return {
          border: "solid",
          borderRadius: "5px",
          padding: "10px",
          paddingTop: "20px",
          marginTop: "-30px",
          borderColor: "#f3f3f3",
          background: "#FAFAFA",
          borderTop: "0px",
          borderBottom: "0px"
        };
      case 2:
        return {
          border: "solid",
          borderRadius: "5px",
          padding: "10px",
          paddingTop: "20px",
          marginTop: "-30px",
          borderColor: "#f3f3f3",
          background: "#FAFAFA",
          marginBottom: "20px",
          borderTop: "0px"
        };
    }
  };
  const formFields = useMemo(() => {
    var _props$config;
    return (_props$config = props.config) === null || _props$config === void 0 ? void 0 : _props$config.map((section, index, array) => {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, section.head && /*#__PURE__*/React.createElement(CardSectionHeader, {
        style: props !== null && props !== void 0 && props.sectionHeadStyle ? props === null || props === void 0 ? void 0 : props.sectionHeadStyle : {},
        id: section.headId
      }, t(section.head)), section.body.map((field, index) => {
        var _field$populators, _field$populators2, _errors$field$populat, _field$populators3, _field$populators4, _field$populators5, _field$populators6, _field$populators7;
        if (props.inline) return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          style: field.isInsideBox ? getCombinedStyle(field === null || field === void 0 ? void 0 : field.placementinbox) : {}
        }, !field.withoutLabel && /*#__PURE__*/React.createElement(CardLabel, {
          style: {
            color: field.isSectionText ? "#505A5F" : "",
            marginBottom: props.inline ? "8px" : "revert"
          },
          className: field !== null && field !== void 0 && field.disable ? "disabled" : ""
        }, t(field.label), field.isMandatory ? " * " : null, field.labelChildren && field.labelChildren), errors && errors[(_field$populators = field.populators) === null || _field$populators === void 0 ? void 0 : _field$populators.name] && Object.keys(errors[(_field$populators2 = field.populators) === null || _field$populators2 === void 0 ? void 0 : _field$populators2.name]).length ? /*#__PURE__*/React.createElement(CardLabelError, null, t(field.populators.error || ((_errors$field$populat = errors[(_field$populators3 = field.populators) === null || _field$populators3 === void 0 ? void 0 : _field$populators3.name]) === null || _errors$field$populat === void 0 ? void 0 : _errors$field$populat.message))) : null, /*#__PURE__*/React.createElement("div", {
          style: field.withoutLabel ? {
            width: "100%"
          } : {},
          className: "field"
        }, fieldSelector(field.type, field.populators, field.isMandatory, field === null || field === void 0 ? void 0 : field.disable, field === null || field === void 0 ? void 0 : field.component, field), (field === null || field === void 0 ? void 0 : field.description) && /*#__PURE__*/React.createElement(CardLabel, {
          style: {
            marginTop: "-24px",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#505A5F",
            ...(field === null || field === void 0 ? void 0 : field.descriptionStyles)
          }
        }, t(field.description)))));
        return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(LabelFieldPair, {
          key: index
        }, !field.withoutLabel && /*#__PURE__*/React.createElement(CardLabel, {
          style: {
            color: field.isSectionText ? "#505A5F" : "",
            marginBottom: props.inline ? "8px" : "revert"
          }
        }, t(field.label), field.isMandatory ? " * " : null), /*#__PURE__*/React.createElement("div", {
          style: field.withoutLabel ? {
            width: "100%",
            ...(props === null || props === void 0 ? void 0 : props.fieldStyle)
          } : {},
          className: "field"
        }, fieldSelector(field.type, field.populators, field.isMandatory, field === null || field === void 0 ? void 0 : field.disable, field === null || field === void 0 ? void 0 : field.component, field), (field === null || field === void 0 ? void 0 : field.description) && /*#__PURE__*/React.createElement(CardText, {
          style: {
            fontSize: "14px",
            marginTop: "-24px"
          }
        }, t(field === null || field === void 0 ? void 0 : field.description)))), field !== null && field !== void 0 && (_field$populators4 = field.populators) !== null && _field$populators4 !== void 0 && _field$populators4.name && errors && errors[field === null || field === void 0 ? void 0 : (_field$populators5 = field.populators) === null || _field$populators5 === void 0 ? void 0 : _field$populators5.name] && Object.keys(errors[field === null || field === void 0 ? void 0 : (_field$populators6 = field.populators) === null || _field$populators6 === void 0 ? void 0 : _field$populators6.name]).length ? /*#__PURE__*/React.createElement(CardLabelError, {
          style: {
            width: "70%",
            marginLeft: "30%",
            fontSize: "12px",
            marginTop: "-21px"
          }
        }, t(field === null || field === void 0 ? void 0 : (_field$populators7 = field.populators) === null || _field$populators7 === void 0 ? void 0 : _field$populators7.error)) : null);
      }), !props.noBreakLine && (array.length - 1 === index ? null : /*#__PURE__*/React.createElement(BreakLine, {
        style: props !== null && props !== void 0 && props.breaklineStyle ? props === null || props === void 0 ? void 0 : props.breaklineStyle : {}
      })));
    });
  }, [props.config, formData]);
  const getCardStyles = () => {
    let styles = props.cardStyle || {};
    if (props.noBoxShadow) styles = {
      ...styles,
      boxShadow: "none"
    };
    return styles;
  };
  const isDisabled = props.isDisabled || false;
  const checkKeyDown = e => {
    const keyCode = e.keyCode ? e.keyCode : e.key ? e.key : e.which;
    if (keyCode === 13) {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    onKeyDown: e => checkKeyDown(e),
    id: props.formId,
    className: props.className
  }, /*#__PURE__*/React.createElement(Card, {
    style: getCardStyles(),
    className: props === null || props === void 0 ? void 0 : props.className
  }, !props.childrenAtTheBottom && props.children, props.heading && /*#__PURE__*/React.createElement(CardSubHeader, {
    style: {
      ...props.headingStyle
    }
  }, " ", props.heading, " "), props.description && /*#__PURE__*/React.createElement(CardLabelDesc, null, " ", props.description, " "), props.text && /*#__PURE__*/React.createElement(CardText, null, props.text), formFields, props.childrenAtTheBottom && props.children, props.submitInForm && /*#__PURE__*/React.createElement(SubmitBar, {
    label: t(props.label),
    style: {
      ...(props === null || props === void 0 ? void 0 : props.buttonStyle)
    },
    submit: "submit",
    disabled: isDisabled,
    className: "w-full"
  }), props.secondaryActionLabel && /*#__PURE__*/React.createElement("div", {
    className: "primary-label-btn",
    style: {
      margin: "20px auto 0 auto"
    },
    onClick: onSecondayActionClick
  }, props.secondaryActionLabel), !props.submitInForm && props.label && /*#__PURE__*/React.createElement(ActionBar, null, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t(props.label),
    submit: "submit",
    disabled: isDisabled
  }), props.onSkip && props.showSkip && /*#__PURE__*/React.createElement(LinkButton, {
    style: props === null || props === void 0 ? void 0 : props.skipStyle,
    label: t(`CS_SKIP_CONTINUE`),
    onClick: props.onSkip
  }))));
};

const ResponseComposer = ({
  data,
  template,
  actionButtonLabel,
  onSubmit
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, data.map((result, i) => {
    return /*#__PURE__*/React.createElement(Card, {
      key: i,
      className: "box-shadow-none"
    }, template.map((field, j) => {
      return /*#__PURE__*/React.createElement(KeyNote, {
        key: i + "" + j,
        keyValue: t(field.label),
        note: field.notePrefix ? field.notePrefix + result[field.key] : result[field.key],
        noteStyle: field.noteStyle
      });
    }), actionButtonLabel && result.status !== "INACTIVE" && /*#__PURE__*/React.createElement(SubmitBar, {
      submit: false,
      label: t(actionButtonLabel),
      onSubmit: () => {
        onSubmit(result);
      }
    }), result.status === "INACTIVE" && /*#__PURE__*/React.createElement(CitizenInfoLabel, {
      style: {
        margin: "0px"
      },
      info: t("CS_FILE_APPLICATION_INFO_LABEL"),
      text: t("CS_INACTIVE_PROPERTY_NOT_ELIGIBLE")
    }));
  }));
};
ResponseComposer.propTypes = {
  data: propTypes.array,
  template: propTypes.array,
  actionButtonLabel: propTypes.string,
  onSubmit: propTypes.func
};
ResponseComposer.defaultProps = {
  data: [],
  template: [],
  actionButtonLabel: "",
  onSubmit: () => {}
};

const SearchField = ({
  children,
  className
}) => {
  const isMobile = window.Digit.Utils.browser.isMobile();
  const isEnabledCommonModules = window.location.href.includes("/obps/") || window.location.href.includes("/noc/");
  const disbaleModules = window.location.href.includes("obps/search") || window.location.href.includes("noc/search");
  if (isEnabledCommonModules && !isMobile && !disbaleModules) {
    return /*#__PURE__*/React.createElement("div", {
      className: `input-fields`,
      style: {
        marginTop: "5px"
      }
    }, children);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `form-field ${className || ""}`
  }, children);
};
const SearchForm = ({
  children,
  onSubmit,
  handleSubmit,
  id,
  className: _className = ""
}) => {
  const isMobile = window.Digit.Utils.browser.isMobile();
  const isEnabledCommonModules = window.location.href.includes("/obps/") || window.location.href.includes("/noc/");
  const disbaleModules = window.location.href.includes("obps/search") || window.location.href.includes("noc/search");
  if (isEnabledCommonModules && !isMobile && !disbaleModules) {
    return /*#__PURE__*/React.createElement("form", Object.assign({
      onSubmit: handleSubmit(onSubmit)
    }, {
      id
    }), children);
  }
  return /*#__PURE__*/React.createElement("form", Object.assign({
    className: `search-form-wrapper ${_className}`,
    onSubmit: handleSubmit(onSubmit)
  }, {
    id
  }), children);
};

const FilterFormField = ({
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `filter-form-field ${className}`
  }, children);
};
const FilterForm = ({
  onMobileExclusiveFilterPopupFormClose: _onMobileExclusiveFilterPopupFormClose = () => null,
  closeButton: _closeButton = () => null,
  showMobileFilterFormPopup: _showMobileFilterFormPopup = false,
  children,
  id: _id = "",
  onSubmit,
  handleSubmit,
  onResetFilterForm: _onResetFilterForm = () => null,
  className: _className = ""
}) => {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const isEnabledCommonModules = window.location.href.includes("/obps/") || window.location.href.includes("/noc/");
  return /*#__PURE__*/React.createElement("div", {
    className: isEnabledCommonModules && !isMobile ? `filter ${_className}` : `filter-form ${_className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-card"
  }, _closeButton(), /*#__PURE__*/React.createElement("div", {
    className: "heading",
    style: {
      alignItems: "center",
      gap: ".75rem",
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-label",
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.66666 2.48016C3.35999 5.9335 8.33333 12.3335 8.33333 12.3335V20.3335C8.33333 21.0668 8.93333 21.6668 9.66666 21.6668H12.3333C13.0667 21.6668 13.6667 21.0668 13.6667 20.3335V12.3335C13.6667 12.3335 18.6267 5.9335 21.32 2.48016C22 1.60016 21.3733 0.333496 20.2667 0.333496H1.71999C0.613327 0.333496 -0.01334 1.60016 0.66666 2.48016Z",
    fill: "#505A5F"
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "8px",
      fontWeight: "normal"
    }
  }, t("FILTERS_FILTER_CARD_CAPTION"), ":")), /*#__PURE__*/React.createElement("div", {
    className: "clearAll",
    onClick: _onResetFilterForm
  }, t("ES_COMMON_CLEAR_ALL")), /*#__PURE__*/React.createElement("span", {
    className: "clear-search",
    onClick: _onResetFilterForm,
    style: {
      border: "1px solid #e0e0e0",
      padding: "6px",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "17",
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5V8L12 4L8 0V3C3.58 3 0 6.58 0 11C0 12.57 0.46 14.03 1.24 15.26L2.7 13.8C2.25 12.97 2 12.01 2 11C2 7.69 4.69 5 8 5ZM14.76 6.74L13.3 8.2C13.74 9.04 14 9.99 14 11C14 14.31 11.31 17 8 17V14L4 18L8 22V19C12.42 19 16 15.42 16 11C16 9.43 15.54 7.97 14.76 6.74Z",
    fill: "#505A5F"
  }))), _showMobileFilterFormPopup ? /*#__PURE__*/React.createElement("span", {
    onClick: _onMobileExclusiveFilterPopupFormClose,
    className: "mobile-only"
  }, /*#__PURE__*/React.createElement(CloseSvg, null)) : null), /*#__PURE__*/React.createElement("form", {
    id: _id,
    onSubmit: handleSubmit(onSubmit)
  }, children), /*#__PURE__*/React.createElement(SubmitBar, {
    className: "w-fullwidth",
    label: t("ES_COMMON_APPLY"),
    submit: true,
    form: _id
  })));
};

const SearchAction = ({
  text,
  handleActionClick
}) => /*#__PURE__*/React.createElement("div", {
  className: "searchAction",
  onClick: handleActionClick
}, /*#__PURE__*/React.createElement(SearchIconSvg, null), " ", /*#__PURE__*/React.createElement("span", {
  className: "searchText"
}, text));

const FilterAction = ({
  text,
  handleActionClick,
  ...props
}) => /*#__PURE__*/React.createElement("div", {
  className: "searchAction",
  onClick: handleActionClick
}, /*#__PURE__*/React.createElement(RoundedLabel, {
  count: props.filterCount
}), /*#__PURE__*/React.createElement(FilterSvg, null), " ", /*#__PURE__*/React.createElement("span", {
  className: "searchText"
}, text));

const SortAction = ({
  text,
  handleActionClick,
  ...props
}) => /*#__PURE__*/React.createElement("div", {
  className: "searchAction svgPrimaryH16px",
  onClick: handleActionClick
}, /*#__PURE__*/React.createElement(RoundedLabel, {
  count: props.filterCount
}), /*#__PURE__*/React.createElement(SortSvg, null), " ", /*#__PURE__*/React.createElement("span", {
  className: "searchText"
}, text));

const Details$1 = ({
  label,
  name,
  onClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "detail",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, /*#__PURE__*/React.createElement("h2", null, label)), /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, name));
};
const DetailsCard = ({
  data,
  serviceRequestIdKey,
  linkPrefix,
  handleSelect,
  selectedItems,
  keyForSelected,
  handleDetailCardClick,
  isTwoDynamicPrefix: _isTwoDynamicPrefix = false,
  getRedirectionLink,
  handleClickEnabled: _handleClickEnabled = true
}) => {
  if (linkPrefix && serviceRequestIdKey) {
    return /*#__PURE__*/React.createElement("div", null, data.map((object, itemIndex) => {
      return /*#__PURE__*/React.createElement(Link, {
        key: itemIndex,
        to: _isTwoDynamicPrefix ? `${linkPrefix}${typeof serviceRequestIdKey === "function" ? serviceRequestIdKey(object) : `${getRedirectionLink(object["Application Type"] === "BPA_STAKEHOLDER_REGISTRATION" ? "BPAREG" : "BPA")}/${object[object["Application Type"] === "BPA_STAKEHOLDER_REGISTRATION" ? "applicationNo" : "Application Number"]}`}` : `${linkPrefix}${typeof serviceRequestIdKey === "function" ? serviceRequestIdKey(object) : object[serviceRequestIdKey]}`
      }, /*#__PURE__*/React.createElement("div", {
        className: "details-container"
      }, Object.keys(object).map((name, index) => {
        if (name === "applicationNo" || name === "Vehicle Log") return null;
        return /*#__PURE__*/React.createElement(Details$1, {
          label: name,
          name: object[name],
          key: index
        });
      })));
    }));
  }
  return /*#__PURE__*/React.createElement("div", null, data.map((object, itemIndex) => {
    return /*#__PURE__*/React.createElement("div", {
      key: itemIndex,
      style: {
        border: selectedItems !== null && selectedItems !== void 0 && selectedItems.includes(object[keyForSelected]) ? "2px solid #1F4A7C" : "2px solid #fff"
      },
      className: "details-container",
      onClick: () => _handleClickEnabled && handleSelect(object)
    }, Object.keys(object).filter(rowEle => {
      var _object$rowEle;
      return !(typeof object[rowEle] == "object" && ((_object$rowEle = object[rowEle]) === null || _object$rowEle === void 0 ? void 0 : _object$rowEle.hidden) == true);
    }).map((name, index) => {
      return /*#__PURE__*/React.createElement(Details$1, {
        label: name,
        name: object[name],
        key: index,
        onClick: () => _handleClickEnabled && handleDetailCardClick(object)
      });
    }));
  }));
};
DetailsCard.propTypes = {
  data: propTypes.array
};
DetailsCard.defaultProps = {
  data: []
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const MobilePopUpCloseButton = ({
  closeMobilePopupModal
}) => /*#__PURE__*/React.createElement("div", {
  className: "InboxMobilePopupCloseButtonWrapper",
  onClick: closeMobilePopupModal
}, /*#__PURE__*/React.createElement(CloseSvg, null));
const MobileComponentDirectory = {
  SearchFormComponent: ({
    registerSearchFormField,
    searchFormState,
    handleSearchFormSubmit,
    onResetSearchForm,
    SearchFormFields,
    closeMobilePopupModal,
    onSearchFormSubmit,
    t
  }) => /*#__PURE__*/React.createElement(SearchForm, {
    onSubmit: ({
      ...props
    }) => {
      closeMobilePopupModal();
      onSearchFormSubmit({
        ...props
      });
    },
    handleSubmit: handleSearchFormSubmit,
    id: "search-form",
    className: "rm-mb form-field-flex-one inboxPopupMobileWrapper"
  }, /*#__PURE__*/React.createElement(MobilePopUpCloseButton, {
    closeMobilePopupModal
  }), /*#__PURE__*/React.createElement(SearchFormFields, {
    registerRef: registerSearchFormField,
    searchFormState: searchFormState
  }), /*#__PURE__*/React.createElement(ActionBar, {
    style: {
      maxWidth: "100%"
    }
  }, /*#__PURE__*/React.createElement(SearchField, {
    className: "submit"
  }, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("ES_COMMON_SEARCH"),
    submit: true,
    form: "search-form"
  }), /*#__PURE__*/React.createElement("p", {
    onClick: onResetSearchForm
  }, t(`ES_COMMON_CLEAR_ALL`))))),
  FilterFormComponent: ({
    registerFilterFormField,
    onResetFilterForm,
    controlFilterForm,
    handleFilterFormSubmit,
    setFilterFormValue,
    getFilterFormValue,
    FilterFormFields,
    closeMobilePopupModal,
    onFilterFormSubmit
  }) => /*#__PURE__*/React.createElement(FilterForm, {
    onSubmit: ({
      ...props
    }) => {
      closeMobilePopupModal();
      onFilterFormSubmit({
        ...props
      });
    },
    closeButton: () => /*#__PURE__*/React.createElement(MobilePopUpCloseButton, {
      closeMobilePopupModal
    }),
    handleSubmit: handleFilterFormSubmit,
    id: "filter-form",
    onResetFilterForm: onResetFilterForm,
    className: "inboxPopupMobileWrapper p-unset"
  }, /*#__PURE__*/React.createElement(FilterFormFields, Object.assign({
    registerRef: registerFilterFormField
  }, {
    controlFilterForm,
    handleFilterFormSubmit,
    setFilterFormValue,
    getFilterFormValue
  }))),
  SortFormComponent: ({
    sortFormDefaultValues: _sortFormDefaultValues = {},
    closeMobilePopupModal,
    MobileSortFormValues,
    onMobileSortOrderData,
    onSortFormReset,
    t
  }) => {
    const {
      setValue: setSortFormValue,
      handleSubmit: handleSortFormSubmit,
      ...methods
    } = useForm({
      defaultValues: _sortFormDefaultValues
    });
    function onResetSortForm() {
      closeMobilePopupModal();
      onSortFormReset(setSortFormValue);
    }
    return /*#__PURE__*/React.createElement(FormProvider, _extends({
      setValue: setSortFormValue,
      handleSubmit: handleSortFormSubmit
    }, methods), /*#__PURE__*/React.createElement(SearchForm, {
      onSubmit: ({
        ...props
      }) => {
        closeMobilePopupModal();
        onMobileSortOrderData({
          ...props
        });
      },
      handleSubmit: handleSortFormSubmit,
      id: "sort-form",
      className: "rm-mb form-field-flex-one inboxPopupMobileWrapper"
    }, /*#__PURE__*/React.createElement(MobilePopUpCloseButton, {
      closeMobilePopupModal
    }), /*#__PURE__*/React.createElement(PopupHeadingLabel, Object.assign({
      IconSVG: SortSvg,
      headingLabel: t("COMMON_TABLE_SORT")
    }, {
      onResetSortForm
    })), /*#__PURE__*/React.createElement(MobileSortFormValues, null), /*#__PURE__*/React.createElement(ActionBar, {
      style: {
        maxWidth: "100%"
      }
    }, /*#__PURE__*/React.createElement(SearchField, {
      className: "submit"
    }, /*#__PURE__*/React.createElement(SubmitBar, {
      label: t("COMMON_TABLE_SORT"),
      submit: true,
      form: "sort-form"
    }), /*#__PURE__*/React.createElement("p", {
      onClick: onResetSortForm
    }, t(`ES_COMMON_CLEAR_ALL`))))));
  }
};

const InboxComposer = ({
  isInboxLoading,
  PropsForInboxLinks,
  SearchFormFields,
  searchFormDefaultValues,
  onSearchFormSubmit,
  onSearchFormReset,
  resetSearchFormDefaultValues,
  FilterFormFields,
  filterFormDefaultValues,
  propsForInboxTable,
  propsForInboxMobileCards,
  onFilterFormSubmit,
  onFilterFormReset,
  resetFilterFormDefaultValues,
  onMobileSortOrderData,
  sortFormDefaultValues,
  onSortFormReset,
  formState: inboxFormState
}) => {
  var _propsForInboxTable$d2;
  const {
    t
  } = useTranslation();
  function activateModal(state, action) {
    switch (action.type) {
      case "set":
        return action.payload;
      case "remove":
        return false;
    }
  }
  const [currentlyActiveMobileModal, setActiveMobileModal] = useReducer(activateModal, false);
  const closeMobilePopupModal = () => {
    setActiveMobileModal({
      type: "remove"
    });
  };
  const {
    register: registerSearchFormField,
    control: controlSearchForm,
    handleSubmit: handleSearchFormSubmit,
    setValue: setSearchFormValue,
    getValues: getSearchFormValue,
    reset: resetSearchForm,
    formState: searchFormState,
    clearErrors: clearSearchFormErrors
  } = useForm({
    defaultValues: {
      ...searchFormDefaultValues
    }
  });
  const {
    register: registerFilterFormField,
    control: controlFilterForm,
    handleSubmit: handleFilterFormSubmit,
    setValue: setFilterFormValue,
    getValues: getFilterFormValue,
    reset: resetFilterForm
  } = useForm({
    defaultValues: {
      ...filterFormDefaultValues
    }
  });
  const onResetFilterForm = () => {
    onFilterFormReset(setFilterFormValue);
  };
  const onResetSearchForm = () => {
    onSearchFormReset(setSearchFormValue);
    clearSearchFormErrors();
    closeMobilePopupModal();
  };
  useEffect(() => {
    if (resetFilterForm && resetSearchForm && inboxFormState) {
      resetFilterForm(inboxFormState === null || inboxFormState === void 0 ? void 0 : inboxFormState.filterForm);
      resetSearchForm(inboxFormState === null || inboxFormState === void 0 ? void 0 : inboxFormState.searchForm);
    }
  }, [inboxFormState, resetSearchForm, resetFilterForm]);
  const isMobile = window.Digit.Utils.browser.isMobile();
  if (isMobile) {
    var _propsForInboxMobileC;
    const CurrentMobileModalComponent = useCallback(({
      ...props
    }) => currentlyActiveMobileModal ? MobileComponentDirectory[currentlyActiveMobileModal]({
      ...props
    }) : null, [currentlyActiveMobileModal]);
    const propsForCurrentMobileModalComponent = {
      SearchFormFields,
      FilterFormFields,
      registerSearchFormField,
      searchFormState,
      handleSearchFormSubmit,
      onResetSearchForm,
      registerFilterFormField,
      onResetFilterForm,
      controlFilterForm,
      handleFilterFormSubmit,
      setFilterFormValue,
      getFilterFormValue,
      closeMobilePopupModal,
      onSearchFormSubmit,
      onFilterFormSubmit,
      onMobileSortOrderData,
      sortFormDefaultValues,
      onSortFormReset,
      MobileSortFormValues: propsForInboxMobileCards === null || propsForInboxMobileCards === void 0 ? void 0 : propsForInboxMobileCards.MobileSortFormValues,
      t
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "InboxComposerWrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "searchBox"
    }, /*#__PURE__*/React.createElement(SearchAction, {
      text: t("ES_COMMON_SEARCH"),
      handleActionClick: () => setActiveMobileModal({
        type: "set",
        payload: "SearchFormComponent"
      })
    }), /*#__PURE__*/React.createElement(FilterAction, {
      text: t("ES_COMMON_FILTER"),
      handleActionClick: () => setActiveMobileModal({
        type: "set",
        payload: "FilterFormComponent"
      })
    }), /*#__PURE__*/React.createElement(SortAction, {
      text: t("COMMON_TABLE_SORT"),
      handleActionClick: () => setActiveMobileModal({
        type: "set",
        payload: "SortFormComponent"
      })
    })), currentlyActiveMobileModal ? /*#__PURE__*/React.createElement(PopUp, null, /*#__PURE__*/React.createElement(CurrentMobileModalComponent, propsForCurrentMobileModalComponent)) : null, isInboxLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement("div", null, (propsForInboxMobileCards === null || propsForInboxMobileCards === void 0 ? void 0 : (_propsForInboxMobileC = propsForInboxMobileCards.data) === null || _propsForInboxMobileC === void 0 ? void 0 : _propsForInboxMobileC.length) < 1 ? /*#__PURE__*/React.createElement(Card, {
      className: "margin-unset text-align-center"
    }, propsForInboxTable !== null && propsForInboxTable !== void 0 && propsForInboxTable.noResultsMessage ? t(propsForInboxTable === null || propsForInboxTable === void 0 ? void 0 : propsForInboxTable.noResultsMessage) : t("CS_MYAPPLICATIONS_NO_APPLICATION")) : /*#__PURE__*/React.createElement(DetailsCard, propsForInboxMobileCards)));
  }
  const isEnabledCommonModules = window.location.href.includes("/obps/") || window.location.href.includes("/noc/");
  if (isEnabledCommonModules) {
    var _propsForInboxTable$d;
    return /*#__PURE__*/React.createElement("div", {
      className: "inbox-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "filters-container"
    }, /*#__PURE__*/React.createElement(InboxLinks, PropsForInboxLinks), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FilterForm, {
      onSubmit: onFilterFormSubmit,
      handleSubmit: handleFilterFormSubmit,
      id: "filter-form",
      onResetFilterForm: onResetFilterForm
    }, /*#__PURE__*/React.createElement(FilterFormFields, Object.assign({
      registerRef: registerFilterFormField
    }, {
      controlFilterForm,
      handleFilterFormSubmit,
      setFilterFormValue,
      getFilterFormValue
    }))))), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(SearchForm, {
      onSubmit: onSearchFormSubmit,
      handleSubmit: handleSearchFormSubmit,
      id: "search-form",
      className: "rm-mb form-field-flex-one"
    }, /*#__PURE__*/React.createElement(SearchFormFields, Object.assign({
      registerRef: registerSearchFormField,
      searchFormState: searchFormState
    }, {
      controlSearchForm
    }, {
      searchFieldComponents: /*#__PURE__*/React.createElement("div", {
        style: window.location.href.includes("/citizen/obps") ? {
          display: "flex"
        } : {}
      }, /*#__PURE__*/React.createElement(SubmitBar, {
        label: t("ES_COMMON_SEARCH"),
        submit: true,
        form: "search-form",
        className: "submit-bar-search",
        style: {
          marginRight: "10px"
        }
      }), /*#__PURE__*/React.createElement("p", {
        onClick: onResetSearchForm,
        className: "clear-search",
        style: {
          paddingTop: "9px"
        }
      }, t(`ES_COMMON_CLEAR_SEARCH`)))
    }))), /*#__PURE__*/React.createElement("div", {
      className: "result",
      style: {
        marginLeft: "24px",
        flex: 1
      }
    }, isInboxLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement("div", null, (propsForInboxTable === null || propsForInboxTable === void 0 ? void 0 : (_propsForInboxTable$d = propsForInboxTable.data) === null || _propsForInboxTable$d === void 0 ? void 0 : _propsForInboxTable$d.length) < 1 ? /*#__PURE__*/React.createElement(Card, {
      className: "margin-unset text-align-center"
    }, propsForInboxTable.noResultsMessage ? t(propsForInboxTable.noResultsMessage) : t("CS_MYAPPLICATIONS_NO_APPLICATION")) : /*#__PURE__*/React.createElement(Table, Object.assign({
      t: t
    }, propsForInboxTable))))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "InboxComposerWrapper"
  }, /*#__PURE__*/React.createElement(InboxLinks, PropsForInboxLinks), /*#__PURE__*/React.createElement(SearchForm, {
    onSubmit: onSearchFormSubmit,
    handleSubmit: handleSearchFormSubmit,
    id: "search-form",
    className: "rm-mb form-field-flex-one"
  }, /*#__PURE__*/React.createElement(SearchFormFields, Object.assign({
    registerRef: registerSearchFormField,
    searchFormState: searchFormState
  }, {
    controlSearchForm
  })), /*#__PURE__*/React.createElement("div", {
    className: "SubmitAndClearAllContainer"
  }, /*#__PURE__*/React.createElement(SearchField, {
    className: "submit"
  }, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("ES_COMMON_SEARCH"),
    submit: true,
    form: "search-form"
  }), /*#__PURE__*/React.createElement("p", {
    onClick: onResetSearchForm
  }, t(`ES_COMMON_CLEAR_SEARCH`))))), /*#__PURE__*/React.createElement(FilterForm, {
    onSubmit: onFilterFormSubmit,
    handleSubmit: handleFilterFormSubmit,
    id: "filter-form",
    onResetFilterForm: onResetFilterForm
  }, /*#__PURE__*/React.createElement(FilterFormFields, Object.assign({
    registerRef: registerFilterFormField
  }, {
    controlFilterForm,
    handleFilterFormSubmit,
    setFilterFormValue,
    getFilterFormValue
  }))), isInboxLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement("div", null, (propsForInboxTable === null || propsForInboxTable === void 0 ? void 0 : (_propsForInboxTable$d2 = propsForInboxTable.data) === null || _propsForInboxTable$d2 === void 0 ? void 0 : _propsForInboxTable$d2.length) < 1 ? /*#__PURE__*/React.createElement(Card, {
    className: "margin-unset text-align-center"
  }, propsForInboxTable.noResultsMessage ? t(propsForInboxTable.noResultsMessage) : t("CS_MYAPPLICATIONS_NO_APPLICATION")) : /*#__PURE__*/React.createElement(Table, Object.assign({
    t: t
  }, propsForInboxTable))));
};

const CityMohalla = ({
  header,
  subHeader,
  cardText,
  cardLabelCity,
  cardLabelMohalla,
  nextText,
  selectedCity,
  cities,
  localities,
  selectCity,
  selectLocalities,
  onSave,
  selectedLocality
}) => {
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardSubHeader, null, subHeader), /*#__PURE__*/React.createElement(CardHeader, null, header), /*#__PURE__*/React.createElement(CardText, null, cardText), /*#__PURE__*/React.createElement(CardLabel, null, cardLabelCity, "* "), /*#__PURE__*/React.createElement(Dropdown, {
    isMandatory: true,
    selected: selectedCity,
    option: cities,
    select: selectCity
  }), /*#__PURE__*/React.createElement(CardLabel, null, cardLabelMohalla, " *"), /*#__PURE__*/React.createElement(Dropdown, {
    isMandatory: true,
    selected: selectedLocality,
    option: localities,
    select: selectLocalities
  }), /*#__PURE__*/React.createElement(SubmitBar, {
    label: nextText,
    onSubmit: onSave
  }));
};
CityMohalla.propTypes = {
  header: propTypes.string,
  subHeader: propTypes.string,
  cardText: propTypes.string,
  cardLabelCity: propTypes.string,
  cardLabelMohalla: propTypes.string,
  nextText: propTypes.string,
  selectedCity: propTypes.string,
  cities: propTypes.array,
  localities: propTypes.array,
  selectCity: propTypes.string,
  selectedLocality: propTypes.string,
  selectLocalities: propTypes.func,
  onSave: propTypes.func
};
CityMohalla.defaultProps = {
  header: "",
  subHeader: "",
  cardText: "",
  cardLabelCity: "",
  cardLabelMohalla: "",
  nextText: "",
  selectedCity: "",
  cities: [],
  localities: [],
  selectCity: "",
  selectedLocality: "",
  selectLocalities: undefined,
  onSave: undefined
};

const ArrowRight = ({
  to
}) => /*#__PURE__*/React.createElement(Link, {
  to: to
}, /*#__PURE__*/React.createElement("svg", {
  style: {
    display: "inline",
    height: "24px"
  },
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
  fill: "#1F4A7C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 5.33325L14.12 7.21325L21.56 14.6666H5.33337V17.3333H21.56L14.12 24.7866L16 26.6666L26.6667 15.9999L16 5.33325Z",
  fill: "white"
})));
const DashboardBox = ({
  t: _t = val => val,
  svgIcon,
  header,
  info,
  subHeader,
  links,
  total
}) => {
  const mobileView = innerWidth <= 640;
  const employeeCardStyles = mobileView ? {
    width: "96vw",
    margin: "8px auto"
  } : {
    width: "328px"
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "employeeCard card-home",
    style: {
      padding: 0,
      ...employeeCardStyles
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "complaint-links-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logo"
  }, svgIcon), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, _t(header))), /*#__PURE__*/React.createElement("div", {
    className: "body "
  }, /*#__PURE__*/React.createElement("div", {
    className: "employeeCard-info-box"
  }, Object.keys(info).map((key, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "employeeCard-info-data"
    }, /*#__PURE__*/React.createElement("span", null, _t(info[key])), /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, _t(key)));
  }))), /*#__PURE__*/React.createElement("hr", {
    className: "underline"
  }), /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, links.map((link, index) => /*#__PURE__*/React.createElement("span", {
    key: index,
    className: "link"
  }, /*#__PURE__*/React.createElement(Link, {
    to: link.pathname
  }, /*#__PURE__*/React.createElement("span", null, _t(link.label))), !isNaN(link.total) && /*#__PURE__*/React.createElement("span", {
    className: "inbox-total"
  }, link.total), /*#__PURE__*/React.createElement(ArrowRight, {
    to: link.pathname
  }))))));
};

const InputCard = ({
  t,
  children,
  texts: _texts = {},
  submit: _submit = false,
  inputs: _inputs = [],
  inputRef,
  onNext,
  onSkip,
  isDisable,
  onAdd,
  isMultipleAllow: _isMultipleAllow = false,
  cardStyle: _cardStyle = {}
}) => {
  const isMobile = window.Digit.Utils.browser.isMobile();
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
      ...(_cardStyle && _cardStyle)
    }
  }, _texts.headerCaption && /*#__PURE__*/React.createElement(CardCaption, null, t(_texts.headerCaption)), (_texts === null || _texts === void 0 ? void 0 : _texts.header) && /*#__PURE__*/React.createElement(CardHeader, null, t(_texts.header)), (_texts === null || _texts === void 0 ? void 0 : _texts.cardText) && /*#__PURE__*/React.createElement(CardText, null, t(_texts.cardText)), children, _texts.submitBarLabel ? /*#__PURE__*/React.createElement(SubmitBar, {
    disabled: isDisable,
    submit: _submit,
    label: t(_texts.submitBarLabel),
    onSubmit: onNext
  }) : null, _texts.skipLabel ? /*#__PURE__*/React.createElement(CardText, {
    style: {
      marginTop: "10px",
      textAlign: isMobile ? "center" : "left"
    }
  }, " ", t(_texts.skipLabel), " ") : null, _texts.skipText ? /*#__PURE__*/React.createElement(LinkButton, {
    label: t(_texts.skipText),
    onClick: onSkip
  }) : null, _isMultipleAllow && _texts.addMultipleText ? /*#__PURE__*/React.createElement(LinkButton, {
    label: t(_texts.addMultipleText),
    onClick: onAdd
  }) : null);
};
InputCard.propTypes = {
  text: propTypes.object,
  submit: propTypes.bool,
  onNext: propTypes.func,
  onSkip: propTypes.func,
  onAdd: propTypes.func,
  t: propTypes.func
};
InputCard.defaultProps = {
  texts: {},
  submit: false,
  onNext: undefined,
  onSkip: undefined,
  onAdd: undefined,
  t: value => value
};

const FormStep = ({
  t,
  children,
  config,
  onSelect,
  onSkip,
  value,
  onChange,
  isDisabled,
  _defaultValues: _defaultValues2 = {},
  forcedError,
  componentInFront,
  onAdd,
  cardStyle: _cardStyle = {},
  isMultipleAllow: _isMultipleAllow = false,
  showErrorBelowChildren: _showErrorBelowChildren = false,
  childrenAtTheBottom: _childrenAtTheBottom = true,
  textInputStyle
}) => {
  var _config$inputs;
  const {
    register,
    watch,
    errors,
    handleSubmit
  } = useForm({
    defaultValues: _defaultValues2
  });
  const goNext = data => {
    onSelect(data);
  };
  var isDisable = isDisabled ? true : config.canDisable && Object.keys(errors).filter(i => errors[i]).length;
  const inputs = (_config$inputs = config.inputs) === null || _config$inputs === void 0 ? void 0 : _config$inputs.map((input, index) => {
    if (input.type === "text") {
      var _input$validation, _input$validation2;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), errors[input.name] && /*#__PURE__*/React.createElement(CardLabelError, null, t(input.error)), /*#__PURE__*/React.createElement("div", {
        className: "field-container"
      }, componentInFront ? /*#__PURE__*/React.createElement("span", {
        className: "citizen-card-input citizen-card-input--front"
      }, componentInFront) : null, /*#__PURE__*/React.createElement(TextInput, {
        key: index,
        name: input.name,
        value: value,
        onChange: onChange,
        minlength: input.validation.minlength,
        maxlength: input.validation.maxlength,
        pattern: (_input$validation = input.validation) === null || _input$validation === void 0 ? void 0 : _input$validation.pattern,
        title: (_input$validation2 = input.validation) === null || _input$validation2 === void 0 ? void 0 : _input$validation2.title,
        inputRef: register(input.validation),
        isMandatory: errors[input.name],
        disable: input.disable ? input.disable : false,
        textInputStyle: textInputStyle
      })));
    }
    if (input.type === "textarea") return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), /*#__PURE__*/React.createElement(TextArea, {
      key: index,
      name: input.name,
      value: value,
      onChange: onChange,
      inputRef: register(input.validation),
      maxLength: "1024"
    }));
  });
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(goNext)
  }, /*#__PURE__*/React.createElement(InputCard, Object.assign({}, {
    isDisable: isDisable,
    isMultipleAllow: _isMultipleAllow
  }, config, {
    cardStyle: _cardStyle,
    submit: true
  }, {
    onSkip: onSkip,
    onAdd: onAdd
  }, {
    t: t
  }), !_childrenAtTheBottom && children, inputs, forcedError && !_showErrorBelowChildren && /*#__PURE__*/React.createElement(CardLabelError, null, t(forcedError)), _childrenAtTheBottom && children, forcedError && _showErrorBelowChildren && /*#__PURE__*/React.createElement(CardLabelError, null, t(forcedError))));
};
FormStep.propTypes = {
  config: propTypes.shape({}),
  onSelect: propTypes.func,
  onSkip: propTypes.func,
  onAdd: propTypes.func,
  t: propTypes.func
};
FormStep.defaultProps = {
  config: {},
  onSelect: undefined,
  onSkip: undefined,
  onAdd: undefined,
  t: value => value
};

const Localities = ({
  selectLocality,
  tenantId,
  boundaryType,
  keepNull,
  selected,
  optionCardStyles,
  style,
  disable,
  disableLoader,
  sortFn
}) => {
  const {
    t
  } = useTranslation();
  const {
    data: tenantlocalties,
    isLoading
  } = Digit.Hooks.useBoundaryLocalities(tenantId, boundaryType, {
    enabled: !disable
  }, t);
  if (isLoading && !disableLoader) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Dropdown, {
    option: sortFn ? tenantlocalties === null || tenantlocalties === void 0 ? void 0 : tenantlocalties.sort(sortFn) : tenantlocalties,
    keepNull: keepNull === false ? false : true,
    selected: selected,
    select: selectLocality,
    optionCardStyles: optionCardStyles,
    optionKey: "i18nkey",
    style: style,
    disable: !(tenantlocalties !== null && tenantlocalties !== void 0 && tenantlocalties.length) || disable
  });
};

const LocationSearchCard = ({
  header,
  cardText,
  nextText,
  t,
  skipAndContinueText,
  forcedError,
  skip,
  onSave,
  onChange,
  position,
  disabled,
  cardBodyStyle: _cardBodyStyle = {},
  isPTDefault,
  PTdefaultcoord,
  isPlaceRequired,
  handleRemove,
  Webview: _Webview = false,
  isPopUp: _isPopUp = false
}) => {
  let isDisabled =  disabled;
  const onLocationChange = (val, location) => {
    isDisabled = val ? false : true;
    onChange(val, location);
  };
  const onLocationChangewithPlace = (val, location, place) => {
    isDisabled = val ? false : true;
    onChange(val, location, place);
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, null, header), /*#__PURE__*/React.createElement("div", {
    style: _cardBodyStyle
  }, _isPopUp && /*#__PURE__*/React.createElement(LinkButton, {
    label: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("svg", {
      style: {
        float: "right",
        position: "relative",
        bottom: "32px",
        marginTop: _Webview ? "-20px" : "-18px",
        marginRight: _Webview ? "-280px" : "-5px",
        marginLeft: _Webview ? "5px" : ""
      },
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
      fill: "#0B0C0C"
    })))),
    style: {
      width: "100px",
      display: "inline"
    },
    onClick: e => handleRemove()
  }), /*#__PURE__*/React.createElement(CardText, null, cardText), /*#__PURE__*/React.createElement(LocationSearch, {
    onChange: isPlaceRequired ? onLocationChangewithPlace : onLocationChange,
    position: position,
    isPTDefault: isPTDefault,
    PTdefaultcoord: PTdefaultcoord,
    isPlaceRequired: isPlaceRequired
  }), forcedError && /*#__PURE__*/React.createElement(CardLabelError, null, t(forcedError))), /*#__PURE__*/React.createElement(SubmitBar, {
    label: nextText,
    onSubmit: onSave,
    disabled: isDisabled
  }), skip ? /*#__PURE__*/React.createElement(LinkButton, {
    onClick: skip,
    label: skipAndContinueText
  }) : null);
};
LocationSearchCard.propTypes = {
  header: propTypes.string,
  cardText: propTypes.string,
  nextText: propTypes.string,
  skipAndContinueText: propTypes.string,
  skip: propTypes.func,
  onSave: propTypes.func,
  onChange: propTypes.func,
  position: propTypes.any,
  isPTDefault: propTypes.any,
  PTdefaultcoord: propTypes.any,
  isPlaceRequired: propTypes.any
};
LocationSearchCard.defaultProps = {
  header: "",
  cardText: "",
  nextText: "",
  skipAndContinueText: "",
  skip: () => {},
  onSave: null,
  onChange: () => {},
  position: undefined,
  isPTDefault: false,
  PTdefaultcoord: {},
  isPlaceRequired: false,
  handleRemove: () => {},
  Webview: false,
  isPopUp: false
};

const DimentionInput = ({
  name,
  value,
  onChange,
  disable
}) => /*#__PURE__*/React.createElement(TextInput, {
  type: "number",
  name: name,
  value: value,
  onChange: onChange,
  disable: disable,
  pattern: "[0-9]{1,2}",
  min: "0.1",
  max: "99.9",
  step: "0.1"
});
const PitDimension = ({
  sanitationType,
  t,
  size: _size = {},
  handleChange,
  disable: _disable = false
}) => {
  return (sanitationType === null || sanitationType === void 0 ? void 0 : sanitationType.dimension) === "dd" ? /*#__PURE__*/React.createElement("div", {
    className: "inputWrapper"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DimentionInput, {
    name: "diameter",
    value: _size["diameter"] || "",
    onChange: handleChange,
    disable: _disable
  }), /*#__PURE__*/React.createElement(CardText, {
    style: {
      textAlign: "center"
    },
    disable: _disable
  }, t("CS_FILE_PROPERTY_DIAMETER"))), /*#__PURE__*/React.createElement("span", null, "x"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DimentionInput, {
    name: "height",
    value: _size["height"] || "",
    onChange: handleChange,
    disable: _disable
  }), /*#__PURE__*/React.createElement(CardText, {
    style: {
      textAlign: "center"
    },
    disable: _disable
  }, t("CS_FILE_PROPERTY_HEIGHT")))) : /*#__PURE__*/React.createElement("div", {
    className: "inputWrapper"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DimentionInput, {
    name: "length",
    value: _size["length"] || "",
    onChange: handleChange,
    disable: _disable
  }), /*#__PURE__*/React.createElement(CardText, {
    style: {
      textAlign: "center"
    },
    disable: _disable
  }, t("CS_FILE_PROPERTY_LENGTH"))), /*#__PURE__*/React.createElement("span", null, "x"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DimentionInput, {
    name: "width",
    value: _size["width"] || "",
    onChange: handleChange,
    disable: _disable
  }), /*#__PURE__*/React.createElement(CardText, {
    style: {
      textAlign: "center"
    },
    disable: _disable
  }, t("CS_FILE_PROPERTY_WIDTH"))), /*#__PURE__*/React.createElement("span", null, "x"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DimentionInput, {
    name: "height",
    value: _size["height"] || "",
    onChange: handleChange,
    disable: _disable
  }), /*#__PURE__*/React.createElement(CardText, {
    style: {
      textAlign: "center"
    },
    disable: _disable
  }, t("CS_FILE_PROPERTY_HEIGHT"))));
};

const RadioOrSelect = ({
  placeholder,
  options,
  onSelect,
  optionKey,
  multiOptionKey: _multiOptionKey = null,
  selectedOption,
  isMandatory,
  t,
  labelKey,
  dropdownStyle: _dropdownStyle = {},
  isDependent: _isDependent = false,
  disabled: _disabled = false,
  optionCardStyles,
  isPTFlow: _isPTFlow = false,
  isDropDown: _isDropDown = false
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, (options === null || options === void 0 ? void 0 : options.length) < 3 && !_isDropDown ? /*#__PURE__*/React.createElement(RadioButtons, {
    selectedOption: selectedOption,
    options: options,
    optionsKey: optionKey,
    multiOptionKey: _multiOptionKey,
    isDependent: _isDependent,
    disabled: _disabled,
    onSelect: onSelect,
    labelKey: labelKey,
    isPTFlow: _isPTFlow,
    t: t
  }) : /*#__PURE__*/React.createElement(Dropdown, {
    isMandatory: isMandatory,
    selected: selectedOption,
    style: _dropdownStyle,
    optionKey: optionKey,
    multiOptionKey: _multiOptionKey,
    option: options,
    select: onSelect,
    t: t,
    disable: _disabled,
    optionCardStyles: optionCardStyles,
    placeholder: placeholder
  }));
};

const RatingCard = ({
  config,
  onSelect,
  t
}) => {
  var _config$inputs;
  const {
    register,
    watch,
    handleSubmit
  } = useForm();
  const [comments, setComments] = useState("");
  const [rating, setRating] = useState(0);
  const onSubmit = data => {
    data.rating = rating;
    onSelect(data);
  };
  const feedback = (e, ref, index) => {
    setRating(index);
  };
  const segments = (_config$inputs = config.inputs) === null || _config$inputs === void 0 ? void 0 : _config$inputs.map((input, index) => {
    if (input.type === "rate") {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), input === null || input === void 0 ? void 0 : input.error, /*#__PURE__*/React.createElement(Rating, {
        currentRating: rating,
        maxRating: input.maxRating,
        onFeedback: (e, ref, i) => feedback(e, ref, i)
      }));
    }
    if (input.type === "checkbox") {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), input.checkLabels && input.checkLabels.map((label, index) => /*#__PURE__*/React.createElement(CheckBox, {
        style: {
          marginBottom: "16px"
        },
        key: index,
        name: input.label,
        label: t(label),
        value: label,
        inputRef: register
      })));
    }
    if (input.type === "radio") {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), /*#__PURE__*/React.createElement(RadioButtons, {
        options: input.checkLabels,
        onSelect: input.onSelect,
        selectedOption: input.selectedOption,
        t: t
      }));
    }
    if (input.type === "textarea") {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), /*#__PURE__*/React.createElement(TextArea, {
        name: input.name,
        value: comments,
        onChange: e => setComments(e.target.value),
        inputRef: register
      }));
    }
    if (input.type === "dropDown") {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardLabel, null, t(input.label)), /*#__PURE__*/React.createElement(Dropdown, {
        option: input.checkLabels,
        optionKey: "i18nKey",
        id: "dropdown",
        selected: input.selectedOption,
        select: input.onSelect,
        t: t,
        disable: false,
        autoFocus: false
      }));
    }
  });
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, null, t(config.texts.header)), segments, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t(config.texts.submitBarLabel),
    submit: true
  })));
};
RatingCard.propTypes = {
  config: propTypes.object,
  onSubmit: propTypes.func,
  t: propTypes.func
};
RatingCard.defaultProps = {
  config: {},
  onSubmit: undefined,
  t: value => value
};

const TextInputCard = ({
  header,
  subHeader,
  cardText,
  cardLabel,
  nextText,
  skipAndContinueText,
  skip,
  onSave,
  onSkip,
  textInput
}) => {
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardSubHeader, null, subHeader), /*#__PURE__*/React.createElement(CardHeader, null, header), /*#__PURE__*/React.createElement(CardText, null, cardText), /*#__PURE__*/React.createElement(CardLabel, null, cardLabel), /*#__PURE__*/React.createElement(TextInput, {
    onChange: textInput
  }), /*#__PURE__*/React.createElement(SubmitBar, {
    label: nextText,
    onSubmit: onSave
  }), skip ? /*#__PURE__*/React.createElement(LinkButton, {
    label: skipAndContinueText,
    onClick: onSkip
  }) : null);
};
TextInputCard.propTypes = {
  header: propTypes.string,
  subHeader: propTypes.string,
  cardText: propTypes.string,
  cardLabel: propTypes.string,
  nextText: propTypes.string,
  skipAndContinueText: propTypes.string,
  skip: propTypes.bool,
  onSave: propTypes.func,
  onSkip: propTypes.func,
  textInput: propTypes.string
};
TextInputCard.defaultProps = {
  header: "",
  subHeader: "",
  cardText: "",
  cardLabel: "",
  nextText: "",
  skipAndContinueText: "",
  skip: true,
  onSave: undefined,
  onSkip: undefined,
  textInput: ""
};

const TypeSelectCard = ({
  t,
  headerCaption,
  header,
  cardText,
  disabled: _disabled = false,
  submitBarLabel,
  selectedOption,
  menu,
  optionsKey,
  selected,
  onSave
}) => {
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardCaption, null, t(headerCaption)), /*#__PURE__*/React.createElement(CardHeader, null, t(header)), /*#__PURE__*/React.createElement(CardText, null, t(cardText)), menu ? /*#__PURE__*/React.createElement(RadioButtons, {
    selectedOption: selectedOption,
    options: menu,
    optionsKey: optionsKey,
    onSelect: selected
  }) : null, /*#__PURE__*/React.createElement(SubmitBar, {
    disabled: _disabled,
    label: t(submitBarLabel),
    onSubmit: onSave
  }));
};
TypeSelectCard.propTypes = {
  headerCaption: propTypes.string,
  header: propTypes.string,
  cardText: propTypes.string,
  submitBarLabel: propTypes.string,
  selectedOption: propTypes.any,
  menu: propTypes.any,
  optionsKey: propTypes.string,
  selected: propTypes.func,
  onSave: propTypes.func,
  t: propTypes.func
};
TypeSelectCard.defaultProps = {};

const PageBasedInput = ({
  children,
  texts,
  onSubmit
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "PageBasedInputWrapper"
  }, /*#__PURE__*/React.createElement(Card, null, children, /*#__PURE__*/React.createElement(SubmitBar, {
    className: "SubmitBarInCardInDesktopView",
    label: texts.submitBarLabel,
    onSubmit: onSubmit
  })), /*#__PURE__*/React.createElement("div", {
    className: "SubmitBar"
  }, /*#__PURE__*/React.createElement(SubmitBar, {
    label: texts.submitBarLabel,
    onSubmit: onSubmit
  })));
};

const SearchOnRadioButtons = ({
  options,
  optionsKey,
  additionalWrapperClass,
  onSelect,
  selectedOption,
  SignatureImage: _SignatureImage = () => /*#__PURE__*/React.createElement(SearchIconSvg, null),
  onSearchQueryChange,
  SearchQueryValue,
  placeholder
}) => {
  function optionsReducer(state, action) {
    switch (action.type) {
      case "filter":
        return action.options.filter(i => i[optionsKey].toUpperCase().includes(action.payload.toUpperCase()));
    }
  }
  const [filteredOptions, optionsDispatch] = useReducer(optionsReducer, options);
  function defaultSearchQueryChange(e) {
    optionsDispatch({
      type: "filter",
      payload: e.target.value,
      options
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "SearchOnRadioButton"
  }, /*#__PURE__*/React.createElement(TextInput, {
    signature: true,
    signatureImg: /*#__PURE__*/React.createElement(_SignatureImage, null),
    onChange: onSearchQueryChange || defaultSearchQueryChange,
    value: SearchQueryValue,
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement(RadioButtons, {
    options: filteredOptions,
    optionsKey,
    additionalWrapperClass,
    onSelect,
    selectedOption
  }));
};

const OnGroundEventCard = ({
  onClick: _onClick = () => null,
  name,
  id,
  eventDetails,
  onGroundEventMonth: _onGroundEventMonth = "MAR",
  onGroundEventDate: _onGroundEventDate = "12 - 16",
  onGroundEventName: _onGroundEventName = "To the moon",
  onGroundEventLocation: _onGroundEventLocation = "Moon",
  onGroundEventTimeRange: _onGroundEventTimeRange = "10:00 am - 1:00 pm",
  eventCategory,
  showEventCatergory
}) => {
  const onEventCardClick = () => _onClick(id);
  return /*#__PURE__*/React.createElement("div", {
    className: "OnGroundEventCard",
    onClick: onEventCardClick
  }, /*#__PURE__*/React.createElement(EventCalendarView, {
    onGroundEventMonth: _onGroundEventMonth,
    onGroundEventDate: _onGroundEventDate
  }), /*#__PURE__*/React.createElement("div", {
    className: "EventDetails"
  }, /*#__PURE__*/React.createElement("h2", null, name), !showEventCatergory ? /*#__PURE__*/React.createElement("div", {
    className: "EventLocation"
  }, /*#__PURE__*/React.createElement(MapMarker, null), /*#__PURE__*/React.createElement("p", null, eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.address)) : null, !showEventCatergory ? /*#__PURE__*/React.createElement("div", {
    className: "EventTime"
  }, /*#__PURE__*/React.createElement(Clock, null), /*#__PURE__*/React.createElement("p", null, _onGroundEventTimeRange)) : null, showEventCatergory ? /*#__PURE__*/React.createElement("div", {
    className: "EventCategory"
  }, /*#__PURE__*/React.createElement("p", null, eventCategory)) : null));
};

const displayError = ({
  t,
  error,
  name
}) => /*#__PURE__*/React.createElement("span", {
  style: {
    display: 'flex',
    flexDirection: 'column'
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "validation-error"
}, t(error)), /*#__PURE__*/React.createElement("div", {
  className: "validation-error"
}, `${t('ES_COMMON_DOC_FILENAME')} : ${name} ...`));
const fileValidationStatus = (file, regex, maxSize, t) => {
  var _file$name;
  const status = {
    valid: true,
    name: file === null || file === void 0 ? void 0 : (_file$name = file.name) === null || _file$name === void 0 ? void 0 : _file$name.substring(0, 15),
    error: ''
  };
  if (!file) return;
  if (!regex.test(file.type) && file.size / 1024 / 1024 > maxSize) {
    status.valid = false;
    status.error = t(`NOT_SUPPORTED_FILE_TYPE_AND_FILE_SIZE_EXCEEDED`);
  }
  if (!regex.test(file.type)) {
    status.valid = false;
    status.error = t(`NOT_SUPPORTED_FILE_TYPE`);
  }
  if (file.size / 1024 / 1024 > maxSize) {
    status.valid = false;
    status.error = t(`FILE_SIZE_EXCEEDED`);
  }
  return status;
};
const checkIfAllValidFiles = (files, regex, maxSize, t) => {
  if (!files.length || !regex || !maxSize) return [{}, false];
  const messages = [];
  let isInValidGroup = false;
  for (let file of files) {
    const fileStatus = fileValidationStatus(file, regex, maxSize, t);
    if (!fileStatus.valid) {
      isInValidGroup = true;
    }
    messages.push(fileStatus);
  }
  return [messages, isInValidGroup];
};
const MultiUploadWrapper = ({
  t,
  module: _module = "PGR",
  tenantId: _tenantId = Digit.ULBService.getStateId(),
  getFormState,
  requestSpecifcFileRemoval,
  extraStyleName: _extraStyleName = "",
  setuploadedstate: _setuploadedstate = [],
  showHintBelow,
  hintText,
  allowedFileTypesRegex: _allowedFileTypesRegex = /(.*?)(jpg|jpeg|webp|aif|png|image|pdf|msword|openxmlformats-officedocument)$/i,
  allowedMaxSizeInMB: _allowedMaxSizeInMB = 10,
  acceptFiles: _acceptFiles = "image/*, .jpg, .jpeg, .webp, .aif, .png, .image, .pdf, .msword, .openxmlformats-officedocument, .dxf"
}) => {
  const FILES_UPLOADED = "FILES_UPLOADED";
  const TARGET_FILE_REMOVAL = "TARGET_FILE_REMOVAL";
  const [fileErrors, setFileErrors] = useState([]);
  const uploadMultipleFiles = (state, payload) => {
    const {
      files,
      fileStoreIds
    } = payload;
    const filesData = Array.from(files);
    const newUploads = filesData === null || filesData === void 0 ? void 0 : filesData.map((file, index) => [file.name, {
      file,
      fileStoreId: fileStoreIds[index]
    }]);
    return [...state, ...newUploads];
  };
  const removeFile = (state, payload) => {
    const __indexOfItemToDelete = state.findIndex(e => e[0] === payload.file.name);
    const mutatedState = state.filter((e, index) => index !== __indexOfItemToDelete);
    return [...mutatedState];
  };
  const uploadReducer = (state, action) => {
    switch (action.type) {
      case FILES_UPLOADED:
        return uploadMultipleFiles(state, action.payload);
      case TARGET_FILE_REMOVAL:
        return removeFile(state, action.payload);
    }
  };
  const onUploadMultipleFiles = async e => {
    setFileErrors([]);
    const files = Array.from(e.target.files);
    if (!files.length) return;
    const [validationMsg, error] = checkIfAllValidFiles(files, _allowedFileTypesRegex, _allowedMaxSizeInMB, t);
    if (!error) {
      try {
        const {
          data: {
            files: fileStoreIds
          } = {}
        } = await Digit.UploadServices.MultipleFilesStorage(_module, e.target.files, _tenantId);
        return dispatch({
          type: FILES_UPLOADED,
          payload: {
            files: e.target.files,
            fileStoreIds
          }
        });
      } catch (err) {}
    } else {
      setFileErrors(validationMsg);
    }
  };
  const [state, dispatch] = useReducer(uploadReducer, [..._setuploadedstate]);
  useEffect(() => getFormState(state), [state]);
  useEffect(() => {
    requestSpecifcFileRemoval ? dispatch({
      type: TARGET_FILE_REMOVAL,
      payload: requestSpecifcFileRemoval
    }) : null;
  }, [requestSpecifcFileRemoval]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UploadFile, {
    onUpload: e => onUploadMultipleFiles(e),
    removeTargetedFile: fileDetailsData => dispatch({
      type: TARGET_FILE_REMOVAL,
      payload: fileDetailsData
    }),
    uploadedFiles: state,
    multiple: true,
    showHintBelow: showHintBelow,
    hintText: hintText,
    extraStyleName: _extraStyleName,
    onDelete: () => {
      setFileErrors([]);
    },
    accept: _acceptFiles
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex'
    }
  }, fileErrors.length ? fileErrors.map(({
    valid,
    name,
    type,
    size,
    error
  }) => valid ? null : displayError({
    t,
    error,
    name
  })) : null));
};

const OpenLinkContainer = ({
  img
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "navbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "center-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "city",
    id: "topbar-logo",
    crossOrigin: "anonymous",
    src: "https://in-egov-assets.s3.ap-south-1.amazonaws.com/images/Upyog-logo.png",
    alt: "mSeva"
  })));
};
OpenLinkContainer.propTypes = {
  img: propTypes.string
};
OpenLinkContainer.defaultProps = {
  img: undefined
};

const UploadPitPhoto = props => {
  const {
    t
  } = useTranslation();
  const [image, setImage] = useState(null);
  const [uploadedImagesThumbs, setUploadedImagesThumbs] = useState(null);
  const [uploadedImagesIds, setUploadedImagesIds] = useState(props.uploadedImages);
  const [rerender, setRerender] = useState(1);
  const [imageFile, setImageFile] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (image) {
      uploadImage();
    }
  }, [image]);
  useEffect(() => {
    (async () => {
      if (uploadedImagesIds !== null) {
        await submit();
        setRerender(rerender + 1);
        props.onPhotoChange(uploadedImagesIds);
      }
    })();
  }, [uploadedImagesIds]);
  useEffect(() => {
    if (imageFile && imageFile.size > 2097152) {
      setError("File is too large");
    } else {
      setImage(imageFile);
    }
  }, [imageFile]);
  const addUploadedImageIds = useCallback(imageIdData => {
    if (uploadedImagesIds === null) {
      var arr = [];
    } else {
      arr = uploadedImagesIds;
    }
    return [...arr, imageIdData.data.files[0].fileStoreId];
  }, [uploadedImagesIds]);
  function getImage(e) {
    setError(null);
    setImageFile(e.target.files[0]);
  }
  const uploadImage = useCallback(async () => {
    if (uploadedImagesIds === null || uploadedImagesIds.length < 3) {
      const response = await Digit.UploadServices.Filestorage("FSM", image, props.tenantId);
      setUploadedImagesIds(addUploadedImageIds(response));
    }
  }, [addUploadedImageIds, image]);
  function addImageThumbnails(thumbnailsData) {
    var keys = Object.keys(thumbnailsData.data);
    var index = keys.findIndex(key => key === "fileStoreIds");
    if (index > -1) {
      keys.splice(index, 1);
    }
    var thumbnails = [];
    const newThumbnails = keys.map(key => {
      return {
        image: thumbnailsData.data[key].split(",")[2],
        key
      };
    });
    setUploadedImagesThumbs([...thumbnails, ...newThumbnails]);
  }
  const submit = useCallback(async () => {
    if (uploadedImagesIds !== null && uploadedImagesIds.length > 0) {
      const res = await Digit.UploadServices.Filefetch(uploadedImagesIds, props.tenantId);
      addImageThumbnails(res);
    }
  }, [uploadedImagesIds]);
  function deleteImage(img) {
    setIsDeleting(true);
    var deleteImageKey = uploadedImagesThumbs.filter((o, index) => o.image === img);
    var uploadedthumbs = uploadedImagesThumbs;
    var newThumbsList = uploadedthumbs.filter(thumbs => thumbs != deleteImageKey[0]);
    var newUploadedImagesIds = uploadedImagesIds.filter(key => key !== deleteImageKey[0].key);
    setUploadedImagesThumbs(newThumbsList);
    setUploadedImagesIds(newUploadedImagesIds);
    Digit.SessionStorage.set("PGR_CREATE_IMAGES", newUploadedImagesIds);
  }
  const handleUpload = event => {
    if (uploadedImagesIds === null || uploadedImagesIds.length < 3) {
      hiddenFileInput.current.click();
    }
  };
  const hiddenFileInput = React.useRef(null);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "imageUploadWrapper",
    style: {
      display: !imageFile ? "none" : "block",
      marginTop: "8px"
    }
  }, /*#__PURE__*/React.createElement(UploadImages, {
    onUpload: getImage,
    onDelete: deleteImage,
    thumbnails: uploadedImagesThumbs ? uploadedImagesThumbs.map(o => o.image) : []
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleUpload,
    style: {
      width: "100%",
      backgroundColor: "#d6d5d4",
      borderStyle: "solid",
      borderBottom: "1px solid #464646",
      padding: "4px 40px",
      margin: "8px 0px",
      cursor: "pointer",
      outline: "none",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("input", {
    style: {
      display: "none"
    },
    type: "file",
    ref: hiddenFileInput,
    onChange: getImage
  }), /*#__PURE__*/React.createElement("p", null, t("UPLOAD_PIT_PHOTO"))), error && /*#__PURE__*/React.createElement(Toast, {
    error: true,
    label: error,
    onClose: () => setError(null)
  }));
};

const ULBHomeCard = props => {
  const {
    t
  } = useTranslation();
  const state = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: "fsm",
    style: {
      backgroundColor: "transparent",
      boxShadow: "none",
      paddingTop: "0"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, null, " ", t(props.title), " "), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "30% 30% 30%",
      textAlign: "-webkit-center",
      justifyContent: "space-between"
    }
  }, props.module.map(i => {
    return /*#__PURE__*/React.createElement(Card, {
      style: {
        minWidth: "100px",
        cursor: "pointer"
      },
      onClick: () => i.link ? history.push(i.link) : location.assign(i.locate),
      children: /*#__PURE__*/React.createElement(Fragment$1, null, " ", i.icon, " ", /*#__PURE__*/React.createElement("p", null, " ", t(i.name), " "), " ")
    });
  }))));
};

export { ActionBar, ActionLinks, AddIcon, AddNewIcon, AnnouncementIcon, AppContainer, ApplyFilterBar, ArrowDown, ArrowForward, ArrowLeft, ArrowRightInbox, AutoLogoutWarning, BPAHomeIcon, BPAIcon, BackButton$1 as BackButton, Banner, Body, Breadcrumb as BreadCrumb, BreakLine, ButtonSelector, Calender, CameraIcon, Card, CardBasedFormsOptions, CardBasedOptions, CardCaption, CardHeader, CardLabel, CardLabelDesc, CardLabelError, CardSectionHeader, CardSubHeader, CardText, CardText$1 as CardTextButton, CaseIcon, CheckBox, CheckPoint, CheckSvg, CitizenHomeCard, CitizenInfoLabel, CitizenOBPSCard, CitizenOBPSHomeCard, CitizenTruck, CityMohalla, Clock, Close, CloseSvg, ComplaintIcon, ConnectingCheckPoints, CustomButton, DashboardBox, DatePicker, DateRange, DateWrap, DeleteIcon, Details, DetailsCard, DisplayPhotos, DocumentIcon, DocumentIconSolid, DocumentSVG, DownloadIcon, DownloadImgIcon, DownloadPrefixIcon, DownwardArrow, DropIcon, Dropdown, DustbinIcon, EDCRIcon, EditIcon, EditPencilIcon, Ellipsis, EllipsisMenu, EmailIcon, EmployeeAppContainer, EmployeeModuleCard, EmployeeOBPSModuleCard, ErrorIcon, EventCalendar, EventCalendarView, EventsIconSolid, ExternalLinkIcon, FilterAction, FilterForm, FilterFormField, FilterIcon, FilterSvg, FormComposer, FormStep, GalleryIcon, GenericFileIcon, GetApp, GreyOutText, Hamburger, Header, HeaderBar, HelpIcon, HomeIcon, HomeLink, ImageIcon, ImageUploadHandler, ImageViewer, InboxComposer, InboxIcon, InboxLinks, InfoBanner, InfoBannerIcon, InputCard, KeyNote, Label, LabelFieldPair, LanguageIcon, LastRow, LinkButton, LinkLabel, Loader, Localities, LocationSearch, LocationSearchCard, LogoutIcon, MapMarker, MediaRow, Menu$1 as Menu, MobileNumber, Modal, ModuleCardFullWidth, MultiLink, MultiSelectDropdown, MultiUploadWrapper, NavBar, NotificationBell, OBPSIcon, OBPSIconSolidBg, OTPInput, OnGroundEventCard, OpenLinkContainer, PDFSvg, PMBIcon, PMBIconSolid, PTIcon, PageBasedInput, Person, PersonIcon, Phone, PitDimension, Poll, PopUp, PopupHeadingLabel, PrevIcon, PrintIcon, PrivateRoute, PropertyHouse, RadioButtons, RadioOrSelect, Rating, RatingCard, ReceiptIcon, RefreshIcon, RefreshSVG, RemoveIcon, RemoveableTag, ResponseComposer, RoundedLabel, Row, RupeeIcon, SearchAction, SearchField, SearchForm, SearchIcon, SearchIconSvg, SearchOnRadioButtons, SectionalDropdown, ShareIcon, ShippingTruck, SortAction, SortDown, SortSvg, SortUp, StandaloneSearchBar, StatusTable, SubmitBar, SurveyIconSolid, Table, TelePhone, TextArea, TextInput, TextInputCard, TickMark, Toast$1 as Toast, TopBar, TypeSelectCard, ULBHomeCard, UploadFile, UploadImages, UploadPitPhoto, UpwardArrow, ViewReportIcon, ViewsIcon, WSICon, WhatsNewCard, WhatsappIcon };
//# sourceMappingURL=index.modern.js.map
